// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studiomediamatrix/v1/types.proto (package creativefabrica.studiomediamatrix.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studiomediamatrix/v1/types.proto.
 */
export const file_creativefabrica_studiomediamatrix_v1_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Session
 */
export type Session = Message<"creativefabrica.studiomediamatrix.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionStatus status = 3;
   */
  status: SessionStatus;

  /**
   * @generated from field: uint32 total_item_count = 4;
   */
  totalItemCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * @generated from field: string thumbnail_url = 8 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 9;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.Session.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 10;
     */
    value: PromptContent;
    case: "promptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 11;
     */
    value: ImageContent;
    case: "imageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 12;
     */
    value: PromptWithImagesContent;
    case: "promptWithImagesContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent prompt_music_generator_content = 13;
     */
    value: PromptMusicGeneratorContent;
    case: "promptMusicGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 15;
     */
    value: PromptSoundGeneratorContent;
    case: "soundGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 16;
     */
    value: PromptSpeechGeneratorContent;
    case: "speechGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 17;
     */
    value: CollageMakerContent;
    case: "collageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SourceFromImageContent source_from_image_content = 18;
     */
    value: SourceFromImageContent;
    case: "sourceFromImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 19;
     */
    value: TextCADContent;
    case: "textCadContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetContent doodle_pet_content = 20;
     */
    value: DoodlePetContent;
    case: "doodlePetContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent coloring_page_maker_content = 22;
     */
    value: ColoringPageMakerContent;
    case: "coloringPageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent prompt_to_video_generator_content = 23;
     */
    value: PromptToVideoGeneratorContent;
    case: "promptToVideoGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteContent wedding_invite_content = 24;
     */
    value: WeddingInviteContent;
    case: "weddingInviteContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.EtsyCoachContent etsy_coach_content = 25;
     */
    value: EtsyCoachContent;
    case: "etsyCoachContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent ai_photo_style_content = 26;
     */
    value: AIPhotoStyleContent;
    case: "aiPhotoStyleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyContent toon_family_content = 27;
     */
    value: ToonFamilyContent;
    case: "toonFamilyContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorContent logo_generator_content = 30;
     */
    value: LogoGeneratorContent;
    case: "logoGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerContent video_upscaler_content = 31;
     */
    value: VideoUpscalerContent;
    case: "videoUpscalerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent ai_mockup_generator_content = 32;
     */
    value: AIMockupGeneratorContent;
    case: "aiMockupGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 33;
     */
    value: CameraAngleContent;
    case: "cameraAngleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 34;
     */
    value: MarketplaceEditorContent;
    case: "marketplaceEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 35;
     */
    value: AISVGGeneratorContent;
    case: "aiSvgGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SplatContent splat_content = 36;
     */
    value: SplatContent;
    case: "splatContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoCutoutsContent video_cutouts_content = 38;
     */
    value: VideoCutoutsContent;
    case: "videoCutoutsContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent prompt_music_lyrics_structured_content = 39;
     */
    value: PromptMusicLyricsStructuredContent;
    case: "promptMusicLyricsStructuredContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoTemplateContent video_template_content = 40;
     */
    value: VideoTemplateContent;
    case: "videoTemplateContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 41;
     */
    value: VideoEditorContent;
    case: "videoEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent youtube_thumbnail_generator_content = 44;
     */
    value: YouTubeThumbnailGeneratorContent;
    case: "youtubeThumbnailGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 45;
     */
    value: InpaintContent;
    case: "inpaintContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AdBannerResizerContent ad_banner_resizer_content = 47;
     */
    value: AdBannerResizerContent;
    case: "adBannerResizerContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 14;
   */
  visibility: SessionVisibility;

  /**
   * Server-maintained key/value metadata. Known keys:
   *   cf_video_upscaler_session_id — on SERVICE_TYPE_VIDEO_DRAFT sessions, the
   *   SERVICE_TYPE_VIDEO_UPSCALER session the draft was last upscaled in
   *   (set via UpdateSessionRequest.metadata).
   *
   * @generated from field: map<string, string> metadata = 21;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant thumbnail_urls = 28;
   */
  thumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string name = 29;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 37;
   */
  deletedAt?: Timestamp | undefined;

  /**
   * @generated from field: string preview_media_url = 42;
   */
  previewMediaUrl: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Source source = 43;
   */
  source: Source;

  /**
   * @generated from field: string team_id = 46;
   */
  teamId: string;

  /**
   * Badge-only (idea.ai corner badge) copy of preview_media_url, set when the
   * session's creator was not a paid subscriber at generation time.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copy is served in preview_media_url instead to viewers that are
   * not paid subscribers.
   *
   * @generated from field: string watermarked_preview_media_url = 48;
   */
  watermarkedPreviewMediaUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Session
 */
export type SessionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionStatus status = 3;
   */
  status?: SessionStatusJson;

  /**
   * @generated from field: uint32 total_item_count = 4;
   */
  totalItemCount?: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: TimestampJson;

  /**
   * @generated from field: string thumbnail_url = 8 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 9;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 10;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 11;
   */
  imageContent?: ImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 12;
   */
  promptWithImagesContent?: PromptWithImagesContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent prompt_music_generator_content = 13;
   */
  promptMusicGeneratorContent?: PromptMusicGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 15;
   */
  soundGeneratorContent?: PromptSoundGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 16;
   */
  speechGeneratorContent?: PromptSpeechGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 17;
   */
  collageMakerContent?: CollageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SourceFromImageContent source_from_image_content = 18;
   */
  sourceFromImageContent?: SourceFromImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 19;
   */
  textCadContent?: TextCADContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetContent doodle_pet_content = 20;
   */
  doodlePetContent?: DoodlePetContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent coloring_page_maker_content = 22;
   */
  coloringPageMakerContent?: ColoringPageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent prompt_to_video_generator_content = 23;
   */
  promptToVideoGeneratorContent?: PromptToVideoGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteContent wedding_invite_content = 24;
   */
  weddingInviteContent?: WeddingInviteContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.EtsyCoachContent etsy_coach_content = 25;
   */
  etsyCoachContent?: EtsyCoachContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent ai_photo_style_content = 26;
   */
  aiPhotoStyleContent?: AIPhotoStyleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyContent toon_family_content = 27;
   */
  toonFamilyContent?: ToonFamilyContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorContent logo_generator_content = 30;
   */
  logoGeneratorContent?: LogoGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerContent video_upscaler_content = 31;
   */
  videoUpscalerContent?: VideoUpscalerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent ai_mockup_generator_content = 32;
   */
  aiMockupGeneratorContent?: AIMockupGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 33;
   */
  cameraAngleContent?: CameraAngleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 34;
   */
  marketplaceEditorContent?: MarketplaceEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 35;
   */
  aiSvgGeneratorContent?: AISVGGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatContent splat_content = 36;
   */
  splatContent?: SplatContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoCutoutsContent video_cutouts_content = 38;
   */
  videoCutoutsContent?: VideoCutoutsContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent prompt_music_lyrics_structured_content = 39;
   */
  promptMusicLyricsStructuredContent?: PromptMusicLyricsStructuredContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoTemplateContent video_template_content = 40;
   */
  videoTemplateContent?: VideoTemplateContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 41;
   */
  videoEditorContent?: VideoEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent youtube_thumbnail_generator_content = 44;
   */
  youtubeThumbnailGeneratorContent?: YouTubeThumbnailGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 45;
   */
  inpaintContent?: InpaintContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AdBannerResizerContent ad_banner_resizer_content = 47;
   */
  adBannerResizerContent?: AdBannerResizerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 14;
   */
  visibility?: SessionVisibilityJson;

  /**
   * Server-maintained key/value metadata. Known keys:
   *   cf_video_upscaler_session_id — on SERVICE_TYPE_VIDEO_DRAFT sessions, the
   *   SERVICE_TYPE_VIDEO_UPSCALER session the draft was last upscaled in
   *   (set via UpdateSessionRequest.metadata).
   *
   * @generated from field: map<string, string> metadata = 21;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant thumbnail_urls = 28;
   */
  thumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string name = 29;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 37;
   */
  deletedAt?: TimestampJson;

  /**
   * @generated from field: string preview_media_url = 42;
   */
  previewMediaUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Source source = 43;
   */
  source?: SourceJson;

  /**
   * @generated from field: string team_id = 46;
   */
  teamId?: string;

  /**
   * Badge-only (idea.ai corner badge) copy of preview_media_url, set when the
   * session's creator was not a paid subscriber at generation time.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copy is served in preview_media_url instead to viewers that are
   * not paid subscribers.
   *
   * @generated from field: string watermarked_preview_media_url = 48;
   */
  watermarkedPreviewMediaUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session, {jsonType: SessionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SourceFromImageContent
 */
export type SourceFromImageContent = Message<"creativefabrica.studiomediamatrix.v1.SourceFromImageContent"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SourceFromImageContent
 */
export type SourceFromImageContentJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SourceFromImageContent.
 * Use `create(SourceFromImageContentSchema)` to create a new message.
 */
export const SourceFromImageContentSchema: GenMessage<SourceFromImageContent, {jsonType: SourceFromImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 1);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CollageMakerContent
 */
export type CollageMakerContent = Message<"creativefabrica.studiomediamatrix.v1.CollageMakerContent"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls: GeneratedImageURL[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle style = 2;
   */
  style: CollageMakerContentStyle;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CollageMakerContent
 */
export type CollageMakerContentJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls?: GeneratedImageURLJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle style = 2;
   */
  style?: CollageMakerContentStyleJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CollageMakerContent.
 * Use `create(CollageMakerContentSchema)` to create a new message.
 */
export const CollageMakerContentSchema: GenMessage<CollageMakerContent, {jsonType: CollageMakerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 2);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DoodlePetContent
 */
export type DoodlePetContent = Message<"creativefabrica.studiomediamatrix.v1.DoodlePetContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetVibe vibe = 1;
   */
  vibe: DoodlePetVibe;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DoodlePetContent
 */
export type DoodlePetContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetVibe vibe = 1;
   */
  vibe?: DoodlePetVibeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURLJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DoodlePetContent.
 * Use `create(DoodlePetContentSchema)` to create a new message.
 */
export const DoodlePetContentSchema: GenMessage<DoodlePetContent, {jsonType: DoodlePetContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 3);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent
 */
export type ColoringPageMakerContent = Message<"creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageType coloring_type = 1;
   */
  coloringType: ColoringPageType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent
 */
export type ColoringPageMakerContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageType coloring_type = 1;
   */
  coloringType?: ColoringPageTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURLJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent.
 * Use `create(ColoringPageMakerContentSchema)` to create a new message.
 */
export const ColoringPageMakerContentSchema: GenMessage<ColoringPageMakerContent, {jsonType: ColoringPageMakerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 4);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.WeddingInviteContent
 */
export type WeddingInviteContent = Message<"creativefabrica.studiomediamatrix.v1.WeddingInviteContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteTheme theme = 1;
   */
  theme: WeddingInviteTheme;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteDetails details = 2;
   */
  details?: WeddingInviteDetails | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 3;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.WeddingInviteContent
 */
export type WeddingInviteContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteTheme theme = 1;
   */
  theme?: WeddingInviteThemeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteDetails details = 2;
   */
  details?: WeddingInviteDetailsJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 3;
   */
  generatedImageUrl?: GeneratedImageURLJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.WeddingInviteContent.
 * Use `create(WeddingInviteContentSchema)` to create a new message.
 */
export const WeddingInviteContentSchema: GenMessage<WeddingInviteContent, {jsonType: WeddingInviteContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 5);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EtsyCoachContent
 */
export type EtsyCoachContent = Message<"creativefabrica.studiomediamatrix.v1.EtsyCoachContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EtsyCoachContent
 */
export type EtsyCoachContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.EtsyCoachContent.
 * Use `create(EtsyCoachContentSchema)` to create a new message.
 */
export const EtsyCoachContentSchema: GenMessage<EtsyCoachContent, {jsonType: EtsyCoachContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 6);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TextCADContent
 */
export type TextCADContent = Message<"creativefabrica.studiomediamatrix.v1.TextCADContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType model_type = 2;
   */
  modelType: ModelThreeDGeneratorOpenSCADModelType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TextCADContent
 */
export type TextCADContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType model_type = 2;
   */
  modelType?: ModelThreeDGeneratorOpenSCADModelTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.TextCADContent.
 * Use `create(TextCADContentSchema)` to create a new message.
 */
export const TextCADContentSchema: GenMessage<TextCADContent, {jsonType: TextCADContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 7);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent
 */
export type AIPhotoStyleContent = Message<"creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent"> & {
  /**
   * @generated from field: string ai_photo_style_id = 1;
   */
  aiPhotoStyleId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent
 */
export type AIPhotoStyleContentJson = {
  /**
   * @generated from field: string ai_photo_style_id = 1;
   */
  aiPhotoStyleId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent.
 * Use `create(AIPhotoStyleContentSchema)` to create a new message.
 */
export const AIPhotoStyleContentSchema: GenMessage<AIPhotoStyleContent, {jsonType: AIPhotoStyleContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 8);

/**
 * YouTubeThumbnailGeneratorContent is the persisted input shape for a
 * thumbnail generation. Outputs are exposed through Session.images, which is
 * already repeated and can grow beyond one image without another schema change.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent
 */
export type YouTubeThumbnailGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: string template_id = 3;
   */
  templateId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 4;
   */
  referenceImages: GeneratedImageURL[];

  /**
   * @generated from field: uint32 output_image_count = 5;
   */
  outputImageCount: number;
};

/**
 * YouTubeThumbnailGeneratorContent is the persisted input shape for a
 * thumbnail generation. Outputs are exposed through Session.images, which is
 * already repeated and can grow beyond one image without another schema change.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent
 */
export type YouTubeThumbnailGeneratorContentJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt?: string;

  /**
   * @generated from field: string template_id = 3;
   */
  templateId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 4;
   */
  referenceImages?: GeneratedImageURLJson[];

  /**
   * @generated from field: uint32 output_image_count = 5;
   */
  outputImageCount?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent.
 * Use `create(YouTubeThumbnailGeneratorContentSchema)` to create a new message.
 */
export const YouTubeThumbnailGeneratorContentSchema: GenMessage<YouTubeThumbnailGeneratorContent, {jsonType: YouTubeThumbnailGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 9);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent
 */
export type AIMockupGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent
 */
export type AIMockupGeneratorContentJson = {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorContent.
 * Use `create(AIMockupGeneratorContentSchema)` to create a new message.
 */
export const AIMockupGeneratorContentSchema: GenMessage<AIMockupGeneratorContent, {jsonType: AIMockupGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 10);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoTemplateContent
 */
export type VideoTemplateContent = Message<"creativefabrica.studiomediamatrix.v1.VideoTemplateContent"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL image_upload = 2;
   */
  imageUpload: GeneratedImageURL[];

  /**
   * @generated from field: uint32 duration = 3;
   */
  duration: number;

  /**
   * @generated from field: string resolution = 4;
   */
  resolution: string;

  /**
   * @generated from field: string aspect_ratio = 5;
   */
  aspectRatio: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 6;
   */
  model: VideoGeneratorModel;

  /**
   * @generated from field: string prompt = 7;
   */
  prompt: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoTemplateContent
 */
export type VideoTemplateContentJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL image_upload = 2;
   */
  imageUpload?: GeneratedImageURLJson[];

  /**
   * @generated from field: uint32 duration = 3;
   */
  duration?: number;

  /**
   * @generated from field: string resolution = 4;
   */
  resolution?: string;

  /**
   * @generated from field: string aspect_ratio = 5;
   */
  aspectRatio?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 6;
   */
  model?: VideoGeneratorModelJson;

  /**
   * @generated from field: string prompt = 7;
   */
  prompt?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoTemplateContent.
 * Use `create(VideoTemplateContentSchema)` to create a new message.
 */
export const VideoTemplateContentSchema: GenMessage<VideoTemplateContent, {jsonType: VideoTemplateContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 11);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Download
 */
export type Download = Message<"creativefabrica.studiomediamatrix.v1.Download"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DownloadStatus status = 3;
   */
  status: DownloadStatus;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Download
 */
export type DownloadJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DownloadStatus status = 3;
   */
  status?: DownloadStatusJson;

  /**
   * @generated from field: string url = 4;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Download.
 * Use `create(DownloadSchema)` to create a new message.
 */
export const DownloadSchema: GenMessage<Download, {jsonType: DownloadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 12);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ShareLink
 */
export type ShareLink = Message<"creativefabrica.studiomediamatrix.v1.ShareLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ShareActionType share_action_type = 4;
   */
  shareActionType: ShareActionType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ShareLink
 */
export type ShareLinkJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ShareActionType share_action_type = 4;
   */
  shareActionType?: ShareActionTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ShareLink.
 * Use `create(ShareLinkSchema)` to create a new message.
 */
export const ShareLinkSchema: GenMessage<ShareLink, {jsonType: ShareLinkJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 13);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Image
 */
export type Image = Message<"creativefabrica.studiomediamatrix.v1.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: string thumbnail_url = 6 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageStatus status = 7;
   */
  status: ImageStatus;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId: string;

  /**
   * @generated from field: string response_preview_url = 12;
   */
  responsePreviewUrl: string;

  /**
   * @generated from field: string original_preview_url = 13;
   */
  originalPreviewUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */
  deletedAt?: Timestamp | undefined;

  /**
   * @generated from field: optional string iteration_id = 16;
   */
  iterationId?: string | undefined;

  /**
   * @generated from field: optional bool sharing_marked_nsfw = 17;
   */
  sharingMarkedNsfw?: boolean | undefined;

  /**
   * @generated from field: int64 ai_generated_image_width = 18;
   */
  aiGeneratedImageWidth: bigint;

  /**
   * @generated from field: int64 ai_generated_image_height = 19;
   */
  aiGeneratedImageHeight: bigint;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant thumbnail_urls = 20;
   */
  thumbnailUrls: ThumbnailVariant[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Image
 */
export type ImageJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl?: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl?: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName?: string;

  /**
   * @generated from field: string thumbnail_url = 6 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageStatus status = 7;
   */
  status?: ImageStatusJson;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: TimestampJson;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId?: string;

  /**
   * @generated from field: string response_preview_url = 12;
   */
  responsePreviewUrl?: string;

  /**
   * @generated from field: string original_preview_url = 13;
   */
  originalPreviewUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */
  deletedAt?: TimestampJson;

  /**
   * @generated from field: optional string iteration_id = 16;
   */
  iterationId?: string;

  /**
   * @generated from field: optional bool sharing_marked_nsfw = 17;
   */
  sharingMarkedNsfw?: boolean;

  /**
   * @generated from field: int64 ai_generated_image_width = 18;
   */
  aiGeneratedImageWidth?: string;

  /**
   * @generated from field: int64 ai_generated_image_height = 19;
   */
  aiGeneratedImageHeight?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant thumbnail_urls = 20;
   */
  thumbnailUrls?: ThumbnailVariantJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, {jsonType: ImageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 14);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Iteration
 */
export type Iteration = Message<"creativefabrica.studiomediamatrix.v1.Iteration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 3;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: string session_id = 4;
   */
  sessionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 6;
   */
  deletedAt?: Timestamp | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 7;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.Iteration.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 8;
     */
    value: PromptContent;
    case: "promptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 9;
     */
    value: ImageContent;
    case: "imageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 11;
     */
    value: PromptWithImagesContent;
    case: "promptWithImagesContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent ai_music_generator_content = 12;
     */
    value: PromptMusicGeneratorContent;
    case: "aiMusicGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 13;
     */
    value: PromptSoundGeneratorContent;
    case: "soundGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 14;
     */
    value: PromptSpeechGeneratorContent;
    case: "speechGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 15;
     */
    value: CollageMakerContent;
    case: "collageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 16;
     */
    value: TextCADContent;
    case: "textCadContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType predefined_action = 17;
     */
    value: ActionType;
    case: "predefinedAction";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 18;
     */
    value: CameraAngleContent;
    case: "cameraAngleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 19;
     */
    value: MarketplaceEditorContent;
    case: "marketplaceEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 20;
     */
    value: AISVGGeneratorContent;
    case: "aiSvgGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoCutoutsContent video_cutouts_content = 21;
     */
    value: VideoCutoutsContent;
    case: "videoCutoutsContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent prompt_music_lyrics_structured_content = 22;
     */
    value: PromptMusicLyricsStructuredContent;
    case: "promptMusicLyricsStructuredContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 23;
     */
    value: VideoEditorContent;
    case: "videoEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 25;
     */
    value: InpaintContent;
    case: "inpaintContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageContent imported_image_content = 26;
     */
    value: ImportedImageContent;
    case: "importedImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AdBannerResizerContent ad_banner_resizer_content = 27;
     */
    value: AdBannerResizerContent;
    case: "adBannerResizerContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 10;
   */
  images: Image[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem media_items = 24;
   */
  mediaItems: MediaItem[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Iteration
 */
export type IterationJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 3;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: string session_id = 4;
   */
  sessionId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 6;
   */
  deletedAt?: TimestampJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 7;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 8;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 9;
   */
  imageContent?: ImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 11;
   */
  promptWithImagesContent?: PromptWithImagesContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent ai_music_generator_content = 12;
   */
  aiMusicGeneratorContent?: PromptMusicGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 13;
   */
  soundGeneratorContent?: PromptSoundGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 14;
   */
  speechGeneratorContent?: PromptSpeechGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 15;
   */
  collageMakerContent?: CollageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 16;
   */
  textCadContent?: TextCADContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType predefined_action = 17;
   */
  predefinedAction?: ActionTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 18;
   */
  cameraAngleContent?: CameraAngleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 19;
   */
  marketplaceEditorContent?: MarketplaceEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 20;
   */
  aiSvgGeneratorContent?: AISVGGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoCutoutsContent video_cutouts_content = 21;
   */
  videoCutoutsContent?: VideoCutoutsContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent prompt_music_lyrics_structured_content = 22;
   */
  promptMusicLyricsStructuredContent?: PromptMusicLyricsStructuredContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 23;
   */
  videoEditorContent?: VideoEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 25;
   */
  inpaintContent?: InpaintContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageContent imported_image_content = 26;
   */
  importedImageContent?: ImportedImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AdBannerResizerContent ad_banner_resizer_content = 27;
   */
  adBannerResizerContent?: AdBannerResizerContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 10;
   */
  images?: ImageJson[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem media_items = 24;
   */
  mediaItems?: MediaItemJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Iteration.
 * Use `create(IterationSchema)` to create a new message.
 */
export const IterationSchema: GenMessage<Iteration, {jsonType: IterationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 15);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MusicGeneratorSection
 */
export type MusicGeneratorSection = Message<"creativefabrica.studiomediamatrix.v1.MusicGeneratorSection"> & {
  /**
   * @generated from field: uint32 start_ms = 1;
   */
  startMs: number;

  /**
   * @generated from field: uint32 end_ms = 2;
   */
  endMs: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorSectionType type = 3;
   */
  type: MusicGeneratorSectionType;

  /**
   * @generated from field: repeated string style = 4;
   */
  style: string[];

  /**
   * @generated from field: string lyrics = 5;
   */
  lyrics: string;

  /**
   * @generated from field: repeated string negative_styles = 6;
   */
  negativeStyles: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MusicGeneratorSection
 */
export type MusicGeneratorSectionJson = {
  /**
   * @generated from field: uint32 start_ms = 1;
   */
  startMs?: number;

  /**
   * @generated from field: uint32 end_ms = 2;
   */
  endMs?: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorSectionType type = 3;
   */
  type?: MusicGeneratorSectionTypeJson;

  /**
   * @generated from field: repeated string style = 4;
   */
  style?: string[];

  /**
   * @generated from field: string lyrics = 5;
   */
  lyrics?: string;

  /**
   * @generated from field: repeated string negative_styles = 6;
   */
  negativeStyles?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MusicGeneratorSection.
 * Use `create(MusicGeneratorSectionSchema)` to create a new message.
 */
export const MusicGeneratorSectionSchema: GenMessage<MusicGeneratorSection, {jsonType: MusicGeneratorSectionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 16);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings
 */
export type MusicGeneratorSongSettings = Message<"creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings"> & {
  /**
   * @generated from field: optional uint32 bpm = 1;
   */
  bpm?: number | undefined;

  /**
   * @generated from field: optional string key = 2;
   */
  key?: string | undefined;

  /**
   * @generated from field: optional string scale = 3;
   */
  scale?: string | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings
 */
export type MusicGeneratorSongSettingsJson = {
  /**
   * @generated from field: optional uint32 bpm = 1;
   */
  bpm?: number;

  /**
   * @generated from field: optional string key = 2;
   */
  key?: string;

  /**
   * @generated from field: optional string scale = 3;
   */
  scale?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings.
 * Use `create(MusicGeneratorSongSettingsSchema)` to create a new message.
 */
export const MusicGeneratorSongSettingsSchema: GenMessage<MusicGeneratorSongSettings, {jsonType: MusicGeneratorSongSettingsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 17);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent
 */
export type SessionRequestPromptContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent.model
   */
  model: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel image_model = 3;
     */
    value: ImageGeneratorModel;
    case: "imageModel";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent
 */
export type SessionRequestPromptContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel image_model = 3;
   */
  imageModel?: ImageGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent.
 * Use `create(SessionRequestPromptContentSchema)` to create a new message.
 */
export const SessionRequestPromptContentSchema: GenMessage<SessionRequestPromptContent, {jsonType: SessionRequestPromptContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 18);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptContent
 */
export type PromptContent = Message<"creativefabrica.studiomediamatrix.v1.PromptContent"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptContent
 */
export type PromptContentJson = {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptContent.
 * Use `create(PromptContentSchema)` to create a new message.
 */
export const PromptContentSchema: GenMessage<PromptContent, {jsonType: PromptContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 19);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent
 */
export type PromptMusicGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration music_duration = 3;
   */
  musicDuration: PromptMusicGeneratorContentMusicDuration;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode content_mode = 4;
   */
  contentMode: PromptMusicGeneratorContentMode;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorModel model = 5;
   */
  model: MusicGeneratorModel;

  /**
   * @generated from field: optional string lyrics = 6;
   */
  lyrics?: string | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 7;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 8;
   */
  sections: MusicGeneratorSection[];

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 9;
   */
  songSettings?: MusicGeneratorSongSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent
 */
export type PromptMusicGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration music_duration = 3;
   */
  musicDuration?: PromptMusicGeneratorContentMusicDurationJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode content_mode = 4;
   */
  contentMode?: PromptMusicGeneratorContentModeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorModel model = 5;
   */
  model?: MusicGeneratorModelJson;

  /**
   * @generated from field: optional string lyrics = 6;
   */
  lyrics?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 7;
   */
  generatedImageUrl?: GeneratedImageURLJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 8;
   */
  sections?: MusicGeneratorSectionJson[];

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 9;
   */
  songSettings?: MusicGeneratorSongSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent.
 * Use `create(PromptMusicGeneratorContentSchema)` to create a new message.
 */
export const PromptMusicGeneratorContentSchema: GenMessage<PromptMusicGeneratorContent, {jsonType: PromptMusicGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 20);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent
 */
export type SessionRequestPromptMusicGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration music_duration = 3;
   */
  musicDuration: PromptMusicGeneratorContentMusicDuration;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode content_mode = 4;
   */
  contentMode: PromptMusicGeneratorContentMode;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorModel model = 5;
   */
  model: MusicGeneratorModel;

  /**
   * @generated from field: optional string lyrics = 6;
   */
  lyrics?: string | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent image_content = 7;
   */
  imageContent?: SessionRequestPromptMusicGeneratorContent_RequestImageContent | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorVoiceType voice = 8;
   */
  voice?: MusicGeneratorVoiceType | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 9;
   */
  sections: MusicGeneratorSection[];

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 10;
   */
  songSettings?: MusicGeneratorSongSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent
 */
export type SessionRequestPromptMusicGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration music_duration = 3;
   */
  musicDuration?: PromptMusicGeneratorContentMusicDurationJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode content_mode = 4;
   */
  contentMode?: PromptMusicGeneratorContentModeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MusicGeneratorModel model = 5;
   */
  model?: MusicGeneratorModelJson;

  /**
   * @generated from field: optional string lyrics = 6;
   */
  lyrics?: string;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent image_content = 7;
   */
  imageContent?: SessionRequestPromptMusicGeneratorContent_RequestImageContentJson;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorVoiceType voice = 8;
   */
  voice?: MusicGeneratorVoiceTypeJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 9;
   */
  sections?: MusicGeneratorSectionJson[];

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 10;
   */
  songSettings?: MusicGeneratorSongSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.
 * Use `create(SessionRequestPromptMusicGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestPromptMusicGeneratorContentSchema: GenMessage<SessionRequestPromptMusicGeneratorContent, {jsonType: SessionRequestPromptMusicGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 21);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent
 */
export type SessionRequestPromptMusicGeneratorContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent
 */
export type SessionRequestPromptMusicGeneratorContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent.RequestImageContent.
 * Use `create(SessionRequestPromptMusicGeneratorContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestPromptMusicGeneratorContent_RequestImageContentSchema: GenMessage<SessionRequestPromptMusicGeneratorContent_RequestImageContent, {jsonType: SessionRequestPromptMusicGeneratorContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 21, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent
 */
export type PromptMusicLyricsStructuredContent = Message<"creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 2;
   */
  seedSections: MusicGeneratorSection[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 3;
   */
  targetDurationMs?: number | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 4;
   */
  songSettings?: MusicGeneratorSongSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent
 */
export type PromptMusicLyricsStructuredContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 2;
   */
  seedSections?: MusicGeneratorSectionJson[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 3;
   */
  targetDurationMs?: number;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 4;
   */
  songSettings?: MusicGeneratorSongSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptMusicLyricsStructuredContent.
 * Use `create(PromptMusicLyricsStructuredContentSchema)` to create a new message.
 */
export const PromptMusicLyricsStructuredContentSchema: GenMessage<PromptMusicLyricsStructuredContent, {jsonType: PromptMusicLyricsStructuredContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 22);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent
 */
export type SessionRequestPromptMusicLyricsStructuredContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 3;
   */
  seedSections: MusicGeneratorSection[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 4;
   */
  targetDurationMs?: number | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 5;
   */
  songSettings?: MusicGeneratorSongSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent
 */
export type SessionRequestPromptMusicLyricsStructuredContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 3;
   */
  seedSections?: MusicGeneratorSectionJson[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 4;
   */
  targetDurationMs?: number;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 5;
   */
  songSettings?: MusicGeneratorSongSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent.
 * Use `create(SessionRequestPromptMusicLyricsStructuredContentSchema)` to create a new message.
 */
export const SessionRequestPromptMusicLyricsStructuredContentSchema: GenMessage<SessionRequestPromptMusicLyricsStructuredContent, {jsonType: SessionRequestPromptMusicLyricsStructuredContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 23);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent
 */
export type PromptSoundGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration sound_duration = 2;
   */
  soundDuration: PromptSoundGeneratorContentSoundDuration;

  /**
   * @generated from field: bool is_loopable = 3;
   */
  isLoopable: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent
 */
export type PromptSoundGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration sound_duration = 2;
   */
  soundDuration?: PromptSoundGeneratorContentSoundDurationJson;

  /**
   * @generated from field: bool is_loopable = 3;
   */
  isLoopable?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent.
 * Use `create(PromptSoundGeneratorContentSchema)` to create a new message.
 */
export const PromptSoundGeneratorContentSchema: GenMessage<PromptSoundGeneratorContent, {jsonType: PromptSoundGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 24);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent
 */
export type SessionRequestPromptSoundGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration sound_duration = 3;
   */
  soundDuration: PromptSoundGeneratorContentSoundDuration;

  /**
   * @generated from field: bool is_loopable = 4;
   */
  isLoopable: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent
 */
export type SessionRequestPromptSoundGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration sound_duration = 3;
   */
  soundDuration?: PromptSoundGeneratorContentSoundDurationJson;

  /**
   * @generated from field: bool is_loopable = 4;
   */
  isLoopable?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent.
 * Use `create(SessionRequestPromptSoundGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestPromptSoundGeneratorContentSchema: GenMessage<SessionRequestPromptSoundGeneratorContent, {jsonType: SessionRequestPromptSoundGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 25);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent
 */
export type SessionRequestPromptSpeechGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: string voice_id = 3;
   */
  voiceId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel model = 4;
   */
  model: PromptSpeechGeneratorModel;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent
 */
export type SessionRequestPromptSpeechGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: string voice_id = 3;
   */
  voiceId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel model = 4;
   */
  model?: PromptSpeechGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent.
 * Use `create(SessionRequestPromptSpeechGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestPromptSpeechGeneratorContentSchema: GenMessage<SessionRequestPromptSpeechGeneratorContent, {jsonType: SessionRequestPromptSpeechGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 26);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent
 */
export type PromptSpeechGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: string voice_id = 2;
   */
  voiceId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel model = 3;
   */
  model: PromptSpeechGeneratorModel;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent
 */
export type PromptSpeechGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: string voice_id = 2;
   */
  voiceId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel model = 3;
   */
  model?: PromptSpeechGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent.
 * Use `create(PromptSpeechGeneratorContentSchema)` to create a new message.
 */
export const PromptSpeechGeneratorContentSchema: GenMessage<PromptSpeechGeneratorContent, {jsonType: PromptSpeechGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 27);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.WeddingInviteDetails
 */
export type WeddingInviteDetails = Message<"creativefabrica.studiomediamatrix.v1.WeddingInviteDetails"> & {
  /**
   * @generated from field: string partner1_name = 1;
   */
  partner1Name: string;

  /**
   * @generated from field: string partner2_name = 2;
   */
  partner2Name: string;

  /**
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * @generated from field: string time = 4;
   */
  time: string;

  /**
   * @generated from field: string venue = 5;
   */
  venue: string;

  /**
   * @generated from field: string address = 6;
   */
  address: string;

  /**
   * @generated from field: string rsvp_date = 7;
   */
  rsvpDate: string;

  /**
   * @generated from field: string additional_info = 8;
   */
  additionalInfo: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.WeddingInviteDetails
 */
export type WeddingInviteDetailsJson = {
  /**
   * @generated from field: string partner1_name = 1;
   */
  partner1Name?: string;

  /**
   * @generated from field: string partner2_name = 2;
   */
  partner2Name?: string;

  /**
   * @generated from field: string date = 3;
   */
  date?: string;

  /**
   * @generated from field: string time = 4;
   */
  time?: string;

  /**
   * @generated from field: string venue = 5;
   */
  venue?: string;

  /**
   * @generated from field: string address = 6;
   */
  address?: string;

  /**
   * @generated from field: string rsvp_date = 7;
   */
  rsvpDate?: string;

  /**
   * @generated from field: string additional_info = 8;
   */
  additionalInfo?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.WeddingInviteDetails.
 * Use `create(WeddingInviteDetailsSchema)` to create a new message.
 */
export const WeddingInviteDetailsSchema: GenMessage<WeddingInviteDetails, {jsonType: WeddingInviteDetailsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 28);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent
 */
export type SessionRequestCollageMakerContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent images_content = 2;
   */
  imagesContent: SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContent[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle style = 3;
   */
  style: CollageMakerContentStyle;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent
 */
export type SessionRequestCollageMakerContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent images_content = 2;
   */
  imagesContent?: SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContentJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle style = 3;
   */
  style?: CollageMakerContentStyleJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.
 * Use `create(SessionRequestCollageMakerContentSchema)` to create a new message.
 */
export const SessionRequestCollageMakerContentSchema: GenMessage<SessionRequestCollageMakerContent, {jsonType: SessionRequestCollageMakerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 29);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent
 */
export type SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent
 */
export type SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent.SessionRequestCollageMakerContentRequestImageContent.
 * Use `create(SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContentSchema)` to create a new message.
 */
export const SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContentSchema: GenMessage<SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContent, {jsonType: SessionRequestCollageMakerContent_SessionRequestCollageMakerContentRequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 29, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent
 */
export type SessionRequestDoodlePetContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetVibe vibe = 2;
   */
  vibe: DoodlePetVibe;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestDoodlePetContent_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent
 */
export type SessionRequestDoodlePetContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetVibe vibe = 2;
   */
  vibe?: DoodlePetVibeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestDoodlePetContent_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.
 * Use `create(SessionRequestDoodlePetContentSchema)` to create a new message.
 */
export const SessionRequestDoodlePetContentSchema: GenMessage<SessionRequestDoodlePetContent, {jsonType: SessionRequestDoodlePetContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 30);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent
 */
export type SessionRequestDoodlePetContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent
 */
export type SessionRequestDoodlePetContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent.RequestImageContent.
 * Use `create(SessionRequestDoodlePetContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestDoodlePetContent_RequestImageContentSchema: GenMessage<SessionRequestDoodlePetContent_RequestImageContent, {jsonType: SessionRequestDoodlePetContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 30, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ClickPoint
 */
export type ClickPoint = Message<"creativefabrica.studiomediamatrix.v1.ClickPoint"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ClickPoint
 */
export type ClickPointJson = {
  /**
   * @generated from field: float x = 1;
   */
  x?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: float y = 2;
   */
  y?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ClickPoint.
 * Use `create(ClickPointSchema)` to create a new message.
 */
export const ClickPointSchema: GenMessage<ClickPoint, {jsonType: ClickPointJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 31);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ObjectClicksRequest
 */
export type ObjectClicksRequest = Message<"creativefabrica.studiomediamatrix.v1.ObjectClicksRequest"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ClickPoint pos_clicks = 1;
   */
  posClicks: ClickPoint[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ClickPoint neg_clicks = 2;
   */
  negClicks: ClickPoint[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ObjectClicksRequest
 */
export type ObjectClicksRequestJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ClickPoint pos_clicks = 1;
   */
  posClicks?: ClickPointJson[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ClickPoint neg_clicks = 2;
   */
  negClicks?: ClickPointJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ObjectClicksRequest.
 * Use `create(ObjectClicksRequestSchema)` to create a new message.
 */
export const ObjectClicksRequestSchema: GenMessage<ObjectClicksRequest, {jsonType: ObjectClicksRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 32);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent
 */
export type SessionRequestVideoCutoutsContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent image_content = 2;
   */
  imageContent?: SessionRequestVideoCutoutsContent_RequestImageContent | undefined;

  /**
   * @generated from field: map<int32, creativefabrica.studiomediamatrix.v1.ObjectClicksRequest> clicks = 3;
   */
  clicks: { [key: number]: ObjectClicksRequest };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent video_content = 4;
   */
  videoContent?: SessionRequestVideoCutoutsContent_RequestVideoContent | undefined;

  /**
   * @generated from field: int32 frame_idx = 5;
   */
  frameIdx: number;

  /**
   * @generated from field: int32 video_width = 6;
   */
  videoWidth: number;

  /**
   * @generated from field: int32 video_height = 7;
   */
  videoHeight: number;

  /**
   * @generated from field: int32 video_frame_count = 8;
   */
  videoFrameCount: number;

  /**
   * @generated from field: float video_fps = 9;
   */
  videoFps: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent
 */
export type SessionRequestVideoCutoutsContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent image_content = 2;
   */
  imageContent?: SessionRequestVideoCutoutsContent_RequestImageContentJson;

  /**
   * @generated from field: map<int32, creativefabrica.studiomediamatrix.v1.ObjectClicksRequest> clicks = 3;
   */
  clicks?: { [key: number]: ObjectClicksRequestJson };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent video_content = 4;
   */
  videoContent?: SessionRequestVideoCutoutsContent_RequestVideoContentJson;

  /**
   * @generated from field: int32 frame_idx = 5;
   */
  frameIdx?: number;

  /**
   * @generated from field: int32 video_width = 6;
   */
  videoWidth?: number;

  /**
   * @generated from field: int32 video_height = 7;
   */
  videoHeight?: number;

  /**
   * @generated from field: int32 video_frame_count = 8;
   */
  videoFrameCount?: number;

  /**
   * @generated from field: float video_fps = 9;
   */
  videoFps?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.
 * Use `create(SessionRequestVideoCutoutsContentSchema)` to create a new message.
 */
export const SessionRequestVideoCutoutsContentSchema: GenMessage<SessionRequestVideoCutoutsContent, {jsonType: SessionRequestVideoCutoutsContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 33);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent
 */
export type SessionRequestVideoCutoutsContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent
 */
export type SessionRequestVideoCutoutsContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestImageContent.
 * Use `create(SessionRequestVideoCutoutsContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestVideoCutoutsContent_RequestImageContentSchema: GenMessage<SessionRequestVideoCutoutsContent_RequestImageContent, {jsonType: SessionRequestVideoCutoutsContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 33, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent
 */
export type SessionRequestVideoCutoutsContent_RequestVideoContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent
 */
export type SessionRequestVideoCutoutsContent_RequestVideoContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent.RequestVideoContent.
 * Use `create(SessionRequestVideoCutoutsContent_RequestVideoContentSchema)` to create a new message.
 */
export const SessionRequestVideoCutoutsContent_RequestVideoContentSchema: GenMessage<SessionRequestVideoCutoutsContent_RequestVideoContent, {jsonType: SessionRequestVideoCutoutsContent_RequestVideoContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 33, 1);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoCutoutsContent
 */
export type VideoCutoutsContent = Message<"creativefabrica.studiomediamatrix.v1.VideoCutoutsContent"> & {
  /**
   * @generated from field: map<int32, creativefabrica.studiomediamatrix.v1.ObjectClicksRequest> clicks = 1;
   */
  clicks: { [key: number]: ObjectClicksRequest };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_video_url = 3;
   */
  generatedVideoUrl?: GeneratedImageURL | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoCutoutsContent
 */
export type VideoCutoutsContentJson = {
  /**
   * @generated from field: map<int32, creativefabrica.studiomediamatrix.v1.ObjectClicksRequest> clicks = 1;
   */
  clicks?: { [key: number]: ObjectClicksRequestJson };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 2;
   */
  generatedImageUrl?: GeneratedImageURLJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_video_url = 3;
   */
  generatedVideoUrl?: GeneratedImageURLJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoCutoutsContent.
 * Use `create(VideoCutoutsContentSchema)` to create a new message.
 */
export const VideoCutoutsContentSchema: GenMessage<VideoCutoutsContent, {jsonType: VideoCutoutsContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 34);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent
 */
export type SessionRequestColoringPageMakerContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageType coloring_type = 2;
   */
  coloringType: ColoringPageType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestColoringPageMakerContent_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent
 */
export type SessionRequestColoringPageMakerContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageType coloring_type = 2;
   */
  coloringType?: ColoringPageTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestColoringPageMakerContent_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.
 * Use `create(SessionRequestColoringPageMakerContentSchema)` to create a new message.
 */
export const SessionRequestColoringPageMakerContentSchema: GenMessage<SessionRequestColoringPageMakerContent, {jsonType: SessionRequestColoringPageMakerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 35);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent
 */
export type SessionRequestColoringPageMakerContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent
 */
export type SessionRequestColoringPageMakerContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent.RequestImageContent.
 * Use `create(SessionRequestColoringPageMakerContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestColoringPageMakerContent_RequestImageContentSchema: GenMessage<SessionRequestColoringPageMakerContent_RequestImageContent, {jsonType: SessionRequestColoringPageMakerContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 35, 0);

/**
 * VideoDuration is the open numeric replacement for the closed
 * PromptToVideoGeneratorContentDuration enum, which tops out at 15 seconds
 * and cannot express the longer durations newer models support (FLUX 3: up
 * to 20s; 30–60s planned). Modeled as a message rather than a bare int so
 * future duration semantics (e.g. an auto/fit-to-content mode) extend it
 * without another migration.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoDuration
 */
export type VideoDuration = Message<"creativefabrica.studiomediamatrix.v1.VideoDuration"> & {
  /**
   * Whole seconds. Per-model bounds are validated server-side against the
   * model's capabilities — there is no schema-level ceiling.
   *
   * @generated from field: int32 in_seconds = 1;
   */
  inSeconds: number;
};

/**
 * VideoDuration is the open numeric replacement for the closed
 * PromptToVideoGeneratorContentDuration enum, which tops out at 15 seconds
 * and cannot express the longer durations newer models support (FLUX 3: up
 * to 20s; 30–60s planned). Modeled as a message rather than a bare int so
 * future duration semantics (e.g. an auto/fit-to-content mode) extend it
 * without another migration.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoDuration
 */
export type VideoDurationJson = {
  /**
   * Whole seconds. Per-model bounds are validated server-side against the
   * model's capabilities — there is no schema-level ceiling.
   *
   * @generated from field: int32 in_seconds = 1;
   */
  inSeconds?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoDuration.
 * Use `create(VideoDurationSchema)` to create a new message.
 */
export const VideoDurationSchema: GenMessage<VideoDuration, {jsonType: VideoDurationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 36);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent
 */
export type SessionRequestPromptToVideoGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * Legacy closed enum (4–15s). Superseded by video_duration; still honored
   * when video_duration is unset so old clients keep working.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration duration = 3 [deprecated = true];
   * @deprecated
   */
  duration: PromptToVideoGeneratorContentDuration;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution resolution = 4;
   */
  resolution: PromptToVideoGeneratorContentResolution;

  /**
   * The single model to generate with. Superseded by `selections`; still
   * honored when selections is empty, which means one video from this model.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 5;
   */
  model: VideoGeneratorModel;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoFrameRequest frames = 6;
   */
  frames: VideoFrameRequest[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio aspect_ratio = 7;
   */
  aspectRatio: PromptToVideoGeneratorContentAspectRatio;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.DirectorConfig director_config = 8;
   */
  directorConfig?: DirectorConfig | undefined;

  /**
   * @generated from field: repeated string studio_asset_usernames = 9;
   */
  studioAssetUsernames: string[];

  /**
   * When set with in_seconds > 0, takes precedence over the legacy
   * `duration` enum.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoDuration video_duration = 10;
   */
  videoDuration?: VideoDuration | undefined;

  /**
   * selections generates several videos from this one prompt and input set,
   * across the same or different models. Every video shares the session's
   * resolution, aspect ratio, duration, frames and director config — only the
   * model varies. Takes precedence over `model` when non-empty; the summed
   * count is capped server-side.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection selections = 11;
   */
  selections: VideoGeneratorModelSelection[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent
 */
export type SessionRequestPromptToVideoGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * Legacy closed enum (4–15s). Superseded by video_duration; still honored
   * when video_duration is unset so old clients keep working.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration duration = 3 [deprecated = true];
   * @deprecated
   */
  duration?: PromptToVideoGeneratorContentDurationJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution resolution = 4;
   */
  resolution?: PromptToVideoGeneratorContentResolutionJson;

  /**
   * The single model to generate with. Superseded by `selections`; still
   * honored when selections is empty, which means one video from this model.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 5;
   */
  model?: VideoGeneratorModelJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoFrameRequest frames = 6;
   */
  frames?: VideoFrameRequestJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio aspect_ratio = 7;
   */
  aspectRatio?: PromptToVideoGeneratorContentAspectRatioJson;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.DirectorConfig director_config = 8;
   */
  directorConfig?: DirectorConfigJson;

  /**
   * @generated from field: repeated string studio_asset_usernames = 9;
   */
  studioAssetUsernames?: string[];

  /**
   * When set with in_seconds > 0, takes precedence over the legacy
   * `duration` enum.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoDuration video_duration = 10;
   */
  videoDuration?: VideoDurationJson;

  /**
   * selections generates several videos from this one prompt and input set,
   * across the same or different models. Every video shares the session's
   * resolution, aspect ratio, duration, frames and director config — only the
   * model varies. Takes precedence over `model` when non-empty; the summed
   * count is capped server-side.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection selections = 11;
   */
  selections?: VideoGeneratorModelSelectionJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent.
 * Use `create(SessionRequestPromptToVideoGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestPromptToVideoGeneratorContentSchema: GenMessage<SessionRequestPromptToVideoGeneratorContent, {jsonType: SessionRequestPromptToVideoGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 37);

/**
 * VideoGeneratorModelSelection requests `count` videos from one model within a
 * single session. Each becomes its own media item, generated and completed
 * independently, under the session's single coin transaction.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection
 */
export type VideoGeneratorModelSelection = Message<"creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 1;
   */
  model: VideoGeneratorModel;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * VideoGeneratorModelSelection requests `count` videos from one model within a
 * single session. Each becomes its own media item, generated and completed
 * independently, under the session's single coin transaction.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection
 */
export type VideoGeneratorModelSelectionJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 1;
   */
  model?: VideoGeneratorModelJson;

  /**
   * @generated from field: int32 count = 2;
   */
  count?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection.
 * Use `create(VideoGeneratorModelSelectionSchema)` to create a new message.
 */
export const VideoGeneratorModelSelectionSchema: GenMessage<VideoGeneratorModelSelection, {jsonType: VideoGeneratorModelSelectionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 38);

/**
 * SessionRequestVideoTemplateContent initiates a Kling motion-control video
 * generation from a curated template. The template carries the reference
 * video, model, and per-template defaults (duration/resolution/aspect_ratio)
 * server-side; the only user input is the uploaded image.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent
 */
export type SessionRequestVideoTemplateContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string template_id = 2;
   */
  templateId: string;

  /**
   * Exactly one image at launch. `repeated` leaves room for multi-asset
   * templates without a wire-format break.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent image_content = 3;
   */
  imageContent: SessionRequestVideoTemplateContent_RequestImageContent[];
};

/**
 * SessionRequestVideoTemplateContent initiates a Kling motion-control video
 * generation from a curated template. The template carries the reference
 * video, model, and per-template defaults (duration/resolution/aspect_ratio)
 * server-side; the only user input is the uploaded image.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent
 */
export type SessionRequestVideoTemplateContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string template_id = 2;
   */
  templateId?: string;

  /**
   * Exactly one image at launch. `repeated` leaves room for multi-asset
   * templates without a wire-format break.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestVideoTemplateContent_RequestImageContentJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.
 * Use `create(SessionRequestVideoTemplateContentSchema)` to create a new message.
 */
export const SessionRequestVideoTemplateContentSchema: GenMessage<SessionRequestVideoTemplateContent, {jsonType: SessionRequestVideoTemplateContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 39);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent
 */
export type SessionRequestVideoTemplateContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent
 */
export type SessionRequestVideoTemplateContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent.RequestImageContent.
 * Use `create(SessionRequestVideoTemplateContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestVideoTemplateContent_RequestImageContentSchema: GenMessage<SessionRequestVideoTemplateContent_RequestImageContent, {jsonType: SessionRequestVideoTemplateContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 39, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorConfig
 */
export type DirectorConfig = Message<"creativefabrica.studiomediamatrix.v1.DirectorConfig"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay time_of_day = 1;
   */
  timeOfDay?: DirectorTimeOfDay | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLighting lighting = 2;
   */
  lighting?: DirectorLighting | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStock film_stock = 3;
   */
  filmStock?: DirectorFilmStock | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFocus focus = 4;
   */
  focus?: DirectorFocus | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorComposition composition = 5;
   */
  composition?: DirectorComposition | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorShotSize shot_size = 6;
   */
  shotSize?: DirectorShotSize | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLens lens = 7;
   */
  lens?: DirectorLens | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovement movement = 8;
   */
  movement?: DirectorMovement | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorConfig
 */
export type DirectorConfigJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay time_of_day = 1;
   */
  timeOfDay?: DirectorTimeOfDayJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLighting lighting = 2;
   */
  lighting?: DirectorLightingJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStock film_stock = 3;
   */
  filmStock?: DirectorFilmStockJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFocus focus = 4;
   */
  focus?: DirectorFocusJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorComposition composition = 5;
   */
  composition?: DirectorCompositionJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorShotSize shot_size = 6;
   */
  shotSize?: DirectorShotSizeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLens lens = 7;
   */
  lens?: DirectorLensJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovement movement = 8;
   */
  movement?: DirectorMovementJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorConfig.
 * Use `create(DirectorConfigSchema)` to create a new message.
 */
export const DirectorConfigSchema: GenMessage<DirectorConfig, {jsonType: DirectorConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 40);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay
 */
export type DirectorTimeOfDay = Message<"creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorTimeOfDayLighting lighting = 1;
   */
  lighting: DirectorTimeOfDayLighting;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay
 */
export type DirectorTimeOfDayJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorTimeOfDayLighting lighting = 1;
   */
  lighting?: DirectorTimeOfDayLightingJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorTimeOfDay.
 * Use `create(DirectorTimeOfDaySchema)` to create a new message.
 */
export const DirectorTimeOfDaySchema: GenMessage<DirectorTimeOfDay, {jsonType: DirectorTimeOfDayJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 41);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorLighting
 */
export type DirectorLighting = Message<"creativefabrica.studiomediamatrix.v1.DirectorLighting"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLightingDirection direction = 1;
   */
  direction: DirectorLightingDirection;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorLighting
 */
export type DirectorLightingJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLightingDirection direction = 1;
   */
  direction?: DirectorLightingDirectionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorLighting.
 * Use `create(DirectorLightingSchema)` to create a new message.
 */
export const DirectorLightingSchema: GenMessage<DirectorLighting, {jsonType: DirectorLightingJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 42);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorFilmStock
 */
export type DirectorFilmStock = Message<"creativefabrica.studiomediamatrix.v1.DirectorFilmStock"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStockColor color = 1;
   */
  color: DirectorFilmStockColor;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStockFormat format = 2;
   */
  format: DirectorFilmStockFormat;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorFilmStock
 */
export type DirectorFilmStockJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStockColor color = 1;
   */
  color?: DirectorFilmStockColorJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFilmStockFormat format = 2;
   */
  format?: DirectorFilmStockFormatJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorFilmStock.
 * Use `create(DirectorFilmStockSchema)` to create a new message.
 */
export const DirectorFilmStockSchema: GenMessage<DirectorFilmStock, {jsonType: DirectorFilmStockJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 43);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorFocus
 */
export type DirectorFocus = Message<"creativefabrica.studiomediamatrix.v1.DirectorFocus"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFocusType type = 1;
   */
  type: DirectorFocusType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorFocus
 */
export type DirectorFocusJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorFocusType type = 1;
   */
  type?: DirectorFocusTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorFocus.
 * Use `create(DirectorFocusSchema)` to create a new message.
 */
export const DirectorFocusSchema: GenMessage<DirectorFocus, {jsonType: DirectorFocusJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 44);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorComposition
 */
export type DirectorComposition = Message<"creativefabrica.studiomediamatrix.v1.DirectorComposition"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorCompositionType type = 1;
   */
  type: DirectorCompositionType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorComposition
 */
export type DirectorCompositionJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorCompositionType type = 1;
   */
  type?: DirectorCompositionTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorComposition.
 * Use `create(DirectorCompositionSchema)` to create a new message.
 */
export const DirectorCompositionSchema: GenMessage<DirectorComposition, {jsonType: DirectorCompositionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 45);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorShotSize
 */
export type DirectorShotSize = Message<"creativefabrica.studiomediamatrix.v1.DirectorShotSize"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorShotSizeType type = 1;
   */
  type: DirectorShotSizeType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorShotSize
 */
export type DirectorShotSizeJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorShotSizeType type = 1;
   */
  type?: DirectorShotSizeTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorShotSize.
 * Use `create(DirectorShotSizeSchema)` to create a new message.
 */
export const DirectorShotSizeSchema: GenMessage<DirectorShotSize, {jsonType: DirectorShotSizeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 46);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorLens
 */
export type DirectorLens = Message<"creativefabrica.studiomediamatrix.v1.DirectorLens"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLensType type = 1;
   */
  type: DirectorLensType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorLens
 */
export type DirectorLensJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorLensType type = 1;
   */
  type?: DirectorLensTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorLens.
 * Use `create(DirectorLensSchema)` to create a new message.
 */
export const DirectorLensSchema: GenMessage<DirectorLens, {jsonType: DirectorLensJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 47);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorMovement
 */
export type DirectorMovement = Message<"creativefabrica.studiomediamatrix.v1.DirectorMovement"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementType type = 1;
   */
  type: DirectorMovementType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementIntensity intensity = 2;
   */
  intensity: DirectorMovementIntensity;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementEasing easing = 3;
   */
  easing: DirectorMovementEasing;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DirectorMovement
 */
export type DirectorMovementJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementType type = 1;
   */
  type?: DirectorMovementTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementIntensity intensity = 2;
   */
  intensity?: DirectorMovementIntensityJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorMovementEasing easing = 3;
   */
  easing?: DirectorMovementEasingJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DirectorMovement.
 * Use `create(DirectorMovementSchema)` to create a new message.
 */
export const DirectorMovementSchema: GenMessage<DirectorMovement, {jsonType: DirectorMovementJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 48);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StudioAsset
 */
export type StudioAsset = Message<"creativefabrica.studiomediamatrix.v1.StudioAsset"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StudioAsset
 */
export type StudioAssetJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string username = 2;
   */
  username?: string;

  /**
   * @generated from field: string type = 3;
   */
  type?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.StudioAsset.
 * Use `create(StudioAssetSchema)` to create a new message.
 */
export const StudioAssetSchema: GenMessage<StudioAsset, {jsonType: StudioAssetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 49);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent
 */
export type PromptToVideoGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * Legacy closed enum: populated best-effort, only when the session's
   * duration is exactly representable (4–15s); UNSPECIFIED otherwise.
   * Read video_duration for the authoritative value.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration duration = 2 [deprecated = true];
   * @deprecated
   */
  duration: PromptToVideoGeneratorContentDuration;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution resolution = 3;
   */
  resolution: PromptToVideoGeneratorContentResolution;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 4;
   */
  model: VideoGeneratorModel;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoFrame frames = 5;
   */
  frames: VideoFrame[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio aspect_ratio = 6;
   */
  aspectRatio: PromptToVideoGeneratorContentAspectRatio;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorConfig director_config = 7;
   */
  directorConfig?: DirectorConfig | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.StudioAsset studio_assets = 8;
   */
  studioAssets: StudioAsset[];

  /**
   * Always set on responses; the authoritative duration in whole seconds.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoDuration video_duration = 9;
   */
  videoDuration?: VideoDuration | undefined;

  /**
   * The model selections the session was created from, echoed back so a client
   * can tell what it asked for. Empty for a single-model session, where `model`
   * is the whole answer.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection selections = 10;
   */
  selections: VideoGeneratorModelSelection[];

  /**
   * Playback length of the delivered clip, recorded when the session's first
   * video completes. For an extension session this is the source plus the
   * extension, whereas video_duration is the extension alone. Unset while the
   * session is still running.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoDuration output_duration = 11;
   */
  outputDuration?: VideoDuration | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent
 */
export type PromptToVideoGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * Legacy closed enum: populated best-effort, only when the session's
   * duration is exactly representable (4–15s); UNSPECIFIED otherwise.
   * Read video_duration for the authoritative value.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration duration = 2 [deprecated = true];
   * @deprecated
   */
  duration?: PromptToVideoGeneratorContentDurationJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution resolution = 3;
   */
  resolution?: PromptToVideoGeneratorContentResolutionJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 4;
   */
  model?: VideoGeneratorModelJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoFrame frames = 5;
   */
  frames?: VideoFrameJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio aspect_ratio = 6;
   */
  aspectRatio?: PromptToVideoGeneratorContentAspectRatioJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DirectorConfig director_config = 7;
   */
  directorConfig?: DirectorConfigJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.StudioAsset studio_assets = 8;
   */
  studioAssets?: StudioAssetJson[];

  /**
   * Always set on responses; the authoritative duration in whole seconds.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoDuration video_duration = 9;
   */
  videoDuration?: VideoDurationJson;

  /**
   * The model selections the session was created from, echoed back so a client
   * can tell what it asked for. Empty for a single-model session, where `model`
   * is the whole answer.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorModelSelection selections = 10;
   */
  selections?: VideoGeneratorModelSelectionJson[];

  /**
   * Playback length of the delivered clip, recorded when the session's first
   * video completes. For an extension session this is the source plus the
   * extension, whereas video_duration is the extension alone. Unset while the
   * session is still running.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoDuration output_duration = 11;
   */
  outputDuration?: VideoDurationJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent.
 * Use `create(PromptToVideoGeneratorContentSchema)` to create a new message.
 */
export const PromptToVideoGeneratorContentSchema: GenMessage<PromptToVideoGeneratorContent, {jsonType: PromptToVideoGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 50);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent
 */
export type SessionRequestWeddingInviteContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteTheme theme = 2;
   */
  theme: WeddingInviteTheme;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteDetails details = 3;
   */
  details?: WeddingInviteDetails | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent image_content = 4;
   */
  imageContent?: SessionRequestWeddingInviteContent_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent
 */
export type SessionRequestWeddingInviteContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteTheme theme = 2;
   */
  theme?: WeddingInviteThemeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteDetails details = 3;
   */
  details?: WeddingInviteDetailsJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent image_content = 4;
   */
  imageContent?: SessionRequestWeddingInviteContent_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.
 * Use `create(SessionRequestWeddingInviteContentSchema)` to create a new message.
 */
export const SessionRequestWeddingInviteContentSchema: GenMessage<SessionRequestWeddingInviteContent, {jsonType: SessionRequestWeddingInviteContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 51);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent
 */
export type SessionRequestWeddingInviteContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent
 */
export type SessionRequestWeddingInviteContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent.RequestImageContent.
 * Use `create(SessionRequestWeddingInviteContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestWeddingInviteContent_RequestImageContentSchema: GenMessage<SessionRequestWeddingInviteContent_RequestImageContent, {jsonType: SessionRequestWeddingInviteContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 51, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent
 */
export type SessionRequestEtsyCoachContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent
 */
export type SessionRequestEtsyCoachContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent.
 * Use `create(SessionRequestEtsyCoachContentSchema)` to create a new message.
 */
export const SessionRequestEtsyCoachContentSchema: GenMessage<SessionRequestEtsyCoachContent, {jsonType: SessionRequestEtsyCoachContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 52);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent
 */
export type SessionRequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestImageContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent images_content = 2;
   */
  imagesContent: SessionRequestImageContent_RequestImageContent[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent
 */
export type SessionRequestImageContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent images_content = 2;
   */
  imagesContent?: SessionRequestImageContent_RequestImageContentJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.
 * Use `create(SessionRequestImageContentSchema)` to create a new message.
 */
export const SessionRequestImageContentSchema: GenMessage<SessionRequestImageContent, {jsonType: SessionRequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 53);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent
 */
export type SessionRequestImageContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent
 */
export type SessionRequestImageContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestImageContent.RequestImageContent.
 * Use `create(SessionRequestImageContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestImageContent_RequestImageContentSchema: GenMessage<SessionRequestImageContent_RequestImageContent, {jsonType: SessionRequestImageContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 53, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent
 */
export type SessionRequestTextCADContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType model_type = 3;
   */
  modelType: ModelThreeDGeneratorOpenSCADModelType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent image_content = 4;
   */
  imageContent?: SessionRequestTextCADContent_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent
 */
export type SessionRequestTextCADContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType model_type = 3;
   */
  modelType?: ModelThreeDGeneratorOpenSCADModelTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent image_content = 4;
   */
  imageContent?: SessionRequestTextCADContent_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.
 * Use `create(SessionRequestTextCADContentSchema)` to create a new message.
 */
export const SessionRequestTextCADContentSchema: GenMessage<SessionRequestTextCADContent, {jsonType: SessionRequestTextCADContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 54);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent
 */
export type SessionRequestTextCADContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent
 */
export type SessionRequestTextCADContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent.RequestImageContent.
 * Use `create(SessionRequestTextCADContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestTextCADContent_RequestImageContentSchema: GenMessage<SessionRequestTextCADContent_RequestImageContent, {jsonType: SessionRequestTextCADContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 54, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent
 */
export type SessionRequestTextMeshContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent image_content = 2;
   */
  imageContent?: SessionRequestTextMeshContent_RequestImageContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MeshModel model = 3;
   */
  model: MeshModel;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent
 */
export type SessionRequestTextMeshContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent image_content = 2;
   */
  imageContent?: SessionRequestTextMeshContent_RequestImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MeshModel model = 3;
   */
  model?: MeshModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.
 * Use `create(SessionRequestTextMeshContentSchema)` to create a new message.
 */
export const SessionRequestTextMeshContentSchema: GenMessage<SessionRequestTextMeshContent, {jsonType: SessionRequestTextMeshContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 55);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent
 */
export type SessionRequestTextMeshContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent
 */
export type SessionRequestTextMeshContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent.RequestImageContent.
 * Use `create(SessionRequestTextMeshContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestTextMeshContent_RequestImageContentSchema: GenMessage<SessionRequestTextMeshContent_RequestImageContent, {jsonType: SessionRequestTextMeshContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 55, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SplatContent
 */
export type SplatContent = Message<"creativefabrica.studiomediamatrix.v1.SplatContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatStyle style = 2;
   */
  style: SplatStyle;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 3;
   */
  generatedImageUrls: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SplatContent
 */
export type SplatContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatStyle style = 2;
   */
  style?: SplatStyleJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 3;
   */
  generatedImageUrls?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SplatContent.
 * Use `create(SplatContentSchema)` to create a new message.
 */
export const SplatContentSchema: GenMessage<SplatContent, {jsonType: SplatContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 56);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent
 */
export type SessionRequestSplatContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent image_content = 2;
   */
  imageContent: SessionRequestSplatContent_RequestImageContent[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatStyle style = 3;
   */
  style: SplatStyle;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent
 */
export type SessionRequestSplatContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent image_content = 2;
   */
  imageContent?: SessionRequestSplatContent_RequestImageContentJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatStyle style = 3;
   */
  style?: SplatStyleJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.
 * Use `create(SessionRequestSplatContentSchema)` to create a new message.
 */
export const SessionRequestSplatContentSchema: GenMessage<SessionRequestSplatContent, {jsonType: SessionRequestSplatContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 57);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent
 */
export type SessionRequestSplatContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent
 */
export type SessionRequestSplatContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent.RequestImageContent.
 * Use `create(SessionRequestSplatContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestSplatContent_RequestImageContentSchema: GenMessage<SessionRequestSplatContent_RequestImageContent, {jsonType: SessionRequestSplatContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 57, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent
 */
export type SessionRequestAIPhotoStyleContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string ai_photo_style_id = 2;
   */
  aiPhotoStyleId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent image_content = 3;
   */
  imageContent: SessionRequestAIPhotoStyleContent_RequestImageContent[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent
 */
export type SessionRequestAIPhotoStyleContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string ai_photo_style_id = 2;
   */
  aiPhotoStyleId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestAIPhotoStyleContent_RequestImageContentJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.
 * Use `create(SessionRequestAIPhotoStyleContentSchema)` to create a new message.
 */
export const SessionRequestAIPhotoStyleContentSchema: GenMessage<SessionRequestAIPhotoStyleContent, {jsonType: SessionRequestAIPhotoStyleContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 58);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent
 */
export type SessionRequestAIPhotoStyleContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent
 */
export type SessionRequestAIPhotoStyleContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent.RequestImageContent.
 * Use `create(SessionRequestAIPhotoStyleContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestAIPhotoStyleContent_RequestImageContentSchema: GenMessage<SessionRequestAIPhotoStyleContent_RequestImageContent, {jsonType: SessionRequestAIPhotoStyleContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 58, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent
 */
export type SessionRequestYouTubeThumbnailGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * @generated from field: string template_id = 4;
   */
  templateId: string;

  /**
   * GPT Image 2 accepts at most 16 reference images. At least one is required.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent reference_images = 5;
   */
  referenceImages: SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContent[];

  /**
   * Defaults to 1 when omitted. The service currently accepts only 1.
   *
   * @generated from field: uint32 output_image_count = 6;
   */
  outputImageCount: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent
 */
export type SessionRequestYouTubeThumbnailGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt?: string;

  /**
   * @generated from field: string template_id = 4;
   */
  templateId?: string;

  /**
   * GPT Image 2 accepts at most 16 reference images. At least one is required.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent reference_images = 5;
   */
  referenceImages?: SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContentJson[];

  /**
   * Defaults to 1 when omitted. The service currently accepts only 1.
   *
   * @generated from field: uint32 output_image_count = 6;
   */
  outputImageCount?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.
 * Use `create(SessionRequestYouTubeThumbnailGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestYouTubeThumbnailGeneratorContentSchema: GenMessage<SessionRequestYouTubeThumbnailGeneratorContent, {jsonType: SessionRequestYouTubeThumbnailGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 59);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent
 */
export type SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent
 */
export type SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent.RequestImageContent.
 * Use `create(SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContentSchema: GenMessage<SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContent, {jsonType: SessionRequestYouTubeThumbnailGeneratorContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 59, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent
 */
export type SessionRequestAIMockupGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string preset_id = 2;
   */
  presetId: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent image_content = 3;
   */
  imageContent: SessionRequestAIMockupGeneratorContent_RequestImageContent[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent
 */
export type SessionRequestAIMockupGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string preset_id = 2;
   */
  presetId?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestAIMockupGeneratorContent_RequestImageContentJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.
 * Use `create(SessionRequestAIMockupGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestAIMockupGeneratorContentSchema: GenMessage<SessionRequestAIMockupGeneratorContent, {jsonType: SessionRequestAIMockupGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 60);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent
 */
export type SessionRequestAIMockupGeneratorContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent
 */
export type SessionRequestAIMockupGeneratorContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent.RequestImageContent.
 * Use `create(SessionRequestAIMockupGeneratorContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestAIMockupGeneratorContent_RequestImageContentSchema: GenMessage<SessionRequestAIMockupGeneratorContent_RequestImageContent, {jsonType: SessionRequestAIMockupGeneratorContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 60, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaItem
 */
export type MediaItem = Message<"creativefabrica.studiomediamatrix.v1.MediaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaType media_type = 4;
   */
  mediaType: MediaType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaStatus status = 5;
   */
  status: MediaStatus;

  /**
   * @generated from field: string error_message = 6;
   */
  errorMessage: string;

  /**
   * Classification of the failure when status is MEDIA_STATUS_ERROR, unspecified
   * otherwise. error_message carries the human-readable detail.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ErrorCode error_code = 23;
   */
  errorCode: ErrorCode;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 7;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 8;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * @generated from field: string session_id = 9;
   */
  sessionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */
  deletedAt?: Timestamp | undefined;

  /**
   * @generated from field: optional string iteration_id = 12;
   */
  iterationId?: string | undefined;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.MediaItem.media_content
   */
  mediaContent: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaAudioContent audio_content = 14;
     */
    value: MediaAudioContent;
    case: "audioContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaCADContent cad_content = 15;
     */
    value: MediaCADContent;
    case: "cadContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaVideoContent video_content = 16;
     */
    value: MediaVideoContent;
    case: "videoContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaJsonContent json_content = 17;
     */
    value: MediaJsonContent;
    case: "jsonContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaMeshContent mesh_content = 18;
     */
    value: MediaMeshContent;
    case: "meshContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaSplatContent splat_content = 20;
     */
    value: MediaSplatContent;
    case: "splatContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaMaskContent mask_content = 21;
     */
    value: MediaMaskContent;
    case: "maskContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaImageContent image_content = 22;
     */
    value: MediaImageContent;
    case: "imageContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bool is_nsfw = 19;
   */
  isNsfw: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaItem
 */
export type MediaItemJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaType media_type = 4;
   */
  mediaType?: MediaTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaStatus status = 5;
   */
  status?: MediaStatusJson;

  /**
   * @generated from field: string error_message = 6;
   */
  errorMessage?: string;

  /**
   * Classification of the failure when status is MEDIA_STATUS_ERROR, unspecified
   * otherwise. error_message carries the human-readable detail.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ErrorCode error_code = 23;
   */
  errorCode?: ErrorCodeJson;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 7;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 8;
   */
  receivedAt?: TimestampJson;

  /**
   * @generated from field: string session_id = 9;
   */
  sessionId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */
  deletedAt?: TimestampJson;

  /**
   * @generated from field: optional string iteration_id = 12;
   */
  iterationId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaAudioContent audio_content = 14;
   */
  audioContent?: MediaAudioContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaCADContent cad_content = 15;
   */
  cadContent?: MediaCADContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaVideoContent video_content = 16;
   */
  videoContent?: MediaVideoContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaJsonContent json_content = 17;
   */
  jsonContent?: MediaJsonContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaMeshContent mesh_content = 18;
   */
  meshContent?: MediaMeshContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaSplatContent splat_content = 20;
   */
  splatContent?: MediaSplatContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaMaskContent mask_content = 21;
   */
  maskContent?: MediaMaskContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaImageContent image_content = 22;
   */
  imageContent?: MediaImageContentJson;

  /**
   * @generated from field: bool is_nsfw = 19;
   */
  isNsfw?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaItem.
 * Use `create(MediaItemSchema)` to create a new message.
 */
export const MediaItemSchema: GenMessage<MediaItem, {jsonType: MediaItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 61);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaVideoContent
 */
export type MediaVideoContent = Message<"creativefabrica.studiomediamatrix.v1.MediaVideoContent"> & {
  /**
   * @generated from field: string generated_thumbnail_url = 2 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl: string;

  /**
   * @generated from field: string original_video_url = 3;
   */
  originalVideoUrl: string;

  /**
   * @generated from field: repeated string generated_hls_urls = 4;
   */
  generatedHlsUrls: string[];

  /**
   * @generated from field: repeated string generated_dash_urls = 5;
   */
  generatedDashUrls: string[];

  /**
   * This URL is generated after aws media converter, publicly accessible
   *
   * @generated from field: string generated_video_url = 6;
   */
  generatedVideoUrl: string;

  /**
   * @generated from field: string generated_preview_url = 7;
   */
  generatedPreviewUrl: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 8;
   */
  generatedThumbnailUrls: ThumbnailVariant[];

  /**
   * Evenly-spaced frame URLs for timeline scrubber UI, ordered by timestamp.
   *
   * @generated from field: repeated string filmstrip_urls = 9;
   */
  filmstripUrls: string[];

  /**
   * True when the video was flagged NSFW, either by automated moderation or
   * by CF staff (SetSessionMediaNSFW). Mirrors MediaItem.is_nsfw for video items.
   *
   * @generated from field: bool is_nsfw = 10;
   */
  isNsfw: boolean;

  /**
   * Engagement analysis of the generated video (tribe analyzer), attached by
   * the ACTION_TYPE_RUN_BRAIN_ANALYSIS_VIDEO action. Absent until triggered.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis generated_brain_analysis = 11;
   */
  generatedBrainAnalysis?: GeneratedBrainAnalysis | undefined;

  /**
   * The model this video was generated with. Set when the session fanned out
   * across models, where the session-level model describes only the first of
   * them; UNSPECIFIED means the session's own model.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 12;
   */
  model: VideoGeneratorModel;

  /**
   * Playback length of this video in whole seconds. Unset when the length
   * could not be determined.
   *
   * @generated from field: optional int32 duration_seconds = 13;
   */
  durationSeconds?: number | undefined;

  /**
   * Badge-only (idea.ai corner badge) copies of generated_video_url and
   * generated_preview_url, stored under random keys. Set when the creator was
   * not a paid subscriber at generation time.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copies are served in the regular URL fields instead to viewers
   * that are not paid subscribers.
   *
   * @generated from field: string watermarked_video_url = 14;
   */
  watermarkedVideoUrl: string;

  /**
   * @generated from field: string watermarked_preview_url = 15;
   */
  watermarkedPreviewUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaVideoContent
 */
export type MediaVideoContentJson = {
  /**
   * @generated from field: string generated_thumbnail_url = 2 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl?: string;

  /**
   * @generated from field: string original_video_url = 3;
   */
  originalVideoUrl?: string;

  /**
   * @generated from field: repeated string generated_hls_urls = 4;
   */
  generatedHlsUrls?: string[];

  /**
   * @generated from field: repeated string generated_dash_urls = 5;
   */
  generatedDashUrls?: string[];

  /**
   * This URL is generated after aws media converter, publicly accessible
   *
   * @generated from field: string generated_video_url = 6;
   */
  generatedVideoUrl?: string;

  /**
   * @generated from field: string generated_preview_url = 7;
   */
  generatedPreviewUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 8;
   */
  generatedThumbnailUrls?: ThumbnailVariantJson[];

  /**
   * Evenly-spaced frame URLs for timeline scrubber UI, ordered by timestamp.
   *
   * @generated from field: repeated string filmstrip_urls = 9;
   */
  filmstripUrls?: string[];

  /**
   * True when the video was flagged NSFW, either by automated moderation or
   * by CF staff (SetSessionMediaNSFW). Mirrors MediaItem.is_nsfw for video items.
   *
   * @generated from field: bool is_nsfw = 10;
   */
  isNsfw?: boolean;

  /**
   * Engagement analysis of the generated video (tribe analyzer), attached by
   * the ACTION_TYPE_RUN_BRAIN_ANALYSIS_VIDEO action. Absent until triggered.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis generated_brain_analysis = 11;
   */
  generatedBrainAnalysis?: GeneratedBrainAnalysisJson;

  /**
   * The model this video was generated with. Set when the session fanned out
   * across models, where the session-level model describes only the first of
   * them; UNSPECIFIED means the session's own model.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 12;
   */
  model?: VideoGeneratorModelJson;

  /**
   * Playback length of this video in whole seconds. Unset when the length
   * could not be determined.
   *
   * @generated from field: optional int32 duration_seconds = 13;
   */
  durationSeconds?: number;

  /**
   * Badge-only (idea.ai corner badge) copies of generated_video_url and
   * generated_preview_url, stored under random keys. Set when the creator was
   * not a paid subscriber at generation time.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copies are served in the regular URL fields instead to viewers
   * that are not paid subscribers.
   *
   * @generated from field: string watermarked_video_url = 14;
   */
  watermarkedVideoUrl?: string;

  /**
   * @generated from field: string watermarked_preview_url = 15;
   */
  watermarkedPreviewUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaVideoContent.
 * Use `create(MediaVideoContentSchema)` to create a new message.
 */
export const MediaVideoContentSchema: GenMessage<MediaVideoContent, {jsonType: MediaVideoContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 62);

/**
 * GeneratedBrainAnalysis is the tribe_analyzer_v1 engagement analysis
 * attached to a generated video. Deliberately minimal: overall_score and
 * verdict render badges without any fetch; the full result (review,
 * run_info, transcript, 3D brain_simulation) lives behind data_url — a
 * gzipped JSON blob served with Content-Encoding: gzip, self-described by
 * its {contract, version} envelope.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis
 */
export type GeneratedBrainAnalysis = Message<"creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrainAnalysisStatus status = 1;
   */
  status: BrainAnalysisStatus;

  /**
   * @generated from field: string generating_user = 2;
   */
  generatingUser: string;

  /**
   * @generated from field: string data_url = 3;
   */
  dataUrl: string;

  /**
   * Populated only when status is FAILED.
   *
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;

  /**
   * Engagement score 0-100 from the analysis review.
   *
   * @generated from field: int32 overall_score = 5;
   */
  overallScore: number;

  /**
   * One-sentence review verdict.
   *
   * @generated from field: string verdict = 6;
   */
  verdict: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * GeneratedBrainAnalysis is the tribe_analyzer_v1 engagement analysis
 * attached to a generated video. Deliberately minimal: overall_score and
 * verdict render badges without any fetch; the full result (review,
 * run_info, transcript, 3D brain_simulation) lives behind data_url — a
 * gzipped JSON blob served with Content-Encoding: gzip, self-described by
 * its {contract, version} envelope.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis
 */
export type GeneratedBrainAnalysisJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrainAnalysisStatus status = 1;
   */
  status?: BrainAnalysisStatusJson;

  /**
   * @generated from field: string generating_user = 2;
   */
  generatingUser?: string;

  /**
   * @generated from field: string data_url = 3;
   */
  dataUrl?: string;

  /**
   * Populated only when status is FAILED.
   *
   * @generated from field: string error_message = 4;
   */
  errorMessage?: string;

  /**
   * Engagement score 0-100 from the analysis review.
   *
   * @generated from field: int32 overall_score = 5;
   */
  overallScore?: number;

  /**
   * One-sentence review verdict.
   *
   * @generated from field: string verdict = 6;
   */
  verdict?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GeneratedBrainAnalysis.
 * Use `create(GeneratedBrainAnalysisSchema)` to create a new message.
 */
export const GeneratedBrainAnalysisSchema: GenMessage<GeneratedBrainAnalysis, {jsonType: GeneratedBrainAnalysisJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 63);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.LyricWord
 */
export type LyricWord = Message<"creativefabrica.studiomediamatrix.v1.LyricWord"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: double start = 2;
   */
  start: number;

  /**
   * @generated from field: double end = 3;
   */
  end: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LyricWordType type = 4;
   */
  type: LyricWordType;

  /**
   * @generated from field: string speaker_id = 5;
   */
  speakerId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.LyricWord
 */
export type LyricWordJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: double start = 2;
   */
  start?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double end = 3;
   */
  end?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LyricWordType type = 4;
   */
  type?: LyricWordTypeJson;

  /**
   * @generated from field: string speaker_id = 5;
   */
  speakerId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.LyricWord.
 * Use `create(LyricWordSchema)` to create a new message.
 */
export const LyricWordSchema: GenMessage<LyricWord, {jsonType: LyricWordJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 64);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedLyrics
 */
export type GeneratedLyrics = Message<"creativefabrica.studiomediamatrix.v1.GeneratedLyrics"> & {
  /**
   * @generated from field: string generating_user = 1;
   */
  generatingUser: string;

  /**
   * @generated from field: repeated string speakers = 2;
   */
  speakers: string[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.LyricWord words = 3;
   */
  words: LyricWord[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedLyrics
 */
export type GeneratedLyricsJson = {
  /**
   * @generated from field: string generating_user = 1;
   */
  generatingUser?: string;

  /**
   * @generated from field: repeated string speakers = 2;
   */
  speakers?: string[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.LyricWord words = 3;
   */
  words?: LyricWordJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GeneratedLyrics.
 * Use `create(GeneratedLyricsSchema)` to create a new message.
 */
export const GeneratedLyricsSchema: GenMessage<GeneratedLyrics, {jsonType: GeneratedLyricsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 65);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaMaskContent
 */
export type MediaMaskContent = Message<"creativefabrica.studiomediamatrix.v1.MediaMaskContent"> & {
  /**
   * @generated from field: string generated_mask_url = 1;
   */
  generatedMaskUrl: string;

  /**
   * @generated from field: int32 object_index = 2;
   */
  objectIndex: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaMaskContent
 */
export type MediaMaskContentJson = {
  /**
   * @generated from field: string generated_mask_url = 1;
   */
  generatedMaskUrl?: string;

  /**
   * @generated from field: int32 object_index = 2;
   */
  objectIndex?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaMaskContent.
 * Use `create(MediaMaskContentSchema)` to create a new message.
 */
export const MediaMaskContentSchema: GenMessage<MediaMaskContent, {jsonType: MediaMaskContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 66);

/**
 * MediaImageContent is a generated image carried as a media item (MEDIA_TYPE_IMAGE)
 * — the media_items counterpart of the legacy session_images row, introduced for
 * tools whose image outputs live on media_items (inpaint; targets the wider
 * session_images deprecation).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaImageContent
 */
export type MediaImageContent = Message<"creativefabrica.studiomediamatrix.v1.MediaImageContent"> & {
  /**
   * @generated from field: string generated_image_url = 1;
   */
  generatedImageUrl: string;

  /**
   * @generated from field: string generated_preview_url = 2;
   */
  generatedPreviewUrl: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 3;
   */
  generatedThumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: int32 width = 4;
   */
  width: number;

  /**
   * @generated from field: int32 height = 5;
   */
  height: number;

  /**
   * Mirrors MediaItem.is_nsfw for image items.
   *
   * @generated from field: bool is_nsfw = 6;
   */
  isNsfw: boolean;
};

/**
 * MediaImageContent is a generated image carried as a media item (MEDIA_TYPE_IMAGE)
 * — the media_items counterpart of the legacy session_images row, introduced for
 * tools whose image outputs live on media_items (inpaint; targets the wider
 * session_images deprecation).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaImageContent
 */
export type MediaImageContentJson = {
  /**
   * @generated from field: string generated_image_url = 1;
   */
  generatedImageUrl?: string;

  /**
   * @generated from field: string generated_preview_url = 2;
   */
  generatedPreviewUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 3;
   */
  generatedThumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: int32 width = 4;
   */
  width?: number;

  /**
   * @generated from field: int32 height = 5;
   */
  height?: number;

  /**
   * Mirrors MediaItem.is_nsfw for image items.
   *
   * @generated from field: bool is_nsfw = 6;
   */
  isNsfw?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaImageContent.
 * Use `create(MediaImageContentSchema)` to create a new message.
 */
export const MediaImageContentSchema: GenMessage<MediaImageContent, {jsonType: MediaImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 67);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaAudioContent
 */
export type MediaAudioContent = Message<"creativefabrica.studiomediamatrix.v1.MediaAudioContent"> & {
  /**
   * @generated from field: string generated_audio_url = 1;
   */
  generatedAudioUrl: string;

  /**
   * @generated from field: string generated_cover_image_url = 2;
   */
  generatedCoverImageUrl: string;

  /**
   * @generated from field: string generated_cover_image_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedCoverImageThumbnailUrl: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_cover_thumbnail_urls = 4;
   */
  generatedCoverThumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string generated_song_title = 5;
   */
  generatedSongTitle: string;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.GeneratedLyrics generated_lyrics = 6;
   */
  generatedLyrics?: GeneratedLyrics | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaAudioContent
 */
export type MediaAudioContentJson = {
  /**
   * @generated from field: string generated_audio_url = 1;
   */
  generatedAudioUrl?: string;

  /**
   * @generated from field: string generated_cover_image_url = 2;
   */
  generatedCoverImageUrl?: string;

  /**
   * @generated from field: string generated_cover_image_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedCoverImageThumbnailUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_cover_thumbnail_urls = 4;
   */
  generatedCoverThumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string generated_song_title = 5;
   */
  generatedSongTitle?: string;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.GeneratedLyrics generated_lyrics = 6;
   */
  generatedLyrics?: GeneratedLyricsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaAudioContent.
 * Use `create(MediaAudioContentSchema)` to create a new message.
 */
export const MediaAudioContentSchema: GenMessage<MediaAudioContent, {jsonType: MediaAudioContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 68);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaCADContent
 */
export type MediaCADContent = Message<"creativefabrica.studiomediamatrix.v1.MediaCADContent"> & {
  /**
   * @generated from field: string generated_mime_type = 1;
   */
  generatedMimeType: string;

  /**
   * @generated from field: string generated_url = 2;
   */
  generatedUrl: string;

  /**
   * @generated from field: string generated_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 4;
   */
  generatedThumbnailUrls: ThumbnailVariant[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaCADContent
 */
export type MediaCADContentJson = {
  /**
   * @generated from field: string generated_mime_type = 1;
   */
  generatedMimeType?: string;

  /**
   * @generated from field: string generated_url = 2;
   */
  generatedUrl?: string;

  /**
   * @generated from field: string generated_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 4;
   */
  generatedThumbnailUrls?: ThumbnailVariantJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaCADContent.
 * Use `create(MediaCADContentSchema)` to create a new message.
 */
export const MediaCADContentSchema: GenMessage<MediaCADContent, {jsonType: MediaCADContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 69);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaMeshContent
 */
export type MediaMeshContent = Message<"creativefabrica.studiomediamatrix.v1.MediaMeshContent"> & {
  /**
   * @generated from field: string generated_mime_type = 1;
   */
  generatedMimeType: string;

  /**
   * @generated from field: string generated_url = 2;
   */
  generatedUrl: string;

  /**
   * @generated from field: string generated_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl: string;

  /**
   * @generated from field: string generated_optimized_url = 4;
   */
  generatedOptimizedUrl: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 5;
   */
  generatedThumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string generated_stl_url = 6;
   */
  generatedStlUrl: string;

  /**
   * @generated from field: repeated string split_geometry_urls = 7;
   */
  splitGeometryUrls: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaMeshContent
 */
export type MediaMeshContentJson = {
  /**
   * @generated from field: string generated_mime_type = 1;
   */
  generatedMimeType?: string;

  /**
   * @generated from field: string generated_url = 2;
   */
  generatedUrl?: string;

  /**
   * @generated from field: string generated_thumbnail_url = 3 [deprecated = true];
   * @deprecated
   */
  generatedThumbnailUrl?: string;

  /**
   * @generated from field: string generated_optimized_url = 4;
   */
  generatedOptimizedUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 5;
   */
  generatedThumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string generated_stl_url = 6;
   */
  generatedStlUrl?: string;

  /**
   * @generated from field: repeated string split_geometry_urls = 7;
   */
  splitGeometryUrls?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaMeshContent.
 * Use `create(MediaMeshContentSchema)` to create a new message.
 */
export const MediaMeshContentSchema: GenMessage<MediaMeshContent, {jsonType: MediaMeshContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 70);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaSplatContent
 */
export type MediaSplatContent = Message<"creativefabrica.studiomediamatrix.v1.MediaSplatContent"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl spz_urls = 1;
   */
  spzUrls: MediaSplatContentSpzUrl[];

  /**
   * @generated from field: string pano_url = 2;
   */
  panoUrl: string;

  /**
   * @generated from field: string collider_mesh_url = 3;
   */
  colliderMeshUrl: string;

  /**
   * @generated from field: string caption = 4;
   */
  caption: string;

  /**
   * @generated from field: double ground_plane_offset = 5;
   */
  groundPlaneOffset: number;

  /**
   * @generated from field: double metric_scale = 6;
   */
  metricScale: number;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 7;
   */
  generatedThumbnailUrls: ThumbnailVariant[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaSplatContent
 */
export type MediaSplatContentJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl spz_urls = 1;
   */
  spzUrls?: MediaSplatContentSpzUrlJson[];

  /**
   * @generated from field: string pano_url = 2;
   */
  panoUrl?: string;

  /**
   * @generated from field: string collider_mesh_url = 3;
   */
  colliderMeshUrl?: string;

  /**
   * @generated from field: string caption = 4;
   */
  caption?: string;

  /**
   * @generated from field: double ground_plane_offset = 5;
   */
  groundPlaneOffset?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double metric_scale = 6;
   */
  metricScale?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ThumbnailVariant generated_thumbnail_urls = 7;
   */
  generatedThumbnailUrls?: ThumbnailVariantJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaSplatContent.
 * Use `create(MediaSplatContentSchema)` to create a new message.
 */
export const MediaSplatContentSchema: GenMessage<MediaSplatContent, {jsonType: MediaSplatContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 71);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl
 */
export type MediaSplatContentSpzUrl = Message<"creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaSplatContentResolution resolution = 1;
   */
  resolution: MediaSplatContentResolution;

  /**
   * @generated from field: string spz_url = 2;
   */
  spzUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl
 */
export type MediaSplatContentSpzUrlJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaSplatContentResolution resolution = 1;
   */
  resolution?: MediaSplatContentResolutionJson;

  /**
   * @generated from field: string spz_url = 2;
   */
  spzUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaSplatContentSpzUrl.
 * Use `create(MediaSplatContentSpzUrlSchema)` to create a new message.
 */
export const MediaSplatContentSpzUrlSchema: GenMessage<MediaSplatContentSpzUrl, {jsonType: MediaSplatContentSpzUrlJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 72);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaJsonContent
 */
export type MediaJsonContent = Message<"creativefabrica.studiomediamatrix.v1.MediaJsonContent"> & {
  /**
   * @generated from field: string generated_url = 1;
   */
  generatedUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MediaJsonContent
 */
export type MediaJsonContentJson = {
  /**
   * @generated from field: string generated_url = 1;
   */
  generatedUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MediaJsonContent.
 * Use `create(MediaJsonContentSchema)` to create a new message.
 */
export const MediaJsonContentSchema: GenMessage<MediaJsonContent, {jsonType: MediaJsonContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 73);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent
 */
export type SessionRequestPromptWithImagesContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent images_content = 3;
   */
  imagesContent: SessionRequestPromptWithImagesContent_RequestImageContent[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 4;
   */
  model: ImageGeneratorModel;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent
 */
export type SessionRequestPromptWithImagesContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent images_content = 3;
   */
  imagesContent?: SessionRequestPromptWithImagesContent_RequestImageContentJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 4;
   */
  model?: ImageGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.
 * Use `create(SessionRequestPromptWithImagesContentSchema)` to create a new message.
 */
export const SessionRequestPromptWithImagesContentSchema: GenMessage<SessionRequestPromptWithImagesContent, {jsonType: SessionRequestPromptWithImagesContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 74);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent
 */
export type SessionRequestPromptWithImagesContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent
 */
export type SessionRequestPromptWithImagesContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent.RequestImageContent.
 * Use `create(SessionRequestPromptWithImagesContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestPromptWithImagesContent_RequestImageContentSchema: GenMessage<SessionRequestPromptWithImagesContent_RequestImageContent, {jsonType: SessionRequestPromptWithImagesContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 74, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ImageContent
 */
export type ImageContent = Message<"creativefabrica.studiomediamatrix.v1.ImageContent"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ImageContent
 */
export type ImageContentJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 1;
   */
  generatedImageUrls?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ImageContent.
 * Use `create(ImageContentSchema)` to create a new message.
 */
export const ImageContentSchema: GenMessage<ImageContent, {jsonType: ImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 75);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoFrame
 */
export type VideoFrame = Message<"creativefabrica.studiomediamatrix.v1.VideoFrame"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameType type = 1;
   */
  type: VideoFrameType;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameInputMediaType input_media_type = 3;
   */
  inputMediaType: VideoFrameInputMediaType;

  /**
   * Per-reference provider routing metadata echoed back from the request.
   * Currently only meaningful for PixVerse C1 reference-to-video; unset for
   * every other model/role.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType reference_type = 4;
   */
  referenceType: VideoFrameReferenceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoFrame
 */
export type VideoFrameJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameType type = 1;
   */
  type?: VideoFrameTypeJson;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameInputMediaType input_media_type = 3;
   */
  inputMediaType?: VideoFrameInputMediaTypeJson;

  /**
   * Per-reference provider routing metadata echoed back from the request.
   * Currently only meaningful for PixVerse C1 reference-to-video; unset for
   * every other model/role.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType reference_type = 4;
   */
  referenceType?: VideoFrameReferenceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoFrame.
 * Use `create(VideoFrameSchema)` to create a new message.
 */
export const VideoFrameSchema: GenMessage<VideoFrame, {jsonType: VideoFrameJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 76);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoFrameRequest
 */
export type VideoFrameRequest = Message<"creativefabrica.studiomediamatrix.v1.VideoFrameRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameType type = 1;
   */
  type: VideoFrameType;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: string ref = 4;
   */
  ref: string;

  /**
   * Client-asserted media duration in whole seconds. Required for REFERENCE
   * frames whose file is a video (Seedance 2.0 reference videos): coins are
   * reserved at session initiation — before the upload — and reference-video
   * seconds are billed on top of the output duration, so the price needs the
   * duration up front. The server validates the asserted values against the
   * per-model limits (2–15s each, ≤15s combined) at initiation, then probes
   * the uploaded file and fails the generation (refunding the reservation)
   * when the probed duration does not match the assertion. Ignored for
   * image frames; optional for audio frames.
   *
   * @generated from field: optional int32 duration_seconds = 5;
   */
  durationSeconds?: number | undefined;

  /**
   * Per-reference provider routing metadata for typed references. Currently
   * only PixVerse C1 reference-to-video consumes it: a REFERENCE image is
   * routed as the video's subject or background. Unspecified defaults to
   * background. Ignored for every other model/role.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType reference_type = 6;
   */
  referenceType?: VideoFrameReferenceType | undefined;

  /**
   * Client-asserted pixel dimensions of the source clip, for models whose
   * price depends on the input's resolution tier rather than the output's.
   * Required for the Gemini Omni Flash 1.1 video-extension ATTACHMENT frame:
   * the extension inherits the source geometry, so the tier — and therefore
   * the coin cost — comes from the source, and coins are reserved at session
   * initiation, before the upload exists. The server maps them onto a tier by
   * SHORT edge, rounding up, then probes the uploaded file and fails the
   * generation (releasing the reservation) when the probed tier does not
   * match the assertion, so a 4k clip cannot be declared as 720p. Ignored by
   * every other model and role.
   *
   * @generated from field: optional int32 width = 7;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional int32 height = 8;
   */
  height?: number | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoFrameRequest
 */
export type VideoFrameRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoFrameType type = 1;
   */
  type?: VideoFrameTypeJson;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName?: string;

  /**
   * @generated from field: string ref = 4;
   */
  ref?: string;

  /**
   * Client-asserted media duration in whole seconds. Required for REFERENCE
   * frames whose file is a video (Seedance 2.0 reference videos): coins are
   * reserved at session initiation — before the upload — and reference-video
   * seconds are billed on top of the output duration, so the price needs the
   * duration up front. The server validates the asserted values against the
   * per-model limits (2–15s each, ≤15s combined) at initiation, then probes
   * the uploaded file and fails the generation (refunding the reservation)
   * when the probed duration does not match the assertion. Ignored for
   * image frames; optional for audio frames.
   *
   * @generated from field: optional int32 duration_seconds = 5;
   */
  durationSeconds?: number;

  /**
   * Per-reference provider routing metadata for typed references. Currently
   * only PixVerse C1 reference-to-video consumes it: a REFERENCE image is
   * routed as the video's subject or background. Unspecified defaults to
   * background. Ignored for every other model/role.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType reference_type = 6;
   */
  referenceType?: VideoFrameReferenceTypeJson;

  /**
   * Client-asserted pixel dimensions of the source clip, for models whose
   * price depends on the input's resolution tier rather than the output's.
   * Required for the Gemini Omni Flash 1.1 video-extension ATTACHMENT frame:
   * the extension inherits the source geometry, so the tier — and therefore
   * the coin cost — comes from the source, and coins are reserved at session
   * initiation, before the upload exists. The server maps them onto a tier by
   * SHORT edge, rounding up, then probes the uploaded file and fails the
   * generation (releasing the reservation) when the probed tier does not
   * match the assertion, so a 4k clip cannot be declared as 720p. Ignored by
   * every other model and role.
   *
   * @generated from field: optional int32 width = 7;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 8;
   */
  height?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoFrameRequest.
 * Use `create(VideoFrameRequestSchema)` to create a new message.
 */
export const VideoFrameRequestSchema: GenMessage<VideoFrameRequest, {jsonType: VideoFrameRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 77);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptWithImagesContent
 */
export type PromptWithImagesContent = Message<"creativefabrica.studiomediamatrix.v1.PromptWithImagesContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 2;
   */
  imageContent?: ImageContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 3;
   */
  model: ImageGeneratorModel;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PromptWithImagesContent
 */
export type PromptWithImagesContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 2;
   */
  imageContent?: ImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 3;
   */
  model?: ImageGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PromptWithImagesContent.
 * Use `create(PromptWithImagesContentSchema)` to create a new message.
 */
export const PromptWithImagesContentSchema: GenMessage<PromptWithImagesContent, {jsonType: PromptWithImagesContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 78);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedImageURL
 */
export type GeneratedImageURL = Message<"creativefabrica.studiomediamatrix.v1.GeneratedImageURL"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GeneratedImageURL
 */
export type GeneratedImageURLJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GeneratedImageURL.
 * Use `create(GeneratedImageURLSchema)` to create a new message.
 */
export const GeneratedImageURLSchema: GenMessage<GeneratedImageURL, {jsonType: GeneratedImageURLJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 79);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig
 */
export type SpeechGeneratorConfig = Message<"creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Voice voices = 1;
   */
  voices: Voice[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig
 */
export type SpeechGeneratorConfigJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Voice voices = 1;
   */
  voices?: VoiceJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig.
 * Use `create(SpeechGeneratorConfigSchema)` to create a new message.
 */
export const SpeechGeneratorConfigSchema: GenMessage<SpeechGeneratorConfig, {jsonType: SpeechGeneratorConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 80);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Voice
 */
export type Voice = Message<"creativefabrica.studiomediamatrix.v1.Voice"> & {
  /**
   * @generated from field: string voice_id = 1;
   */
  voiceId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: optional string preview_url = 4;
   */
  previewUrl?: string | undefined;

  /**
   * Primary language code (e.g. "en").
   *
   * @generated from field: optional string language = 5;
   */
  language?: string | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VoiceLabels labels = 6;
   */
  labels?: VoiceLabels | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VerifiedLanguage verified_languages = 7;
   */
  verifiedLanguages: VerifiedLanguage[];

  /**
   * Vendor catalog category (e.g. "premade", "professional", "generated").
   *
   * @generated from field: optional string category = 8;
   */
  category?: string | undefined;

  /**
   * Public URL of the voice's avatar thumbnail, omitted when the voice has no avatar.
   *
   * @generated from field: optional string avatar_url = 9;
   */
  avatarUrl?: string | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Voice
 */
export type VoiceJson = {
  /**
   * @generated from field: string voice_id = 1;
   */
  voiceId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string preview_url = 4;
   */
  previewUrl?: string;

  /**
   * Primary language code (e.g. "en").
   *
   * @generated from field: optional string language = 5;
   */
  language?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VoiceLabels labels = 6;
   */
  labels?: VoiceLabelsJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VerifiedLanguage verified_languages = 7;
   */
  verifiedLanguages?: VerifiedLanguageJson[];

  /**
   * Vendor catalog category (e.g. "premade", "professional", "generated").
   *
   * @generated from field: optional string category = 8;
   */
  category?: string;

  /**
   * Public URL of the voice's avatar thumbnail, omitted when the voice has no avatar.
   *
   * @generated from field: optional string avatar_url = 9;
   */
  avatarUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Voice.
 * Use `create(VoiceSchema)` to create a new message.
 */
export const VoiceSchema: GenMessage<Voice, {jsonType: VoiceJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 81);

/**
 * VoiceLabels carries the curated vendor labels used for filtering and
 * display. Values are canonical lowercase ids (e.g. "female", "middle_aged",
 * "narration"); clients resolve display names themselves.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VoiceLabels
 */
export type VoiceLabels = Message<"creativefabrica.studiomediamatrix.v1.VoiceLabels"> & {
  /**
   * @generated from field: optional string gender = 1;
   */
  gender?: string | undefined;

  /**
   * @generated from field: optional string age = 2;
   */
  age?: string | undefined;

  /**
   * @generated from field: optional string accent = 3;
   */
  accent?: string | undefined;

  /**
   * @generated from field: optional string use_case = 4;
   */
  useCase?: string | undefined;
};

/**
 * VoiceLabels carries the curated vendor labels used for filtering and
 * display. Values are canonical lowercase ids (e.g. "female", "middle_aged",
 * "narration"); clients resolve display names themselves.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VoiceLabels
 */
export type VoiceLabelsJson = {
  /**
   * @generated from field: optional string gender = 1;
   */
  gender?: string;

  /**
   * @generated from field: optional string age = 2;
   */
  age?: string;

  /**
   * @generated from field: optional string accent = 3;
   */
  accent?: string;

  /**
   * @generated from field: optional string use_case = 4;
   */
  useCase?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VoiceLabels.
 * Use `create(VoiceLabelsSchema)` to create a new message.
 */
export const VoiceLabelsSchema: GenMessage<VoiceLabels, {jsonType: VoiceLabelsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 82);

/**
 * VerifiedLanguage describes one language a voice is verified for, with the
 * accent it speaks it in and a per-language audition preview.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VerifiedLanguage
 */
export type VerifiedLanguage = Message<"creativefabrica.studiomediamatrix.v1.VerifiedLanguage"> & {
  /**
   * @generated from field: string language = 1;
   */
  language: string;

  /**
   * @generated from field: optional string locale = 2;
   */
  locale?: string | undefined;

  /**
   * @generated from field: optional string accent = 3;
   */
  accent?: string | undefined;

  /**
   * @generated from field: optional string preview_url = 4;
   */
  previewUrl?: string | undefined;
};

/**
 * VerifiedLanguage describes one language a voice is verified for, with the
 * accent it speaks it in and a per-language audition preview.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VerifiedLanguage
 */
export type VerifiedLanguageJson = {
  /**
   * @generated from field: string language = 1;
   */
  language?: string;

  /**
   * @generated from field: optional string locale = 2;
   */
  locale?: string;

  /**
   * @generated from field: optional string accent = 3;
   */
  accent?: string;

  /**
   * @generated from field: optional string preview_url = 4;
   */
  previewUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VerifiedLanguage.
 * Use `create(VerifiedLanguageSchema)` to create a new message.
 */
export const VerifiedLanguageSchema: GenMessage<VerifiedLanguage, {jsonType: VerifiedLanguageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 83);

/**
 * SpeechVoiceFilterOptions aggregates the distinct filter values present in
 * the voice catalog. Values are canonical ids; accents are grouped per
 * language code.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions
 */
export type SpeechVoiceFilterOptions = Message<"creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions"> & {
  /**
   * @generated from field: repeated string gender = 1;
   */
  gender: string[];

  /**
   * @generated from field: repeated string age = 2;
   */
  age: string[];

  /**
   * @generated from field: repeated string language = 3;
   */
  language: string[];

  /**
   * @generated from field: repeated string use_case = 4;
   */
  useCase: string[];

  /**
   * @generated from field: map<string, creativefabrica.studiomediamatrix.v1.AccentList> accents_by_language = 5;
   */
  accentsByLanguage: { [key: string]: AccentList };
};

/**
 * SpeechVoiceFilterOptions aggregates the distinct filter values present in
 * the voice catalog. Values are canonical ids; accents are grouped per
 * language code.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions
 */
export type SpeechVoiceFilterOptionsJson = {
  /**
   * @generated from field: repeated string gender = 1;
   */
  gender?: string[];

  /**
   * @generated from field: repeated string age = 2;
   */
  age?: string[];

  /**
   * @generated from field: repeated string language = 3;
   */
  language?: string[];

  /**
   * @generated from field: repeated string use_case = 4;
   */
  useCase?: string[];

  /**
   * @generated from field: map<string, creativefabrica.studiomediamatrix.v1.AccentList> accents_by_language = 5;
   */
  accentsByLanguage?: { [key: string]: AccentListJson };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions.
 * Use `create(SpeechVoiceFilterOptionsSchema)` to create a new message.
 */
export const SpeechVoiceFilterOptionsSchema: GenMessage<SpeechVoiceFilterOptions, {jsonType: SpeechVoiceFilterOptionsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 84);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AccentList
 */
export type AccentList = Message<"creativefabrica.studiomediamatrix.v1.AccentList"> & {
  /**
   * @generated from field: repeated string accents = 1;
   */
  accents: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AccentList
 */
export type AccentListJson = {
  /**
   * @generated from field: repeated string accents = 1;
   */
  accents?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AccentList.
 * Use `create(AccentListSchema)` to create a new message.
 */
export const AccentListSchema: GenMessage<AccentList, {jsonType: AccentListJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 85);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InternalRequestImageContent
 */
export type InternalRequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.InternalRequestImageContent"> & {
  /**
   * @generated from field: repeated string url = 1;
   */
  url: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InternalRequestImageContent
 */
export type InternalRequestImageContentJson = {
  /**
   * @generated from field: repeated string url = 1;
   */
  url?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InternalRequestImageContent.
 * Use `create(InternalRequestImageContentSchema)` to create a new message.
 */
export const InternalRequestImageContentSchema: GenMessage<InternalRequestImageContent, {jsonType: InternalRequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 86);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent
 */
export type SessionRequestSourceFromImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: repeated string image_urls = 2;
   */
  imageUrls: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent
 */
export type SessionRequestSourceFromImageContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: repeated string image_urls = 2;
   */
  imageUrls?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent.
 * Use `create(SessionRequestSourceFromImageContentSchema)` to create a new message.
 */
export const SessionRequestSourceFromImageContentSchema: GenMessage<SessionRequestSourceFromImageContent, {jsonType: SessionRequestSourceFromImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 87);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ColorDescription
 */
export type ColorDescription = Message<"creativefabrica.studiomediamatrix.v1.ColorDescription"> & {
  /**
   * @generated from field: string hex_color = 1;
   */
  hexColor: string;

  /**
   * @generated from field: repeated string adjectives = 2;
   */
  adjectives: string[];

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string suggested_usage = 4;
   */
  suggestedUsage: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ColorDescription
 */
export type ColorDescriptionJson = {
  /**
   * @generated from field: string hex_color = 1;
   */
  hexColor?: string;

  /**
   * @generated from field: repeated string adjectives = 2;
   */
  adjectives?: string[];

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string suggested_usage = 4;
   */
  suggestedUsage?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ColorDescription.
 * Use `create(ColorDescriptionSchema)` to create a new message.
 */
export const ColorDescriptionSchema: GenMessage<ColorDescription, {jsonType: ColorDescriptionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 88);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIPhotoStyle
 */
export type AIPhotoStyle = Message<"creativefabrica.studiomediamatrix.v1.AIPhotoStyle"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * it might be empty
   *
   * @generated from field: optional string reference_image_url = 4;
   */
  referenceImageUrl?: string | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleModel ai_model = 5;
   */
  aiModel: AIPhotoStyleModel;

  /**
   * @generated from field: int64 price_in_coins = 6;
   */
  priceInCoins: bigint;

  /**
   * @generated from field: int64 reference_image_width = 7;
   */
  referenceImageWidth: bigint;

  /**
   * @generated from field: int64 reference_image_height = 8;
   */
  referenceImageHeight: bigint;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIPhotoStyle
 */
export type AIPhotoStyleJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * it might be empty
   *
   * @generated from field: optional string reference_image_url = 4;
   */
  referenceImageUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleModel ai_model = 5;
   */
  aiModel?: AIPhotoStyleModelJson;

  /**
   * @generated from field: int64 price_in_coins = 6;
   */
  priceInCoins?: string;

  /**
   * @generated from field: int64 reference_image_width = 7;
   */
  referenceImageWidth?: string;

  /**
   * @generated from field: int64 reference_image_height = 8;
   */
  referenceImageHeight?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AIPhotoStyle.
 * Use `create(AIPhotoStyleSchema)` to create a new message.
 */
export const AIPhotoStyleSchema: GenMessage<AIPhotoStyle, {jsonType: AIPhotoStyleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 89);

/**
 * YouTubeThumbnailTemplate contains only public display metadata. The curated
 * generation prompt is stored and resolved server-side.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate
 */
export type YouTubeThumbnailTemplate = Message<"creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: optional string preview_image_url = 4;
   */
  previewImageUrl?: string | undefined;

  /**
   * @generated from field: int64 preview_image_width = 5;
   */
  previewImageWidth: bigint;

  /**
   * @generated from field: int64 preview_image_height = 6;
   */
  previewImageHeight: bigint;
};

/**
 * YouTubeThumbnailTemplate contains only public display metadata. The curated
 * generation prompt is stored and resolved server-side.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate
 */
export type YouTubeThumbnailTemplateJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string preview_image_url = 4;
   */
  previewImageUrl?: string;

  /**
   * @generated from field: int64 preview_image_width = 5;
   */
  previewImageWidth?: string;

  /**
   * @generated from field: int64 preview_image_height = 6;
   */
  previewImageHeight?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate.
 * Use `create(YouTubeThumbnailTemplateSchema)` to create a new message.
 */
export const YouTubeThumbnailTemplateSchema: GenMessage<YouTubeThumbnailTemplate, {jsonType: YouTubeThumbnailTemplateJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 90);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter
 */
export type ToonFamilyCharacter = Message<"creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: bool has_image = 3;
   */
  hasImage: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter
 */
export type ToonFamilyCharacterJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: bool has_image = 3;
   */
  hasImage?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter.
 * Use `create(ToonFamilyCharacterSchema)` to create a new message.
 */
export const ToonFamilyCharacterSchema: GenMessage<ToonFamilyCharacter, {jsonType: ToonFamilyCharacterJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 91);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyPet
 */
export type ToonFamilyPet = Message<"creativefabrica.studiomediamatrix.v1.ToonFamilyPet"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: bool has_image = 3;
   */
  hasImage: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyPet
 */
export type ToonFamilyPetJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: bool has_image = 3;
   */
  hasImage?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ToonFamilyPet.
 * Use `create(ToonFamilyPetSchema)` to create a new message.
 */
export const ToonFamilyPetSchema: GenMessage<ToonFamilyPet, {jsonType: ToonFamilyPetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 92);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyContent
 */
export type ToonFamilyContent = Message<"creativefabrica.studiomediamatrix.v1.ToonFamilyContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyStyle style = 1;
   */
  style: ToonFamilyStyle;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter characters = 3;
   */
  characters: ToonFamilyCharacter[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyPet pet = 4;
   */
  pet?: ToonFamilyPet | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 5;
   */
  generatedImageUrls: GeneratedImageURL[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ToonFamilyContent
 */
export type ToonFamilyContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyStyle style = 1;
   */
  style?: ToonFamilyStyleJson;

  /**
   * @generated from field: string topic = 2;
   */
  topic?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ToonFamilyCharacter characters = 3;
   */
  characters?: ToonFamilyCharacterJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyPet pet = 4;
   */
  pet?: ToonFamilyPetJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_urls = 5;
   */
  generatedImageUrls?: GeneratedImageURLJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ToonFamilyContent.
 * Use `create(ToonFamilyContentSchema)` to create a new message.
 */
export const ToonFamilyContentSchema: GenMessage<ToonFamilyContent, {jsonType: ToonFamilyContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 93);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent
 */
export type SessionRequestToonFamilyContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyStyle style = 2;
   */
  style: ToonFamilyStyle;

  /**
   * @generated from field: string topic = 3;
   */
  topic: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter characters = 4;
   */
  characters: SessionRequestToonFamilyCharacter[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet pet = 5;
   */
  pet?: SessionRequestToonFamilyPet | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent
 */
export type SessionRequestToonFamilyContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyStyle style = 2;
   */
  style?: ToonFamilyStyleJson;

  /**
   * @generated from field: string topic = 3;
   */
  topic?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter characters = 4;
   */
  characters?: SessionRequestToonFamilyCharacterJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet pet = 5;
   */
  pet?: SessionRequestToonFamilyPetJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent.
 * Use `create(SessionRequestToonFamilyContentSchema)` to create a new message.
 */
export const SessionRequestToonFamilyContentSchema: GenMessage<SessionRequestToonFamilyContent, {jsonType: SessionRequestToonFamilyContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 94);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter
 */
export type SessionRequestToonFamilyCharacter = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestToonFamilyCharacter_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter
 */
export type SessionRequestToonFamilyCharacterJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestToonFamilyCharacter_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.
 * Use `create(SessionRequestToonFamilyCharacterSchema)` to create a new message.
 */
export const SessionRequestToonFamilyCharacterSchema: GenMessage<SessionRequestToonFamilyCharacter, {jsonType: SessionRequestToonFamilyCharacterJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 95);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent
 */
export type SessionRequestToonFamilyCharacter_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent
 */
export type SessionRequestToonFamilyCharacter_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyCharacter.RequestImageContent.
 * Use `create(SessionRequestToonFamilyCharacter_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestToonFamilyCharacter_RequestImageContentSchema: GenMessage<SessionRequestToonFamilyCharacter_RequestImageContent, {jsonType: SessionRequestToonFamilyCharacter_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 95, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet
 */
export type SessionRequestToonFamilyPet = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestToonFamilyPet_RequestImageContent | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet
 */
export type SessionRequestToonFamilyPetJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent image_content = 3;
   */
  imageContent?: SessionRequestToonFamilyPet_RequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.
 * Use `create(SessionRequestToonFamilyPetSchema)` to create a new message.
 */
export const SessionRequestToonFamilyPetSchema: GenMessage<SessionRequestToonFamilyPet, {jsonType: SessionRequestToonFamilyPetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 96);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent
 */
export type SessionRequestToonFamilyPet_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent
 */
export type SessionRequestToonFamilyPet_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyPet.RequestImageContent.
 * Use `create(SessionRequestToonFamilyPet_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestToonFamilyPet_RequestImageContentSchema: GenMessage<SessionRequestToonFamilyPet_RequestImageContent, {jsonType: SessionRequestToonFamilyPet_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 96, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ThumbnailVariant
 */
export type ThumbnailVariant = Message<"creativefabrica.studiomediamatrix.v1.ThumbnailVariant"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ThumbnailVariant
 */
export type ThumbnailVariantJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ThumbnailVariant.
 * Use `create(ThumbnailVariantSchema)` to create a new message.
 */
export const ThumbnailVariantSchema: GenMessage<ThumbnailVariant, {jsonType: ThumbnailVariantJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 97);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.LogoGeneratorContent
 */
export type LogoGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.LogoGeneratorContent"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle style = 2;
   */
  style: LogoGeneratorStyle;

  /**
   * @generated from field: string hex_code_color = 3;
   */
  hexCodeColor: string;

  /**
   * @generated from field: optional string background_hex_code_color = 4;
   */
  backgroundHexCodeColor?: string | undefined;

  /**
   * @generated from field: string additional_info = 5;
   */
  additionalInfo: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 6;
   */
  generatedImageUrl?: GeneratedImageURL | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.LogoGeneratorContent
 */
export type LogoGeneratorContentJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle style = 2;
   */
  style?: LogoGeneratorStyleJson;

  /**
   * @generated from field: string hex_code_color = 3;
   */
  hexCodeColor?: string;

  /**
   * @generated from field: optional string background_hex_code_color = 4;
   */
  backgroundHexCodeColor?: string;

  /**
   * @generated from field: string additional_info = 5;
   */
  additionalInfo?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL generated_image_url = 6;
   */
  generatedImageUrl?: GeneratedImageURLJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.LogoGeneratorContent.
 * Use `create(LogoGeneratorContentSchema)` to create a new message.
 */
export const LogoGeneratorContentSchema: GenMessage<LogoGeneratorContent, {jsonType: LogoGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 98);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent
 */
export type SessionRequestLogoGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle style = 3;
   */
  style: LogoGeneratorStyle;

  /**
   * @generated from field: string hex_code_color = 4;
   */
  hexCodeColor: string;

  /**
   * @generated from field: optional string background_hex_code_color = 5;
   */
  backgroundHexCodeColor?: string | undefined;

  /**
   * @generated from field: string additional_info = 6;
   */
  additionalInfo: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent
 */
export type SessionRequestLogoGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle style = 3;
   */
  style?: LogoGeneratorStyleJson;

  /**
   * @generated from field: string hex_code_color = 4;
   */
  hexCodeColor?: string;

  /**
   * @generated from field: optional string background_hex_code_color = 5;
   */
  backgroundHexCodeColor?: string;

  /**
   * @generated from field: string additional_info = 6;
   */
  additionalInfo?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent.
 * Use `create(SessionRequestLogoGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestLogoGeneratorContentSchema: GenMessage<SessionRequestLogoGeneratorContent, {jsonType: SessionRequestLogoGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 99);

/**
 * VideoUpscalerFluxVideoUpscaleConfig carries the FLUX Video Upscale knobs (the
 * model enum stays the discriminator). Both enter the price: the output frame
 * is the source frame scaled by upscale_factor, and creativity sets the rate.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig
 */
export type VideoUpscalerFluxVideoUpscaleConfig = Message<"creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig"> & {
  /**
   * Output scaling relative to the source resolution, aspect ratio preserved;
   * 1.5 to 3 when set, 0 = the genai default (2). The vendor caps the output
   * frame at about 14 megapixels, so a large source is upscaled by less than
   * the requested factor.
   *
   * @generated from field: double upscale_factor = 1;
   */
  upscaleFactor: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleCreativity creativity = 2;
   */
  creativity: VideoUpscalerFluxVideoUpscaleCreativity;
};

/**
 * VideoUpscalerFluxVideoUpscaleConfig carries the FLUX Video Upscale knobs (the
 * model enum stays the discriminator). Both enter the price: the output frame
 * is the source frame scaled by upscale_factor, and creativity sets the rate.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig
 */
export type VideoUpscalerFluxVideoUpscaleConfigJson = {
  /**
   * Output scaling relative to the source resolution, aspect ratio preserved;
   * 1.5 to 3 when set, 0 = the genai default (2). The vendor caps the output
   * frame at about 14 megapixels, so a large source is upscaled by less than
   * the requested factor.
   *
   * @generated from field: double upscale_factor = 1;
   */
  upscaleFactor?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleCreativity creativity = 2;
   */
  creativity?: VideoUpscalerFluxVideoUpscaleCreativityJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig.
 * Use `create(VideoUpscalerFluxVideoUpscaleConfigSchema)` to create a new message.
 */
export const VideoUpscalerFluxVideoUpscaleConfigSchema: GenMessage<VideoUpscalerFluxVideoUpscaleConfig, {jsonType: VideoUpscalerFluxVideoUpscaleConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 100);

/**
 * VideoUpscalerByteplusEnhanceConfig carries the enhance knobs for both byteplus
 * video-enhance models (the model enum stays the tier discriminator). Zero
 * values mean "unset" and are omitted toward the vendor so its defaults apply.
 * resolution and fps enter the price (coefficient by tier x resolution x fps
 * bucket); the bitrate family and style do not.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig
 */
export type VideoUpscalerByteplusEnhanceConfig = Message<"creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceScene scene = 1;
   */
  scene: VideoUpscalerByteplusEnhanceScene;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceStyle style = 2;
   */
  style: VideoUpscalerByteplusEnhanceStyle;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceResolution resolution = 3;
   */
  resolution: VideoUpscalerByteplusEnhanceResolution;

  /**
   * Target output frame rate. 0 = keep the source frame rate (the source frame
   * rate then prices the request); 24, 30 or 60 when set
   * (>30 doubles the billing coefficient).
   *
   * @generated from field: int32 fps = 4;
   */
  fps: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceBitrateLevel bitrate_level = 5;
   */
  bitrateLevel: VideoUpscalerByteplusEnhanceBitrateLevel;

  /**
   * Target average bitrate in kbps. 0 = auto (derived from bitrate_level,
   * resolution and fps); 10-150000 when set.
   *
   * @generated from field: int32 bitrate = 6;
   */
  bitrate: number;

  /**
   * Output color depth: professional model only, 8 or 10 (0 = vendor default
   * 8). 10-bit output is encoded as H.265.
   *
   * @generated from field: int32 bit_depth = 7;
   */
  bitDepth: number;
};

/**
 * VideoUpscalerByteplusEnhanceConfig carries the enhance knobs for both byteplus
 * video-enhance models (the model enum stays the tier discriminator). Zero
 * values mean "unset" and are omitted toward the vendor so its defaults apply.
 * resolution and fps enter the price (coefficient by tier x resolution x fps
 * bucket); the bitrate family and style do not.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig
 */
export type VideoUpscalerByteplusEnhanceConfigJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceScene scene = 1;
   */
  scene?: VideoUpscalerByteplusEnhanceSceneJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceStyle style = 2;
   */
  style?: VideoUpscalerByteplusEnhanceStyleJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceResolution resolution = 3;
   */
  resolution?: VideoUpscalerByteplusEnhanceResolutionJson;

  /**
   * Target output frame rate. 0 = keep the source frame rate (the source frame
   * rate then prices the request); 24, 30 or 60 when set
   * (>30 doubles the billing coefficient).
   *
   * @generated from field: int32 fps = 4;
   */
  fps?: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceBitrateLevel bitrate_level = 5;
   */
  bitrateLevel?: VideoUpscalerByteplusEnhanceBitrateLevelJson;

  /**
   * Target average bitrate in kbps. 0 = auto (derived from bitrate_level,
   * resolution and fps); 10-150000 when set.
   *
   * @generated from field: int32 bitrate = 6;
   */
  bitrate?: number;

  /**
   * Output color depth: professional model only, 8 or 10 (0 = vendor default
   * 8). 10-bit output is encoded as H.265.
   *
   * @generated from field: int32 bit_depth = 7;
   */
  bitDepth?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig.
 * Use `create(VideoUpscalerByteplusEnhanceConfigSchema)` to create a new message.
 */
export const VideoUpscalerByteplusEnhanceConfigSchema: GenMessage<VideoUpscalerByteplusEnhanceConfig, {jsonType: VideoUpscalerByteplusEnhanceConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 101);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl
 */
export type MultipartUploadPartUrl = Message<"creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl"> & {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber: number;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl
 */
export type MultipartUploadPartUrlJson = {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber?: number;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl.
 * Use `create(MultipartUploadPartUrlSchema)` to create a new message.
 */
export const MultipartUploadPartUrlSchema: GenMessage<MultipartUploadPartUrl, {jsonType: MultipartUploadPartUrlJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 102);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MultipartUpload
 */
export type MultipartUpload = Message<"creativefabrica.studiomediamatrix.v1.MultipartUpload"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string s3_upload_id = 2;
   */
  s3UploadId: string;

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: int64 part_size = 4;
   */
  partSize: bigint;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl urls = 5;
   */
  urls: MultipartUploadPartUrl[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MultipartUpload
 */
export type MultipartUploadJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string s3_upload_id = 2;
   */
  s3UploadId?: string;

  /**
   * @generated from field: string key = 3;
   */
  key?: string;

  /**
   * @generated from field: int64 part_size = 4;
   */
  partSize?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MultipartUploadPartUrl urls = 5;
   */
  urls?: MultipartUploadPartUrlJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MultipartUpload.
 * Use `create(MultipartUploadSchema)` to create a new message.
 */
export const MultipartUploadSchema: GenMessage<MultipartUpload, {jsonType: MultipartUploadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 103);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerContent
 */
export type VideoUpscalerContent = Message<"creativefabrica.studiomediamatrix.v1.VideoUpscalerContent"> & {
  /**
   * @generated from field: int32 source_width = 1;
   */
  sourceWidth: number;

  /**
   * @generated from field: int32 source_height = 2;
   */
  sourceHeight: number;

  /**
   * @generated from field: string source_container = 3;
   */
  sourceContainer: string;

  /**
   * @generated from field: int32 source_size = 4;
   */
  sourceSize: number;

  /**
   * @generated from field: double source_duration = 5;
   */
  sourceDuration: number;

  /**
   * @generated from field: double source_frame_rate = 6;
   */
  sourceFrameRate: number;

  /**
   * @generated from field: int32 source_frame_count = 7;
   */
  sourceFrameCount: number;

  /**
   * @generated from field: int32 output_width = 8;
   */
  outputWidth: number;

  /**
   * @generated from field: int32 output_height = 9;
   */
  outputHeight: number;

  /**
   * @generated from field: double output_frame_rate = 10;
   */
  outputFrameRate: number;

  /**
   * @generated from field: string output_container = 11;
   */
  outputContainer: string;

  /**
   * @generated from field: string topaz_request_id = 12;
   */
  topazRequestId: string;

  /**
   * @generated from field: int64 estimated_cost_coins = 13;
   */
  estimatedCostCoins: bigint;

  /**
   * @generated from field: int64 estimated_time_seconds = 14;
   */
  estimatedTimeSeconds: bigint;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL upload_url = 15;
   */
  uploadUrl?: GeneratedImageURL | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 16;
   */
  model: VideoUpscalerModel;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MultipartUpload multipart_upload = 17;
   */
  multipartUpload?: MultipartUpload | undefined;

  /**
   * Set only for the byteplus video-enhance models; echoes the request config.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 18;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfig | undefined;

  /**
   * Set only for the FLUX Video Upscale model; echoes the request config.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 19;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfig | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoUpscalerContent
 */
export type VideoUpscalerContentJson = {
  /**
   * @generated from field: int32 source_width = 1;
   */
  sourceWidth?: number;

  /**
   * @generated from field: int32 source_height = 2;
   */
  sourceHeight?: number;

  /**
   * @generated from field: string source_container = 3;
   */
  sourceContainer?: string;

  /**
   * @generated from field: int32 source_size = 4;
   */
  sourceSize?: number;

  /**
   * @generated from field: double source_duration = 5;
   */
  sourceDuration?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double source_frame_rate = 6;
   */
  sourceFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 source_frame_count = 7;
   */
  sourceFrameCount?: number;

  /**
   * @generated from field: int32 output_width = 8;
   */
  outputWidth?: number;

  /**
   * @generated from field: int32 output_height = 9;
   */
  outputHeight?: number;

  /**
   * @generated from field: double output_frame_rate = 10;
   */
  outputFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string output_container = 11;
   */
  outputContainer?: string;

  /**
   * @generated from field: string topaz_request_id = 12;
   */
  topazRequestId?: string;

  /**
   * @generated from field: int64 estimated_cost_coins = 13;
   */
  estimatedCostCoins?: string;

  /**
   * @generated from field: int64 estimated_time_seconds = 14;
   */
  estimatedTimeSeconds?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL upload_url = 15;
   */
  uploadUrl?: GeneratedImageURLJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 16;
   */
  model?: VideoUpscalerModelJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MultipartUpload multipart_upload = 17;
   */
  multipartUpload?: MultipartUploadJson;

  /**
   * Set only for the byteplus video-enhance models; echoes the request config.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 18;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfigJson;

  /**
   * Set only for the FLUX Video Upscale model; echoes the request config.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 19;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoUpscalerContent.
 * Use `create(VideoUpscalerContentSchema)` to create a new message.
 */
export const VideoUpscalerContentSchema: GenMessage<VideoUpscalerContent, {jsonType: VideoUpscalerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 104);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent
 */
export type SessionRequestVideoUpscalerContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: int32 source_width = 2;
   */
  sourceWidth: number;

  /**
   * @generated from field: int32 source_height = 3;
   */
  sourceHeight: number;

  /**
   * @generated from field: string source_container = 4;
   */
  sourceContainer: string;

  /**
   * @generated from field: int32 source_size = 5;
   */
  sourceSize: number;

  /**
   * @generated from field: double source_duration = 6;
   */
  sourceDuration: number;

  /**
   * @generated from field: double source_frame_rate = 7;
   */
  sourceFrameRate: number;

  /**
   * @generated from field: int32 source_frame_count = 8;
   */
  sourceFrameCount: number;

  /**
   * @generated from field: int32 output_width = 9;
   */
  outputWidth: number;

  /**
   * @generated from field: int32 output_height = 10;
   */
  outputHeight: number;

  /**
   * @generated from field: double output_frame_rate = 11;
   */
  outputFrameRate: number;

  /**
   * @generated from field: string output_container = 12;
   */
  outputContainer: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent video_content = 13;
   */
  videoContent?: SessionRequestVideoUpscalerContent_RequestVideoContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 14;
   */
  model: VideoUpscalerModel;

  /**
   * Required semantics for the byteplus video-enhance models only; ignored
   * for the Topaz models. The `model` field stays the discriminator.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 15;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfig | undefined;

  /**
   * Semantics for the FLUX Video Upscale model only; ignored for the others.
   * Unset resolves every knob to its genai default.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 16;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfig | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent
 */
export type SessionRequestVideoUpscalerContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: int32 source_width = 2;
   */
  sourceWidth?: number;

  /**
   * @generated from field: int32 source_height = 3;
   */
  sourceHeight?: number;

  /**
   * @generated from field: string source_container = 4;
   */
  sourceContainer?: string;

  /**
   * @generated from field: int32 source_size = 5;
   */
  sourceSize?: number;

  /**
   * @generated from field: double source_duration = 6;
   */
  sourceDuration?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double source_frame_rate = 7;
   */
  sourceFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 source_frame_count = 8;
   */
  sourceFrameCount?: number;

  /**
   * @generated from field: int32 output_width = 9;
   */
  outputWidth?: number;

  /**
   * @generated from field: int32 output_height = 10;
   */
  outputHeight?: number;

  /**
   * @generated from field: double output_frame_rate = 11;
   */
  outputFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string output_container = 12;
   */
  outputContainer?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent video_content = 13;
   */
  videoContent?: SessionRequestVideoUpscalerContent_RequestVideoContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 14;
   */
  model?: VideoUpscalerModelJson;

  /**
   * Required semantics for the byteplus video-enhance models only; ignored
   * for the Topaz models. The `model` field stays the discriminator.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 15;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfigJson;

  /**
   * Semantics for the FLUX Video Upscale model only; ignored for the others.
   * Unset resolves every knob to its genai default.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 16;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.
 * Use `create(SessionRequestVideoUpscalerContentSchema)` to create a new message.
 */
export const SessionRequestVideoUpscalerContentSchema: GenMessage<SessionRequestVideoUpscalerContent, {jsonType: SessionRequestVideoUpscalerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 105);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent
 */
export type SessionRequestVideoUpscalerContent_RequestVideoContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent
 */
export type SessionRequestVideoUpscalerContent_RequestVideoContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent.RequestVideoContent.
 * Use `create(SessionRequestVideoUpscalerContent_RequestVideoContentSchema)` to create a new message.
 */
export const SessionRequestVideoUpscalerContent_RequestVideoContentSchema: GenMessage<SessionRequestVideoUpscalerContent_RequestVideoContent, {jsonType: SessionRequestVideoUpscalerContent_RequestVideoContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 105, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig
 */
export type HappyhorseVideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditResolution resolution = 1;
   */
  resolution: HappyhorseVideoEditResolution;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditAudioSetting audio_setting = 2;
   */
  audioSetting: HappyhorseVideoEditAudioSetting;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig
 */
export type HappyhorseVideoEditConfigJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditResolution resolution = 1;
   */
  resolution?: HappyhorseVideoEditResolutionJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditAudioSetting audio_setting = 2;
   */
  audioSetting?: HappyhorseVideoEditAudioSettingJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig.
 * Use `create(HappyhorseVideoEditConfigSchema)` to create a new message.
 */
export const HappyhorseVideoEditConfigSchema: GenMessage<HappyhorseVideoEditConfig, {jsonType: HappyhorseVideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 106);

/**
 * Gemini Omni Flash exposes no knobs (output length and resolution are
 * model-decided); presence in the model_config oneof selects the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig
 */
export type GeminiOmniFlashVideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig"> & {
};

/**
 * Gemini Omni Flash exposes no knobs (output length and resolution are
 * model-decided); presence in the model_config oneof selects the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig
 */
export type GeminiOmniFlashVideoEditConfigJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig.
 * Use `create(GeminiOmniFlashVideoEditConfigSchema)` to create a new message.
 */
export const GeminiOmniFlashVideoEditConfigSchema: GenMessage<GeminiOmniFlashVideoEditConfig, {jsonType: GeminiOmniFlashVideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 107);

/**
 * Grok Imagine 1.5 video editing exposes no knobs: xAI's /videos/edits ignores
 * duration, aspect ratio and resolution because the output inherits them from
 * the source clip (capped at 720p). Presence in the model_config oneof selects
 * the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig
 */
export type GrokImagineVideo15VideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig"> & {
};

/**
 * Grok Imagine 1.5 video editing exposes no knobs: xAI's /videos/edits ignores
 * duration, aspect ratio and resolution because the output inherits them from
 * the source clip (capped at 720p). Presence in the model_config oneof selects
 * the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig
 */
export type GrokImagineVideo15VideoEditConfigJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig.
 * Use `create(GrokImagineVideo15VideoEditConfigSchema)` to create a new message.
 */
export const GrokImagineVideo15VideoEditConfigSchema: GenMessage<GrokImagineVideo15VideoEditConfig, {jsonType: GrokImagineVideo15VideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 108);

/**
 * FLUX 3 local video editing (Black Forest Labs) exposes no knobs: the edited
 * clip inherits the source's duration, aspect ratio and frame rate, and the
 * quality tier is the model itself (Fast vs High). Shared by both tiers —
 * which oneof member carries it selects the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig
 */
export type Flux3VideoEditingVideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig"> & {
};

/**
 * FLUX 3 local video editing (Black Forest Labs) exposes no knobs: the edited
 * clip inherits the source's duration, aspect ratio and frame rate, and the
 * quality tier is the model itself (Fast vs High). Shared by both tiers —
 * which oneof member carries it selects the model.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig
 */
export type Flux3VideoEditingVideoEditConfigJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig.
 * Use `create(Flux3VideoEditingVideoEditConfigSchema)` to create a new message.
 */
export const Flux3VideoEditingVideoEditConfigSchema: GenMessage<Flux3VideoEditingVideoEditConfig, {jsonType: Flux3VideoEditingVideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 109);

/**
 * MiniMax H3 conditions a NEW clip on the uploaded source (the source rides
 * MiniMax's reference_video role — H3 has no in-place edit mode), so unlike the
 * other editor models it exposes real output knobs.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig
 */
export type MinimaxHailuoV3VideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig"> & {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_768P or _2K only. Unspecified leaves the
   * option off the request so services-genai renders its own default (2k).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution: VideoEditorResolution;

  /**
   * Output length. 4-15 when set; 0 leaves the option off the request so
   * services-genai renders its own default (5). Note both the output duration
   * and the source clip's duration are billed.
   *
   * @generated from field: int32 duration_seconds = 2;
   */
  durationSeconds: number;
};

/**
 * MiniMax H3 conditions a NEW clip on the uploaded source (the source rides
 * MiniMax's reference_video role — H3 has no in-place edit mode), so unlike the
 * other editor models it exposes real output knobs.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig
 */
export type MinimaxHailuoV3VideoEditConfigJson = {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_768P or _2K only. Unspecified leaves the
   * option off the request so services-genai renders its own default (2k).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution?: VideoEditorResolutionJson;

  /**
   * Output length. 4-15 when set; 0 leaves the option off the request so
   * services-genai renders its own default (5). Note both the output duration
   * and the source clip's duration are billed.
   *
   * @generated from field: int32 duration_seconds = 2;
   */
  durationSeconds?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig.
 * Use `create(MinimaxHailuoV3VideoEditConfigSchema)` to create a new message.
 */
export const MinimaxHailuoV3VideoEditConfigSchema: GenMessage<MinimaxHailuoV3VideoEditConfig, {jsonType: MinimaxHailuoV3VideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 110);

/**
 * WAN 3.0 edits the uploaded clip in place from a prompt instruction. Shared
 * by the standard and Prime members of the model_config oneofs — same knobs
 * and output, Prime is served on faster hardware at a higher rate.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig
 */
export type Wan30VideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig"> & {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_480P, _720P or _1080P. Unspecified leaves
   * the option off the request so services-genai renders its own default
   * (720p).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution: VideoEditorResolution;

  /**
   * Output length, 2-15. Send the source clip's duration — the edit is billed
   * on this value, and 0 leaves the option off so genai defaults to 5s, which
   * would render a shorter clip than the one uploaded.
   *
   * @generated from field: int32 duration_seconds = 2;
   */
  durationSeconds: number;

  /**
   * Output sound track. Absent leaves the option off so genai applies its own
   * default (on). Price is the same either way.
   *
   * @generated from field: optional bool generate_audio = 3;
   */
  generateAudio?: boolean | undefined;

  /**
   * Vendor prompt rewriter. Absent leaves the option off so genai applies its
   * own default (off); enabling it adds 20-60s of latency.
   *
   * @generated from field: optional bool prompt_extend = 4;
   */
  promptExtend?: boolean | undefined;
};

/**
 * WAN 3.0 edits the uploaded clip in place from a prompt instruction. Shared
 * by the standard and Prime members of the model_config oneofs — same knobs
 * and output, Prime is served on faster hardware at a higher rate.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig
 */
export type Wan30VideoEditConfigJson = {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_480P, _720P or _1080P. Unspecified leaves
   * the option off the request so services-genai renders its own default
   * (720p).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution?: VideoEditorResolutionJson;

  /**
   * Output length, 2-15. Send the source clip's duration — the edit is billed
   * on this value, and 0 leaves the option off so genai defaults to 5s, which
   * would render a shorter clip than the one uploaded.
   *
   * @generated from field: int32 duration_seconds = 2;
   */
  durationSeconds?: number;

  /**
   * Output sound track. Absent leaves the option off so genai applies its own
   * default (on). Price is the same either way.
   *
   * @generated from field: optional bool generate_audio = 3;
   */
  generateAudio?: boolean;

  /**
   * Vendor prompt rewriter. Absent leaves the option off so genai applies its
   * own default (off); enabling it adds 20-60s of latency.
   *
   * @generated from field: optional bool prompt_extend = 4;
   */
  promptExtend?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig.
 * Use `create(Wan30VideoEditConfigSchema)` to create a new message.
 */
export const Wan30VideoEditConfigSchema: GenMessage<Wan30VideoEditConfig, {jsonType: Wan30VideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 111);

/**
 * Seedance 2.5 edits the uploaded clip in place from a prompt instruction,
 * optionally conditioned on extra reference images and audio clips (the full
 * omni reference set). No duration or aspect-ratio knobs: the vendor requires
 * duration=-1 (output length follows the source, roughly equal) and
 * ratio=adaptive (output ratio follows the source).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig
 */
export type Seedance25VideoEditConfig = Message<"creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig"> & {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_480P, _720P or _1080P. Unspecified leaves
   * the option off the request so services-genai renders its own default
   * (720p).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution: VideoEditorResolution;
};

/**
 * Seedance 2.5 edits the uploaded clip in place from a prompt instruction,
 * optionally conditioned on extra reference images and audio clips (the full
 * omni reference set). No duration or aspect-ratio knobs: the vendor requires
 * duration=-1 (output length follows the source, roughly equal) and
 * ratio=adaptive (output ratio follows the source).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig
 */
export type Seedance25VideoEditConfigJson = {
  /**
   * Accepts VIDEO_EDITOR_RESOLUTION_480P, _720P or _1080P. Unspecified leaves
   * the option off the request so services-genai renders its own default
   * (720p).
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorResolution resolution = 1;
   */
  resolution?: VideoEditorResolutionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig.
 * Use `create(Seedance25VideoEditConfigSchema)` to create a new message.
 */
export const Seedance25VideoEditConfigSchema: GenMessage<Seedance25VideoEditConfig, {jsonType: Seedance25VideoEditConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 112);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorContent
 */
export type VideoEditorContent = Message<"creativefabrica.studiomediamatrix.v1.VideoEditorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_video = 2;
   */
  sourceVideo?: GeneratedImageURL | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MultipartUpload source_video_multipart_upload = 3;
   */
  sourceVideoMultipartUpload?: MultipartUpload | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 4;
   */
  referenceImages: GeneratedImageURL[];

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.VideoEditorContent.model_config
   */
  modelConfig: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 5;
     */
    value: HappyhorseVideoEditConfig;
    case: "happyhorseV1Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 7;
     */
    value: GeminiOmniFlashVideoEditConfig;
    case: "geminiOmniFlashConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 8;
     */
    value: GrokImagineVideo15VideoEditConfig;
    case: "grokImagineVideo15Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 9;
     */
    value: MinimaxHailuoV3VideoEditConfig;
    case: "minimaxHailuoV3Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 10;
     */
    value: Wan30VideoEditConfig;
    case: "wan30Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 11;
     */
    value: Wan30VideoEditConfig;
    case: "wan30PrimeConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 12;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingFastConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 13;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingHighConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 14;
     */
    value: Seedance25VideoEditConfig;
    case: "seedance25Config";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: int64 estimated_cost_coins = 6;
   */
  estimatedCostCoins: bigint;

  /**
   * Badge-only copy of source_video when the source is a watermarked output.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copy is served in source_video instead to viewers that are not
   * paid subscribers.
   *
   * @generated from field: string watermarked_source_video_url = 15;
   */
  watermarkedSourceVideoUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorContent
 */
export type VideoEditorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_video = 2;
   */
  sourceVideo?: GeneratedImageURLJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MultipartUpload source_video_multipart_upload = 3;
   */
  sourceVideoMultipartUpload?: MultipartUploadJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 4;
   */
  referenceImages?: GeneratedImageURLJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 5;
   */
  happyhorseV1Config?: HappyhorseVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 7;
   */
  geminiOmniFlashConfig?: GeminiOmniFlashVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 8;
   */
  grokImagineVideo15Config?: GrokImagineVideo15VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 9;
   */
  minimaxHailuoV3Config?: MinimaxHailuoV3VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 10;
   */
  wan30Config?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 11;
   */
  wan30PrimeConfig?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 12;
   */
  flux3VideoEditingFastConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 13;
   */
  flux3VideoEditingHighConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 14;
   */
  seedance25Config?: Seedance25VideoEditConfigJson;

  /**
   * @generated from field: int64 estimated_cost_coins = 6;
   */
  estimatedCostCoins?: string;

  /**
   * Badge-only copy of source_video when the source is a watermarked output.
   * Internal events only: always empty in RPC responses and notifications,
   * where the copy is served in source_video instead to viewers that are not
   * paid subscribers.
   *
   * @generated from field: string watermarked_source_video_url = 15;
   */
  watermarkedSourceVideoUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoEditorContent.
 * Use `create(VideoEditorContentSchema)` to create a new message.
 */
export const VideoEditorContentSchema: GenMessage<VideoEditorContent, {jsonType: VideoEditorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 113);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest
 */
export type VideoEditorUploadRequest = Message<"creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest
 */
export type VideoEditorUploadRequestJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest.
 * Use `create(VideoEditorUploadRequestSchema)` to create a new message.
 */
export const VideoEditorUploadRequestSchema: GenMessage<VideoEditorUploadRequest, {jsonType: VideoEditorUploadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 114);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest
 */
export type VideoEditorReferenceImageRequest = Message<"creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest.asset
   */
  asset: {
    /**
     * @generated from field: string existing_url = 1;
     */
    value: string;
    case: "existingUrl";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest new_upload = 2;
     */
    value: VideoEditorUploadRequest;
    case: "newUpload";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest
 */
export type VideoEditorReferenceImageRequestJson = {
  /**
   * @generated from field: string existing_url = 1;
   */
  existingUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest new_upload = 2;
   */
  newUpload?: VideoEditorUploadRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest.
 * Use `create(VideoEditorReferenceImageRequestSchema)` to create a new message.
 */
export const VideoEditorReferenceImageRequestSchema: GenMessage<VideoEditorReferenceImageRequest, {jsonType: VideoEditorReferenceImageRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 115);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent
 */
export type SessionRequestVideoEditorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest source_video = 3;
   */
  sourceVideo?: VideoEditorUploadRequest | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest reference_images = 4;
   */
  referenceImages: VideoEditorReferenceImageRequest[];

  /**
   * @generated from field: double source_duration = 6;
   */
  sourceDuration: number;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent.model_config
   */
  modelConfig: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 5;
     */
    value: HappyhorseVideoEditConfig;
    case: "happyhorseV1Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 7;
     */
    value: GeminiOmniFlashVideoEditConfig;
    case: "geminiOmniFlashConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 8;
     */
    value: GrokImagineVideo15VideoEditConfig;
    case: "grokImagineVideo15Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 9;
     */
    value: MinimaxHailuoV3VideoEditConfig;
    case: "minimaxHailuoV3Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 10;
     */
    value: Wan30VideoEditConfig;
    case: "wan30Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 11;
     */
    value: Wan30VideoEditConfig;
    case: "wan30PrimeConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 12;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingFastConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 13;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingHighConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 14;
     */
    value: Seedance25VideoEditConfig;
    case: "seedance25Config";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent
 */
export type SessionRequestVideoEditorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorUploadRequest source_video = 3;
   */
  sourceVideo?: VideoEditorUploadRequestJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest reference_images = 4;
   */
  referenceImages?: VideoEditorReferenceImageRequestJson[];

  /**
   * @generated from field: double source_duration = 6;
   */
  sourceDuration?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 5;
   */
  happyhorseV1Config?: HappyhorseVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 7;
   */
  geminiOmniFlashConfig?: GeminiOmniFlashVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 8;
   */
  grokImagineVideo15Config?: GrokImagineVideo15VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 9;
   */
  minimaxHailuoV3Config?: MinimaxHailuoV3VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 10;
   */
  wan30Config?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 11;
   */
  wan30PrimeConfig?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 12;
   */
  flux3VideoEditingFastConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 13;
   */
  flux3VideoEditingHighConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 14;
   */
  seedance25Config?: Seedance25VideoEditConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent.
 * Use `create(SessionRequestVideoEditorContentSchema)` to create a new message.
 */
export const SessionRequestVideoEditorContentSchema: GenMessage<SessionRequestVideoEditorContent, {jsonType: SessionRequestVideoEditorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 116);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent
 */
export type SessionRequestVideoEditorPromptContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest reference_images = 3;
   */
  referenceImages: VideoEditorReferenceImageRequest[];

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent.model_config
   */
  modelConfig: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 4;
     */
    value: HappyhorseVideoEditConfig;
    case: "happyhorseV1Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 5;
     */
    value: GeminiOmniFlashVideoEditConfig;
    case: "geminiOmniFlashConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 6;
     */
    value: GrokImagineVideo15VideoEditConfig;
    case: "grokImagineVideo15Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 7;
     */
    value: MinimaxHailuoV3VideoEditConfig;
    case: "minimaxHailuoV3Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 8;
     */
    value: Wan30VideoEditConfig;
    case: "wan30Config";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 9;
     */
    value: Wan30VideoEditConfig;
    case: "wan30PrimeConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 10;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingFastConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 11;
     */
    value: Flux3VideoEditingVideoEditConfig;
    case: "flux3VideoEditingHighConfig";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 12;
     */
    value: Seedance25VideoEditConfig;
    case: "seedance25Config";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent
 */
export type SessionRequestVideoEditorPromptContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoEditorReferenceImageRequest reference_images = 3;
   */
  referenceImages?: VideoEditorReferenceImageRequestJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditConfig happyhorse_v1_config = 4;
   */
  happyhorseV1Config?: HappyhorseVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeminiOmniFlashVideoEditConfig gemini_omni_flash_config = 5;
   */
  geminiOmniFlashConfig?: GeminiOmniFlashVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GrokImagineVideo15VideoEditConfig grok_imagine_video_1_5_config = 6;
   */
  grokImagineVideo15Config?: GrokImagineVideo15VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MinimaxHailuoV3VideoEditConfig minimax_hailuo_v3_config = 7;
   */
  minimaxHailuoV3Config?: MinimaxHailuoV3VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_config = 8;
   */
  wan30Config?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Wan30VideoEditConfig wan_3_0_prime_config = 9;
   */
  wan30PrimeConfig?: Wan30VideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_fast_config = 10;
   */
  flux3VideoEditingFastConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Flux3VideoEditingVideoEditConfig flux_3_video_editing_high_config = 11;
   */
  flux3VideoEditingHighConfig?: Flux3VideoEditingVideoEditConfigJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Seedance25VideoEditConfig seedance_2_5_config = 12;
   */
  seedance25Config?: Seedance25VideoEditConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent.
 * Use `create(SessionRequestVideoEditorPromptContentSchema)` to create a new message.
 */
export const SessionRequestVideoEditorPromptContentSchema: GenMessage<SessionRequestVideoEditorPromptContent, {jsonType: SessionRequestVideoEditorPromptContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 117);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintUploadRequest
 */
export type InpaintUploadRequest = Message<"creativefabrica.studiomediamatrix.v1.InpaintUploadRequest"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintUploadRequest
 */
export type InpaintUploadRequestJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InpaintUploadRequest.
 * Use `create(InpaintUploadRequestSchema)` to create a new message.
 */
export const InpaintUploadRequestSchema: GenMessage<InpaintUploadRequest, {jsonType: InpaintUploadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 118);

/**
 * A reference image for an inpaint round: keep one from an earlier round by
 * URL, or upload a new one (VideoEditorReferenceImageRequest pattern).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest
 */
export type InpaintReferenceImageRequest = Message<"creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest.asset
   */
  asset: {
    /**
     * @generated from field: string existing_url = 1;
     */
    value: string;
    case: "existingUrl";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintUploadRequest new_upload = 2;
     */
    value: InpaintUploadRequest;
    case: "newUpload";
  } | { case: undefined; value?: undefined };
};

/**
 * A reference image for an inpaint round: keep one from an earlier round by
 * URL, or upload a new one (VideoEditorReferenceImageRequest pattern).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest
 */
export type InpaintReferenceImageRequestJson = {
  /**
   * @generated from field: string existing_url = 1;
   */
  existingUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintUploadRequest new_upload = 2;
   */
  newUpload?: InpaintUploadRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest.
 * Use `create(InpaintReferenceImageRequestSchema)` to create a new message.
 */
export const InpaintReferenceImageRequestSchema: GenMessage<InpaintReferenceImageRequest, {jsonType: InpaintReferenceImageRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 119);

/**
 * InpaintScribbleColor is one drawing color, as offered in a model's palette
 * (ModelEntry.inpaint_details.scribble_colors) and as reported back on a
 * round. Structured (rather than a bare string) so future fields can bind a
 * color's marked region to a specific object or reference image — e.g. "the
 * red marks are where the product from the second image goes" — without a
 * breaking change.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintScribbleColor
 */
export type InpaintScribbleColor = Message<"creativefabrica.studiomediamatrix.v1.InpaintScribbleColor"> & {
  /**
   * Human-readable color name (e.g. "red"); injected verbatim into the
   * server-side generation prompt.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * InpaintScribbleColor is one drawing color, as offered in a model's palette
 * (ModelEntry.inpaint_details.scribble_colors) and as reported back on a
 * round. Structured (rather than a bare string) so future fields can bind a
 * color's marked region to a specific object or reference image — e.g. "the
 * red marks are where the product from the second image goes" — without a
 * breaking change.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintScribbleColor
 */
export type InpaintScribbleColorJson = {
  /**
   * Human-readable color name (e.g. "red"); injected verbatim into the
   * server-side generation prompt.
   *
   * @generated from field: string name = 1;
   */
  name?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InpaintScribbleColor.
 * Use `create(InpaintScribbleColorSchema)` to create a new message.
 */
export const InpaintScribbleColorSchema: GenMessage<InpaintScribbleColor, {jsonType: InpaintScribbleColorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 120);

/**
 * Persisted on Session.content and Iteration.content for SERVICE_TYPE_INPAINT.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintContent
 */
export type InpaintContent = Message<"creativefabrica.studiomediamatrix.v1.InpaintContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * The scribbled input image for this round: a presigned PUT target on the
   * way out, the final bucket URL once ingested. Mandatory every round.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL painted_image = 2;
   */
  paintedImage?: GeneratedImageURL | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 3;
   */
  referenceImages: GeneratedImageURL[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 4;
   */
  model: ImageGeneratorModel;

  /**
   * Scribble colors used this round, drawn from the model's palette
   * (ModelEntry.inpaint_details.scribble_colors).
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 5;
   */
  scribbleColors: InpaintScribbleColor[];

  /**
   * Server-recorded lineage: the completed output the user painted on
   * (empty on the first round). Set by the server, ignored on requests.
   *
   * @generated from field: string base_image_url = 6;
   */
  baseImageUrl: string;
};

/**
 * Persisted on Session.content and Iteration.content for SERVICE_TYPE_INPAINT.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintContent
 */
export type InpaintContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * The scribbled input image for this round: a presigned PUT target on the
   * way out, the final bucket URL once ingested. Mandatory every round.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL painted_image = 2;
   */
  paintedImage?: GeneratedImageURLJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.GeneratedImageURL reference_images = 3;
   */
  referenceImages?: GeneratedImageURLJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 4;
   */
  model?: ImageGeneratorModelJson;

  /**
   * Scribble colors used this round, drawn from the model's palette
   * (ModelEntry.inpaint_details.scribble_colors).
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 5;
   */
  scribbleColors?: InpaintScribbleColorJson[];

  /**
   * Server-recorded lineage: the completed output the user painted on
   * (empty on the first round). Set by the server, ignored on requests.
   *
   * @generated from field: string base_image_url = 6;
   */
  baseImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InpaintContent.
 * Use `create(InpaintContentSchema)` to create a new message.
 */
export const InpaintContentSchema: GenMessage<InpaintContent, {jsonType: InpaintContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 121);

/**
 * Shared by initiate AND iterate: unlike other tools, every inpaint round —
 * including iterations — requires a fresh painted-image upload (the user
 * paints on the latest completed output).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent
 */
export type SessionRequestInpaintContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintUploadRequest painted_image = 3;
   */
  paintedImage?: InpaintUploadRequest | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest reference_images = 4;
   */
  referenceImages: InpaintReferenceImageRequest[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 5;
   */
  model: ImageGeneratorModel;

  /**
   * Colors actually used in the painted image this round; each must come from
   * the model's palette.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 6;
   */
  scribbleColors: InpaintScribbleColor[];
};

/**
 * Shared by initiate AND iterate: unlike other tools, every inpaint round —
 * including iterations — requires a fresh painted-image upload (the user
 * paints on the latest completed output).
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent
 */
export type SessionRequestInpaintContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintUploadRequest painted_image = 3;
   */
  paintedImage?: InpaintUploadRequestJson;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintReferenceImageRequest reference_images = 4;
   */
  referenceImages?: InpaintReferenceImageRequestJson[];

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel model = 5;
   */
  model?: ImageGeneratorModelJson;

  /**
   * Colors actually used in the painted image this round; each must come from
   * the model's palette.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 6;
   */
  scribbleColors?: InpaintScribbleColorJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent.
 * Use `create(SessionRequestInpaintContentSchema)` to create a new message.
 */
export const SessionRequestInpaintContentSchema: GenMessage<SessionRequestInpaintContent, {jsonType: SessionRequestInpaintContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 122);

/**
 * AdBannerSize is one output size of the Ad Banner Resizer, in pixels.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.AdBannerSize
 */
export type AdBannerSize = Message<"creativefabrica.studiomediamatrix.v1.AdBannerSize"> & {
  /**
   * @generated from field: uint32 width = 1;
   */
  width: number;

  /**
   * @generated from field: uint32 height = 2;
   */
  height: number;
};

/**
 * AdBannerSize is one output size of the Ad Banner Resizer, in pixels.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.AdBannerSize
 */
export type AdBannerSizeJson = {
  /**
   * @generated from field: uint32 width = 1;
   */
  width?: number;

  /**
   * @generated from field: uint32 height = 2;
   */
  height?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AdBannerSize.
 * Use `create(AdBannerSizeSchema)` to create a new message.
 */
export const AdBannerSizeSchema: GenMessage<AdBannerSize, {jsonType: AdBannerSizeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 123);

/**
 * Persisted on Session.content and Iteration.content for
 * SERVICE_TYPE_AD_BANNER_RESIZER. A session is one source banner; every round
 * resizes that same banner to the sizes it names, one media item per size.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.AdBannerResizerContent
 */
export type AdBannerResizerContent = Message<"creativefabrica.studiomediamatrix.v1.AdBannerResizerContent"> & {
  /**
   * The upload handle of the source banner: a presigned PUT target with its
   * upload id, set only on the session returned by InitiateSession. The
   * uploaded source is read through GetSessionInputMedia; later rounds reuse
   * it.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_image = 1;
   */
  sourceImage?: GeneratedImageURL | undefined;

  /**
   * The sizes requested in this round. On the session, the first round's.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 2;
   */
  sizes: AdBannerSize[];
};

/**
 * Persisted on Session.content and Iteration.content for
 * SERVICE_TYPE_AD_BANNER_RESIZER. A session is one source banner; every round
 * resizes that same banner to the sizes it names, one media item per size.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.AdBannerResizerContent
 */
export type AdBannerResizerContentJson = {
  /**
   * The upload handle of the source banner: a presigned PUT target with its
   * upload id, set only on the session returned by InitiateSession. The
   * uploaded source is read through GetSessionInputMedia; later rounds reuse
   * it.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_image = 1;
   */
  sourceImage?: GeneratedImageURLJson;

  /**
   * The sizes requested in this round. On the session, the first round's.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 2;
   */
  sizes?: AdBannerSizeJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AdBannerResizerContent.
 * Use `create(AdBannerResizerContentSchema)` to create a new message.
 */
export const AdBannerResizerContentSchema: GenMessage<AdBannerResizerContent, {jsonType: AdBannerResizerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 124);

/**
 * Starts a session: uploads the source banner and requests the first sizes.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent
 */
export type SessionRequestAdBannerResizerContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage source_image = 2;
   */
  sourceImage?: SessionRequestAdBannerResizerContent_SourceImage | undefined;

  /**
   * At least one; a size may be named once per request.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 3;
   */
  sizes: AdBannerSize[];
};

/**
 * Starts a session: uploads the source banner and requests the first sizes.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent
 */
export type SessionRequestAdBannerResizerContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage source_image = 2;
   */
  sourceImage?: SessionRequestAdBannerResizerContent_SourceImageJson;

  /**
   * At least one; a size may be named once per request.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 3;
   */
  sizes?: AdBannerSizeJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.
 * Use `create(SessionRequestAdBannerResizerContentSchema)` to create a new message.
 */
export const SessionRequestAdBannerResizerContentSchema: GenMessage<SessionRequestAdBannerResizerContent, {jsonType: SessionRequestAdBannerResizerContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 125);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage
 */
export type SessionRequestAdBannerResizerContent_SourceImage = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage
 */
export type SessionRequestAdBannerResizerContent_SourceImageJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent.SourceImage.
 * Use `create(SessionRequestAdBannerResizerContent_SourceImageSchema)` to create a new message.
 */
export const SessionRequestAdBannerResizerContent_SourceImageSchema: GenMessage<SessionRequestAdBannerResizerContent_SourceImage, {jsonType: SessionRequestAdBannerResizerContent_SourceImageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 125, 0);

/**
 * Requests more sizes of the session's source banner. No upload: the round
 * reads the source the session already holds.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent
 */
export type SessionRequestAdBannerResizerSizesContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * At least one; a size may be named once per request.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 2;
   */
  sizes: AdBannerSize[];
};

/**
 * Requests more sizes of the session's source banner. No upload: the round
 * reads the source the session already holds.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent
 */
export type SessionRequestAdBannerResizerSizesContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * At least one; a size may be named once per request.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AdBannerSize sizes = 2;
   */
  sizes?: AdBannerSizeJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent.
 * Use `create(SessionRequestAdBannerResizerSizesContentSchema)` to create a new message.
 */
export const SessionRequestAdBannerResizerSizesContentSchema: GenMessage<SessionRequestAdBannerResizerSizesContent, {jsonType: SessionRequestAdBannerResizerSizesContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 126);

/**
 * ImportedImageSource says which tool produced an image the client imported.
 * Every field is optional — a purely client-side producer has no generation to
 * point at — but the more that is sent, the better the round can explain
 * itself.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportedImageSource
 */
export type ImportedImageSource = Message<"creativefabrica.studiomediamatrix.v1.ImportedImageSource"> & {
  /**
   * Producing tool, e.g. "outpaint", "paint", "relight", "camera_angle".
   * Free-form: the producers live outside this service.
   *
   * @generated from field: string tool = 1;
   */
  tool: string;

  /**
   * Finer-grained action within the tool.
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * services-genai generation id, when the producer was a generation.
   *
   * @generated from field: string generation_id = 3;
   */
  generationId: string;

  /**
   * Model key the producer used.
   *
   * @generated from field: string model = 4;
   */
  model: string;

  /**
   * Display text for the chat turn, e.g. "From Outpaint".
   *
   * @generated from field: string display_label = 5;
   */
  displayLabel: string;

  /**
   * Anything the typed fields do not cover — a crop box, a mask id, a seed.
   * Stored and returned verbatim; never interpreted by this service.
   *
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };
};

/**
 * ImportedImageSource says which tool produced an image the client imported.
 * Every field is optional — a purely client-side producer has no generation to
 * point at — but the more that is sent, the better the round can explain
 * itself.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportedImageSource
 */
export type ImportedImageSourceJson = {
  /**
   * Producing tool, e.g. "outpaint", "paint", "relight", "camera_angle".
   * Free-form: the producers live outside this service.
   *
   * @generated from field: string tool = 1;
   */
  tool?: string;

  /**
   * Finer-grained action within the tool.
   *
   * @generated from field: string action = 2;
   */
  action?: string;

  /**
   * services-genai generation id, when the producer was a generation.
   *
   * @generated from field: string generation_id = 3;
   */
  generationId?: string;

  /**
   * Model key the producer used.
   *
   * @generated from field: string model = 4;
   */
  model?: string;

  /**
   * Display text for the chat turn, e.g. "From Outpaint".
   *
   * @generated from field: string display_label = 5;
   */
  displayLabel?: string;

  /**
   * Anything the typed fields do not cover — a crop box, a mask id, a seed.
   * Stored and returned verbatim; never interpreted by this service.
   *
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ImportedImageSource.
 * Use `create(ImportedImageSourceSchema)` to create a new message.
 */
export const ImportedImageSourceSchema: GenMessage<ImportedImageSource, {jsonType: ImportedImageSourceJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 127);

/**
 * Persisted on Iteration.content for an ACTION_TYPE_IMPORT_IMAGE round: the
 * image the client handed us, where it came from, and the working image it
 * superseded.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportedImageContent
 */
export type ImportedImageContent = Message<"creativefabrica.studiomediamatrix.v1.ImportedImageContent"> & {
  /**
   * The imported image, copied into the session's own storage.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL image = 1;
   */
  image?: GeneratedImageURL | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageSource source = 2;
   */
  source?: ImportedImageSource | undefined;

  /**
   * Server-recorded lineage: the completed output this import superseded
   * (empty when the session had none). Set by the server, ignored on requests.
   *
   * @generated from field: string base_image_url = 3;
   */
  baseImageUrl: string;
};

/**
 * Persisted on Iteration.content for an ACTION_TYPE_IMPORT_IMAGE round: the
 * image the client handed us, where it came from, and the working image it
 * superseded.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportedImageContent
 */
export type ImportedImageContentJson = {
  /**
   * The imported image, copied into the session's own storage.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL image = 1;
   */
  image?: GeneratedImageURLJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageSource source = 2;
   */
  source?: ImportedImageSourceJson;

  /**
   * Server-recorded lineage: the completed output this import superseded
   * (empty when the session had none). Set by the server, ignored on requests.
   *
   * @generated from field: string base_image_url = 3;
   */
  baseImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ImportedImageContent.
 * Use `create(ImportedImageContentSchema)` to create a new message.
 */
export const ImportedImageContentSchema: GenMessage<ImportedImageContent, {jsonType: ImportedImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 128);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CameraAngleSettings
 */
export type CameraAngleSettings = Message<"creativefabrica.studiomediamatrix.v1.CameraAngleSettings"> & {
  /**
   * @generated from field: double azimuth = 1;
   */
  azimuth: number;

  /**
   * @generated from field: double elevation = 2;
   */
  elevation: number;

  /**
   * @generated from field: double zoom = 3;
   */
  zoom: number;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAnglePreset preset = 4;
   */
  preset: CameraAnglePreset;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CameraAngleSettings
 */
export type CameraAngleSettingsJson = {
  /**
   * @generated from field: double azimuth = 1;
   */
  azimuth?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double elevation = 2;
   */
  elevation?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double zoom = 3;
   */
  zoom?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAnglePreset preset = 4;
   */
  preset?: CameraAnglePresetJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CameraAngleSettings.
 * Use `create(CameraAngleSettingsSchema)` to create a new message.
 */
export const CameraAngleSettingsSchema: GenMessage<CameraAngleSettings, {jsonType: CameraAngleSettingsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 129);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CameraAngleContent
 */
export type CameraAngleContent = Message<"creativefabrica.studiomediamatrix.v1.CameraAngleContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_image = 1;
   */
  sourceImage?: GeneratedImageURL | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleSettings camera_angle_settings = 2;
   */
  cameraAngleSettings?: CameraAngleSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CameraAngleContent
 */
export type CameraAngleContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GeneratedImageURL source_image = 1;
   */
  sourceImage?: GeneratedImageURLJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleSettings camera_angle_settings = 2;
   */
  cameraAngleSettings?: CameraAngleSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CameraAngleContent.
 * Use `create(CameraAngleContentSchema)` to create a new message.
 */
export const CameraAngleContentSchema: GenMessage<CameraAngleContent, {jsonType: CameraAngleContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 130);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent
 */
export type SessionRequestCameraAngleContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent source_image = 2;
   */
  sourceImage?: SessionRequestCameraAngleContent_RequestImageContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleSettings camera_angle_settings = 3;
   */
  cameraAngleSettings?: CameraAngleSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent
 */
export type SessionRequestCameraAngleContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent source_image = 2;
   */
  sourceImage?: SessionRequestCameraAngleContent_RequestImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleSettings camera_angle_settings = 3;
   */
  cameraAngleSettings?: CameraAngleSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.
 * Use `create(SessionRequestCameraAngleContentSchema)` to create a new message.
 */
export const SessionRequestCameraAngleContentSchema: GenMessage<SessionRequestCameraAngleContent, {jsonType: SessionRequestCameraAngleContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 131);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent
 */
export type SessionRequestCameraAngleContent_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent
 */
export type SessionRequestCameraAngleContent_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent.RequestImageContent.
 * Use `create(SessionRequestCameraAngleContent_RequestImageContentSchema)` to create a new message.
 */
export const SessionRequestCameraAngleContent_RequestImageContentSchema: GenMessage<SessionRequestCameraAngleContent_RequestImageContent, {jsonType: SessionRequestCameraAngleContent_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 131, 0);

/**
 * MarketplaceEditor: edit images already uploaded to the marketplace via URL.
 * Initiate takes a URL + asset metadata; iterate takes only a text prompt.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata
 */
export type MarketplaceEditorAssetMetadata = Message<"creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string bundle_id = 2;
   */
  bundleId: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string asset_creator_user_id = 4;
   */
  assetCreatorUserId: string;
};

/**
 * MarketplaceEditor: edit images already uploaded to the marketplace via URL.
 * Initiate takes a URL + asset metadata; iterate takes only a text prompt.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata
 */
export type MarketplaceEditorAssetMetadataJson = {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId?: string;

  /**
   * @generated from field: string bundle_id = 2;
   */
  bundleId?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: string asset_creator_user_id = 4;
   */
  assetCreatorUserId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata.
 * Use `create(MarketplaceEditorAssetMetadataSchema)` to create a new message.
 */
export const MarketplaceEditorAssetMetadataSchema: GenMessage<MarketplaceEditorAssetMetadata, {jsonType: MarketplaceEditorAssetMetadataJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 132);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent
 */
export type MarketplaceEditorContent = Message<"creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata asset_metadata = 3;
   */
  assetMetadata?: MarketplaceEditorAssetMetadata | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent
 */
export type MarketplaceEditorContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata asset_metadata = 3;
   */
  assetMetadata?: MarketplaceEditorAssetMetadataJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent.
 * Use `create(MarketplaceEditorContentSchema)` to create a new message.
 */
export const MarketplaceEditorContentSchema: GenMessage<MarketplaceEditorContent, {jsonType: MarketplaceEditorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 133);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent
 */
export type SessionRequestMarketplaceEditorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 3;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata asset_metadata = 4;
   */
  assetMetadata?: MarketplaceEditorAssetMetadata | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent
 */
export type SessionRequestMarketplaceEditorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 3;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorAssetMetadata asset_metadata = 4;
   */
  assetMetadata?: MarketplaceEditorAssetMetadataJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent.
 * Use `create(SessionRequestMarketplaceEditorContentSchema)` to create a new message.
 */
export const SessionRequestMarketplaceEditorContentSchema: GenMessage<SessionRequestMarketplaceEditorContent, {jsonType: SessionRequestMarketplaceEditorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 134);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Notice
 */
export type Notice = Message<"creativefabrica.studiomediamatrix.v1.Notice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string object_id = 3;
   */
  objectId: string;

  /**
   * @generated from field: string object_type = 4;
   */
  objectType: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeStatus status = 5;
   */
  status: NoticeStatus;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeContent content = 6;
   */
  content?: NoticeContent | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.Notice
 */
export type NoticeJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string object_id = 3;
   */
  objectId?: string;

  /**
   * @generated from field: string object_type = 4;
   */
  objectType?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeStatus status = 5;
   */
  status?: NoticeStatusJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeContent content = 6;
   */
  content?: NoticeContentJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.Notice.
 * Use `create(NoticeSchema)` to create a new message.
 */
export const NoticeSchema: GenMessage<Notice, {jsonType: NoticeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 135);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeContent
 */
export type NoticeContent = Message<"creativefabrica.studiomediamatrix.v1.NoticeContent"> & {
  /**
   * @generated from field: string prompt_text = 1;
   */
  promptText: string;

  /**
   * @generated from field: string thumbnail_url = 2;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: int32 queue_position = 3;
   */
  queuePosition: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeContent
 */
export type NoticeContentJson = {
  /**
   * @generated from field: string prompt_text = 1;
   */
  promptText?: string;

  /**
   * @generated from field: string thumbnail_url = 2;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: int32 queue_position = 3;
   */
  queuePosition?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.NoticeContent.
 * Use `create(NoticeContentSchema)` to create a new message.
 */
export const NoticeContentSchema: GenMessage<NoticeContent, {jsonType: NoticeContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 136);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent
 */
export type AISVGGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle style = 2;
   */
  style: AISVGGeneratorStyle;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity complexity = 3;
   */
  complexity: AISVGGeneratorComplexity;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth stroke_width = 4;
   */
  strokeWidth: AISVGGeneratorStrokeWidth;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle stroke_style = 5;
   */
  strokeStyle: AISVGGeneratorStrokeStyle;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor color = 6;
   */
  color: AISVGGeneratorColor;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent.result
   */
  result: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 7;
     */
    value: MediaItem;
    case: "mediaItem";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput quiverai_input = 8;
   */
  quiveraiInput?: QuiverAIInput | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent
 */
export type AISVGGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle style = 2;
   */
  style?: AISVGGeneratorStyleJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity complexity = 3;
   */
  complexity?: AISVGGeneratorComplexityJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth stroke_width = 4;
   */
  strokeWidth?: AISVGGeneratorStrokeWidthJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle stroke_style = 5;
   */
  strokeStyle?: AISVGGeneratorStrokeStyleJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor color = 6;
   */
  color?: AISVGGeneratorColorJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 7;
   */
  mediaItem?: MediaItemJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput quiverai_input = 8;
   */
  quiveraiInput?: QuiverAIInputJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent.
 * Use `create(AISVGGeneratorContentSchema)` to create a new message.
 */
export const AISVGGeneratorContentSchema: GenMessage<AISVGGeneratorContent, {jsonType: AISVGGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 137);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent
 */
export type SessionRequestAISVGGeneratorContent = Message<"creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContent | undefined;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle style = 3;
   */
  style: AISVGGeneratorStyle;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity complexity = 4;
   */
  complexity: AISVGGeneratorComplexity;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth stroke_width = 5;
   */
  strokeWidth: AISVGGeneratorStrokeWidth;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle stroke_style = 6;
   */
  strokeStyle: AISVGGeneratorStrokeStyle;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor color = 7;
   */
  color: AISVGGeneratorColor;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput quiverai_input = 8;
   */
  quiveraiInput?: QuiverAIInput | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent
 */
export type SessionRequestAISVGGeneratorContentJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 2;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle style = 3;
   */
  style?: AISVGGeneratorStyleJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity complexity = 4;
   */
  complexity?: AISVGGeneratorComplexityJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth stroke_width = 5;
   */
  strokeWidth?: AISVGGeneratorStrokeWidthJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle stroke_style = 6;
   */
  strokeStyle?: AISVGGeneratorStrokeStyleJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor color = 7;
   */
  color?: AISVGGeneratorColorJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput quiverai_input = 8;
   */
  quiveraiInput?: QuiverAIInputJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent.
 * Use `create(SessionRequestAISVGGeneratorContentSchema)` to create a new message.
 */
export const SessionRequestAISVGGeneratorContentSchema: GenMessage<SessionRequestAISVGGeneratorContent, {jsonType: SessionRequestAISVGGeneratorContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 138);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.QuiverAIInput
 */
export type QuiverAIInput = Message<"creativefabrica.studiomediamatrix.v1.QuiverAIInput"> & {
  /**
   * Model identifier accepted by api.quiver.ai (e.g. "arrow-1.1"). The server validates against
   * an allowlist; arrow-1.1 is the only exposed model at launch.
   *
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: string instructions = 2;
   */
  instructions: string;

  /**
   * Optional output canvas; when absent, the server omits the attributes field on the upstream
   * request and QuiverAI emits its default canvas.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox view_box = 3;
   */
  viewBox?: QuiverAIInput_ViewBox | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.QuiverAIInput
 */
export type QuiverAIInputJson = {
  /**
   * Model identifier accepted by api.quiver.ai (e.g. "arrow-1.1"). The server validates against
   * an allowlist; arrow-1.1 is the only exposed model at launch.
   *
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: string instructions = 2;
   */
  instructions?: string;

  /**
   * Optional output canvas; when absent, the server omits the attributes field on the upstream
   * request and QuiverAI emits its default canvas.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox view_box = 3;
   */
  viewBox?: QuiverAIInput_ViewBoxJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.QuiverAIInput.
 * Use `create(QuiverAIInputSchema)` to create a new message.
 */
export const QuiverAIInputSchema: GenMessage<QuiverAIInput, {jsonType: QuiverAIInputJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 139);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox
 */
export type QuiverAIInput_ViewBox = Message<"creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox"> & {
  /**
   * @generated from field: double min_x = 1;
   */
  minX: number;

  /**
   * @generated from field: double min_y = 2;
   */
  minY: number;

  /**
   * @generated from field: double width = 3;
   */
  width: number;

  /**
   * @generated from field: double height = 4;
   */
  height: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox
 */
export type QuiverAIInput_ViewBoxJson = {
  /**
   * @generated from field: double min_x = 1;
   */
  minX?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double min_y = 2;
   */
  minY?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double width = 3;
   */
  width?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double height = 4;
   */
  height?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.QuiverAIInput.ViewBox.
 * Use `create(QuiverAIInput_ViewBoxSchema)` to create a new message.
 */
export const QuiverAIInput_ViewBoxSchema: GenMessage<QuiverAIInput_ViewBox, {jsonType: QuiverAIInput_ViewBoxJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 139, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate
 */
export type AIMockupGeneratorTemplate = Message<"creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string preview_image_url = 3;
   */
  previewImageUrl?: string | undefined;

  /**
   * @generated from field: int64 price_in_coins = 4;
   */
  priceInCoins: bigint;

  /**
   * @generated from field: int64 reference_image_width = 5;
   */
  referenceImageWidth: bigint;

  /**
   * @generated from field: int64 reference_image_height = 6;
   */
  referenceImageHeight: bigint;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate
 */
export type AIMockupGeneratorTemplateJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string preview_image_url = 3;
   */
  previewImageUrl?: string;

  /**
   * @generated from field: int64 price_in_coins = 4;
   */
  priceInCoins?: string;

  /**
   * @generated from field: int64 reference_image_width = 5;
   */
  referenceImageWidth?: string;

  /**
   * @generated from field: int64 reference_image_height = 6;
   */
  referenceImageHeight?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate.
 * Use `create(AIMockupGeneratorTemplateSchema)` to create a new message.
 */
export const AIMockupGeneratorTemplateSchema: GenMessage<AIMockupGeneratorTemplate, {jsonType: AIMockupGeneratorTemplateJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 140);

/**
 * VideoGeneratorTemplate is the FE-facing DTO for a curated motion-control
 * video template. Backed by a modalitytemplate/v1.Template with
 * template_type = "video-generator" curated in services-genai; upscaler
 * resolves the source video URL, model, preset, and per-template defaults
 * server-side and does not expose them through this DTO.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate
 */
export type VideoGeneratorTemplate = Message<"creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia preview_media = 4;
   */
  previewMedia: VideoGeneratorTemplatePreviewMedia[];

  /**
   * @generated from field: uint32 duration = 5;
   */
  duration: number;

  /**
   * @generated from field: string resolution = 6;
   */
  resolution: string;

  /**
   * @generated from field: string aspect_ratio = 7;
   */
  aspectRatio: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 8;
   */
  model: VideoGeneratorModel;
};

/**
 * VideoGeneratorTemplate is the FE-facing DTO for a curated motion-control
 * video template. Backed by a modalitytemplate/v1.Template with
 * template_type = "video-generator" curated in services-genai; upscaler
 * resolves the source video URL, model, preset, and per-template defaults
 * server-side and does not expose them through this DTO.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate
 */
export type VideoGeneratorTemplateJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia preview_media = 4;
   */
  previewMedia?: VideoGeneratorTemplatePreviewMediaJson[];

  /**
   * @generated from field: uint32 duration = 5;
   */
  duration?: number;

  /**
   * @generated from field: string resolution = 6;
   */
  resolution?: string;

  /**
   * @generated from field: string aspect_ratio = 7;
   */
  aspectRatio?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel model = 8;
   */
  model?: VideoGeneratorModelJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate.
 * Use `create(VideoGeneratorTemplateSchema)` to create a new message.
 */
export const VideoGeneratorTemplateSchema: GenMessage<VideoGeneratorTemplate, {jsonType: VideoGeneratorTemplateJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 141);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia
 */
export type VideoGeneratorTemplatePreviewMedia = Message<"creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia.content
   */
  content: {
    /**
     * @generated from field: string image_url = 1;
     */
    value: string;
    case: "imageUrl";
  } | {
    /**
     * @generated from field: string video_url = 2;
     */
    value: string;
    case: "videoUrl";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia
 */
export type VideoGeneratorTemplatePreviewMediaJson = {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl?: string;

  /**
   * @generated from field: string video_url = 2;
   */
  videoUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplatePreviewMedia.
 * Use `create(VideoGeneratorTemplatePreviewMediaSchema)` to create a new message.
 */
export const VideoGeneratorTemplatePreviewMediaSchema: GenMessage<VideoGeneratorTemplatePreviewMedia, {jsonType: VideoGeneratorTemplatePreviewMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 142);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaImageContent
 */
export type InputMediaImageContent = Message<"creativefabrica.studiomediamatrix.v1.InputMediaImageContent"> & {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl: string;

  /**
   * @generated from field: string processed_url = 2;
   */
  processedUrl: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaImageContent
 */
export type InputMediaImageContentJson = {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl?: string;

  /**
   * @generated from field: string processed_url = 2;
   */
  processedUrl?: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InputMediaImageContent.
 * Use `create(InputMediaImageContentSchema)` to create a new message.
 */
export const InputMediaImageContentSchema: GenMessage<InputMediaImageContent, {jsonType: InputMediaImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 143);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaAudioContent
 */
export type InputMediaAudioContent = Message<"creativefabrica.studiomediamatrix.v1.InputMediaAudioContent"> & {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaAudioContent
 */
export type InputMediaAudioContentJson = {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InputMediaAudioContent.
 * Use `create(InputMediaAudioContentSchema)` to create a new message.
 */
export const InputMediaAudioContentSchema: GenMessage<InputMediaAudioContent, {jsonType: InputMediaAudioContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 144);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaVideoContent
 */
export type InputMediaVideoContent = Message<"creativefabrica.studiomediamatrix.v1.InputMediaVideoContent"> & {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMediaVideoContent
 */
export type InputMediaVideoContentJson = {
  /**
   * @generated from field: string original_url = 1;
   */
  originalUrl?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InputMediaVideoContent.
 * Use `create(InputMediaVideoContentSchema)` to create a new message.
 */
export const InputMediaVideoContentSchema: GenMessage<InputMediaVideoContent, {jsonType: InputMediaVideoContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 145);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMedia
 */
export type InputMedia = Message<"creativefabrica.studiomediamatrix.v1.InputMedia"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaType type = 2;
   */
  type: InputMediaType;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaStatus status = 3;
   */
  status: InputMediaStatus;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.InputMedia.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaImageContent image_content = 4;
     */
    value: InputMediaImageContent;
    case: "imageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaAudioContent audio_content = 5;
     */
    value: InputMediaAudioContent;
    case: "audioContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaVideoContent video_content = 10;
     */
    value: InputMediaVideoContent;
    case: "videoContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: string session_id = 7;
   */
  sessionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * The round this input belongs to, for tools whose uploads are scoped to an
   * iteration (videoEditor, inpaint). Unset for session-scoped inputs.
   *
   * @generated from field: optional string iteration_id = 11;
   */
  iterationId?: string | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InputMedia
 */
export type InputMediaJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaType type = 2;
   */
  type?: InputMediaTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaStatus status = 3;
   */
  status?: InputMediaStatusJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaImageContent image_content = 4;
   */
  imageContent?: InputMediaImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaAudioContent audio_content = 5;
   */
  audioContent?: InputMediaAudioContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InputMediaVideoContent video_content = 10;
   */
  videoContent?: InputMediaVideoContentJson;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: string session_id = 7;
   */
  sessionId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: TimestampJson;

  /**
   * The round this input belongs to, for tools whose uploads are scoped to an
   * iteration (videoEditor, inpaint). Unset for session-scoped inputs.
   *
   * @generated from field: optional string iteration_id = 11;
   */
  iterationId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InputMedia.
 * Use `create(InputMediaSchema)` to create a new message.
 */
export const InputMediaSchema: GenMessage<InputMedia, {jsonType: InputMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 146);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.BrandedMedia
 */
export type BrandedMedia = Message<"creativefabrica.studiomediamatrix.v1.BrandedMedia"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaStatus status = 2;
   */
  status: BrandedMediaStatus;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaType media_type = 3;
   */
  mediaType: BrandedMediaType;

  /**
   * @generated from field: string input_url = 4;
   */
  inputUrl: string;

  /**
   * @generated from field: string output_url = 5;
   */
  outputUrl: string;

  /**
   * @generated from field: string failure_reason = 6;
   */
  failureReason: string;

  /**
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 8;
   */
  createTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 9;
   */
  updateTime?: Timestamp | undefined;

  /**
   * Platform selects which branding (outro) set is applied.
   * UNSPECIFIED is treated as STUDIO for backward compatibility.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform platform = 10;
   */
  platform: BrandedMediaPlatform;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.BrandedMedia
 */
export type BrandedMediaJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaStatus status = 2;
   */
  status?: BrandedMediaStatusJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaType media_type = 3;
   */
  mediaType?: BrandedMediaTypeJson;

  /**
   * @generated from field: string input_url = 4;
   */
  inputUrl?: string;

  /**
   * @generated from field: string output_url = 5;
   */
  outputUrl?: string;

  /**
   * @generated from field: string failure_reason = 6;
   */
  failureReason?: string;

  /**
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 8;
   */
  createTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 9;
   */
  updateTime?: TimestampJson;

  /**
   * Platform selects which branding (outro) set is applied.
   * UNSPECIFIED is treated as STUDIO for backward compatibility.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform platform = 10;
   */
  platform?: BrandedMediaPlatformJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.BrandedMedia.
 * Use `create(BrandedMediaSchema)` to create a new message.
 */
export const BrandedMediaSchema: GenMessage<BrandedMedia, {jsonType: BrandedMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 147);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ReplaceableObject
 */
export type ReplaceableObject = Message<"creativefabrica.studiomediamatrix.v1.ReplaceableObject"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ReplaceableObject
 */
export type ReplaceableObjectJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ReplaceableObject.
 * Use `create(ReplaceableObjectSchema)` to create a new message.
 */
export const ReplaceableObjectSchema: GenMessage<ReplaceableObject, {jsonType: ReplaceableObjectJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_types, 148);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ImageStatus
 */
export enum ImageStatus {
  /**
   * @generated from enum value: IMAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMAGE_STATUS_UPLOAD_PENDING = 1;
   */
  UPLOAD_PENDING = 1,

  /**
   * @generated from enum value: IMAGE_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: IMAGE_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: IMAGE_STATUS_ERROR = 4;
   */
  ERROR = 4,

  /**
   * @generated from enum value: IMAGE_STATUS_WAITING_FOR_PREPROCESSING = 5;
   */
  WAITING_FOR_PREPROCESSING = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ImageStatus
 */
export type ImageStatusJson = "IMAGE_STATUS_UNSPECIFIED" | "IMAGE_STATUS_UPLOAD_PENDING" | "IMAGE_STATUS_PROCESSING" | "IMAGE_STATUS_COMPLETED" | "IMAGE_STATUS_ERROR" | "IMAGE_STATUS_WAITING_FOR_PREPROCESSING";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ImageStatus.
 */
export const ImageStatusSchema: GenEnum<ImageStatus, ImageStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 0);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DownloadStatus
 */
export enum DownloadStatus {
  /**
   * @generated from enum value: DOWNLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DownloadStatus
 */
export type DownloadStatusJson = "DOWNLOAD_STATUS_UNSPECIFIED" | "DOWNLOAD_STATUS_REQUESTED" | "DOWNLOAD_STATUS_COMPLETED" | "DOWNLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DownloadStatus.
 */
export const DownloadStatusSchema: GenEnum<DownloadStatus, DownloadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 1);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SessionStatus
 */
export enum SessionStatus {
  /**
   * @generated from enum value: SESSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: SESSION_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: SESSION_STATUS_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: SESSION_STATUS_REITERATION_PENDING = 4;
   */
  REITERATION_PENDING = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SessionStatus
 */
export type SessionStatusJson = "SESSION_STATUS_UNSPECIFIED" | "SESSION_STATUS_PENDING" | "SESSION_STATUS_COMPLETED" | "SESSION_STATUS_FAILED" | "SESSION_STATUS_REITERATION_PENDING";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.SessionStatus.
 */
export const SessionStatusSchema: GenEnum<SessionStatus, SessionStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 2);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.UploadStatus
 */
export enum UploadStatus {
  /**
   * @generated from enum value: UPLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: UPLOAD_STATUS_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: UPLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.UploadStatus
 */
export type UploadStatusJson = "UPLOAD_STATUS_UNSPECIFIED" | "UPLOAD_STATUS_PENDING" | "UPLOAD_STATUS_SUCCESS" | "UPLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.UploadStatus.
 */
export const UploadStatusSchema: GenEnum<UploadStatus, UploadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 3);

/**
 * User-facing classification of a processing failure. Only failure classes a
 * client can act on are distinguished; every service-side failure is reported
 * as ERROR_CODE_INTERNAL_SERVER_ERROR.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_TIMEOUT = 1;
   */
  TIMEOUT = 1,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL_SERVER_ERROR = 3;
   */
  INTERNAL_SERVER_ERROR = 3,

  /**
   * @generated from enum value: ERROR_CODE_VALIDATION_ERROR = 4;
   */
  VALIDATION_ERROR = 4,

  /**
   * @generated from enum value: ERROR_CODE_UPLOAD_TIMEOUT = 8;
   */
  UPLOAD_TIMEOUT = 8,

  /**
   * @generated from enum value: ERROR_CODE_NSFW_CONTENT_DETECTED = 9;
   */
  NSFW_CONTENT_DETECTED = 9,

  /**
   * @generated from enum value: ERROR_CODE_PROMPT_BLOCKED = 10;
   */
  PROMPT_BLOCKED = 10,

  /**
   * @generated from enum value: ERROR_CODE_UNPROCESSABLE_ACTION = 11;
   */
  UNPROCESSABLE_ACTION = 11,

  /**
   * @generated from enum value: ERROR_CODE_RESOURCE_EXHAUSTED = 14;
   */
  RESOURCE_EXHAUSTED = 14,

  /**
   * @generated from enum value: ERROR_CODE_COPYRIGHT_VIOLATION = 15;
   */
  COPYRIGHT_VIOLATION = 15,
}

/**
 * User-facing classification of a processing failure. Only failure classes a
 * client can act on are distinguished; every service-side failure is reported
 * as ERROR_CODE_INTERNAL_SERVER_ERROR.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.ErrorCode
 */
export type ErrorCodeJson = "ERROR_CODE_UNSPECIFIED" | "ERROR_CODE_TIMEOUT" | "ERROR_CODE_INTERNAL_SERVER_ERROR" | "ERROR_CODE_VALIDATION_ERROR" | "ERROR_CODE_UPLOAD_TIMEOUT" | "ERROR_CODE_NSFW_CONTENT_DETECTED" | "ERROR_CODE_PROMPT_BLOCKED" | "ERROR_CODE_UNPROCESSABLE_ACTION" | "ERROR_CODE_RESOURCE_EXHAUSTED" | "ERROR_CODE_COPYRIGHT_VIOLATION";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode, ErrorCodeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 4);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.Source
 */
export enum Source {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOURCE_LUMO = 1;
   */
  LUMO = 1,

  /**
   * @generated from enum value: SOURCE_FREEMODE_AI = 2;
   */
  FREEMODE_AI = 2,

  /**
   * @generated from enum value: SOURCE_UNLIMITED = 3;
   */
  UNLIMITED = 3,

  /**
   * @generated from enum value: SOURCE_MARKETPLACE = 4;
   */
  MARKETPLACE = 4,

  /**
   * @generated from enum value: SOURCE_MOBILE = 5;
   */
  MOBILE = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.Source
 */
export type SourceJson = "SOURCE_UNSPECIFIED" | "SOURCE_LUMO" | "SOURCE_FREEMODE_AI" | "SOURCE_UNLIMITED" | "SOURCE_MARKETPLACE" | "SOURCE_MOBILE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.Source.
 */
export const SourceSchema: GenEnum<Source, SourceJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 5);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ServiceType
 */
export enum ServiceType {
  /**
   * @generated from enum value: SERVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SERVICE_TYPE_UPSCALER = 1;
   */
  UPSCALER = 1,

  /**
   * @generated from enum value: SERVICE_TYPE_QUOTE_GENERATOR = 2;
   */
  QUOTE_GENERATOR = 2,

  /**
   * @generated from enum value: SERVICE_TYPE_DESIGN_REVIEWER = 3;
   */
  DESIGN_REVIEWER = 3,

  /**
   * @generated from enum value: SERVICE_TYPE_IMAGE_EDITOR = 4;
   */
  IMAGE_EDITOR = 4,

  /**
   * @generated from enum value: SERVICE_TYPE_AI_MUSIC_GENERATOR = 5;
   */
  AI_MUSIC_GENERATOR = 5,

  /**
   * @generated from enum value: SERVICE_TYPE_AI_WATERMARK_REMOVER = 6;
   */
  AI_WATERMARK_REMOVER = 6,

  /**
   * @generated from enum value: SERVICE_TYPE_SOUND_GENERATOR = 7;
   */
  SOUND_GENERATOR = 7,

  /**
   * @generated from enum value: SERVICE_TYPE_SPEECH_GENERATOR = 8;
   */
  SPEECH_GENERATOR = 8,

  /**
   * @generated from enum value: SERVICE_TYPE_COLLAGE_MAKER = 9;
   */
  COLLAGE_MAKER = 9,

  /**
   * @generated from enum value: SERVICE_TYPE_MOCKUP_GENERATOR = 10;
   */
  MOCKUP_GENERATOR = 10,

  /**
   * @generated from enum value: SERVICE_TYPE_THREE_D_MODEL_GENERATOR = 11 [deprecated = true];
   * @deprecated
   */
  THREE_D_MODEL_GENERATOR = 11,

  /**
   * @generated from enum value: SERVICE_TYPE_DOODLE_PET = 12;
   */
  DOODLE_PET = 12,

  /**
   * @generated from enum value: SERVICE_TYPE_PEOPLE_REMOVER_FROM_BACKGROUND = 13;
   */
  PEOPLE_REMOVER_FROM_BACKGROUND = 13,

  /**
   * @generated from enum value: SERVICE_TYPE_COLORING_PAGE_MAKER = 14;
   */
  COLORING_PAGE_MAKER = 14,

  /**
   * @generated from enum value: SERVICE_TYPE_VIDEO_GENERATOR = 15;
   */
  VIDEO_GENERATOR = 15,

  /**
   * @generated from enum value: SERVICE_TYPE_WEDDING_INVITE_GENERATOR = 16;
   */
  WEDDING_INVITE_GENERATOR = 16,

  /**
   * @generated from enum value: SERVICE_TYPE_ETSY_COACH = 17;
   */
  ETSY_COACH = 17,

  /**
   * @generated from enum value: SERVICE_TYPE_AI_PHOTO_STYLE = 18;
   */
  AI_PHOTO_STYLE = 18,

  /**
   * @generated from enum value: SERVICE_TYPE_TOON_FAMILY_BUILDER = 19;
   */
  TOON_FAMILY_BUILDER = 19,

  /**
   * @generated from enum value: SERVICE_TYPE_MESH_GENERATOR = 20;
   */
  MESH_GENERATOR = 20,

  /**
   * @generated from enum value: SERVICE_TYPE_THREE_D_PRINT_GENERATOR = 21;
   */
  THREE_D_PRINT_GENERATOR = 21,

  /**
   * aka as "mesh"
   *
   * @generated from enum value: SERVICE_TYPE_THREE_D_MODEL_MESH_GENERATOR = 22;
   */
  THREE_D_MODEL_MESH_GENERATOR = 22,

  /**
   * @generated from enum value: SERVICE_TYPE_LOGO_GENERATOR = 23;
   */
  LOGO_GENERATOR = 23,

  /**
   * @generated from enum value: SERVICE_TYPE_VIDEO_UPSCALER = 24;
   */
  VIDEO_UPSCALER = 24,

  /**
   * @generated from enum value: SERVICE_TYPE_AI_MOCKUP_GENERATOR = 25;
   */
  AI_MOCKUP_GENERATOR = 25,

  /**
   * @generated from enum value: SERVICE_TYPE_CAMERA_ANGLE = 26;
   */
  CAMERA_ANGLE = 26,

  /**
   * @generated from enum value: SERVICE_TYPE_MARKETPLACE_EDITOR = 27;
   */
  MARKETPLACE_EDITOR = 27,

  /**
   * @generated from enum value: SERVICE_TYPE_AISVG_GENERATOR = 28;
   */
  AISVG_GENERATOR = 28,

  /**
   * @generated from enum value: SERVICE_TYPE_SPLAT_GENERATOR = 29;
   */
  SPLAT_GENERATOR = 29,

  /**
   * @generated from enum value: SERVICE_TYPE_FLOW_IMAGE_GENERATOR = 30;
   */
  FLOW_IMAGE_GENERATOR = 30,

  /**
   * @generated from enum value: SERVICE_TYPE_VIDEO_CUTOUTS = 31;
   */
  VIDEO_CUTOUTS = 31,

  /**
   * @generated from enum value: SERVICE_TYPE_AI_MUSIC_LYRICS_STRUCTURED = 32;
   */
  AI_MUSIC_LYRICS_STRUCTURED = 32,

  /**
   * @generated from enum value: SERVICE_TYPE_VIDEO_EDITOR = 33;
   */
  VIDEO_EDITOR = 33,

  /**
   * @generated from enum value: SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR = 34;
   */
  YOUTUBE_THUMBNAIL_GENERATOR = 34,

  /**
   * @generated from enum value: SERVICE_TYPE_INPAINT = 35;
   */
  INPAINT = 35,

  /**
   * @generated from enum value: SERVICE_TYPE_AD_BANNER_RESIZER = 36;
   */
  AD_BANNER_RESIZER = 36,

  /**
   * Draft Mode: fast, low-cost video drafts. Sessions use the video generator's
   * request and content (SessionRequestPromptToVideoGeneratorContent /
   * PromptToVideoGeneratorContent with this service_type) and are restricted to
   * the Draft Mode model set that ListModels serves for this service type.
   *
   * @generated from enum value: SERVICE_TYPE_VIDEO_DRAFT = 37;
   */
  VIDEO_DRAFT = 37,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ServiceType
 */
export type ServiceTypeJson = "SERVICE_TYPE_UNSPECIFIED" | "SERVICE_TYPE_UPSCALER" | "SERVICE_TYPE_QUOTE_GENERATOR" | "SERVICE_TYPE_DESIGN_REVIEWER" | "SERVICE_TYPE_IMAGE_EDITOR" | "SERVICE_TYPE_AI_MUSIC_GENERATOR" | "SERVICE_TYPE_AI_WATERMARK_REMOVER" | "SERVICE_TYPE_SOUND_GENERATOR" | "SERVICE_TYPE_SPEECH_GENERATOR" | "SERVICE_TYPE_COLLAGE_MAKER" | "SERVICE_TYPE_MOCKUP_GENERATOR" | "SERVICE_TYPE_THREE_D_MODEL_GENERATOR" | "SERVICE_TYPE_DOODLE_PET" | "SERVICE_TYPE_PEOPLE_REMOVER_FROM_BACKGROUND" | "SERVICE_TYPE_COLORING_PAGE_MAKER" | "SERVICE_TYPE_VIDEO_GENERATOR" | "SERVICE_TYPE_WEDDING_INVITE_GENERATOR" | "SERVICE_TYPE_ETSY_COACH" | "SERVICE_TYPE_AI_PHOTO_STYLE" | "SERVICE_TYPE_TOON_FAMILY_BUILDER" | "SERVICE_TYPE_MESH_GENERATOR" | "SERVICE_TYPE_THREE_D_PRINT_GENERATOR" | "SERVICE_TYPE_THREE_D_MODEL_MESH_GENERATOR" | "SERVICE_TYPE_LOGO_GENERATOR" | "SERVICE_TYPE_VIDEO_UPSCALER" | "SERVICE_TYPE_AI_MOCKUP_GENERATOR" | "SERVICE_TYPE_CAMERA_ANGLE" | "SERVICE_TYPE_MARKETPLACE_EDITOR" | "SERVICE_TYPE_AISVG_GENERATOR" | "SERVICE_TYPE_SPLAT_GENERATOR" | "SERVICE_TYPE_FLOW_IMAGE_GENERATOR" | "SERVICE_TYPE_VIDEO_CUTOUTS" | "SERVICE_TYPE_AI_MUSIC_LYRICS_STRUCTURED" | "SERVICE_TYPE_VIDEO_EDITOR" | "SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR" | "SERVICE_TYPE_INPAINT" | "SERVICE_TYPE_AD_BANNER_RESIZER" | "SERVICE_TYPE_VIDEO_DRAFT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ServiceType.
 */
export const ServiceTypeSchema: GenEnum<ServiceType, ServiceTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 6);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SessionVisibility
 */
export enum SessionVisibility {
  /**
   * @generated from enum value: SESSION_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_VISIBILITY_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: SESSION_VISIBILITY_PUBLIC = 2;
   */
  PUBLIC = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SessionVisibility
 */
export type SessionVisibilityJson = "SESSION_VISIBILITY_UNSPECIFIED" | "SESSION_VISIBILITY_PRIVATE" | "SESSION_VISIBILITY_PUBLIC";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.SessionVisibility.
 */
export const SessionVisibilitySchema: GenEnum<SessionVisibility, SessionVisibilityJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 7);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ShareActionType
 */
export enum ShareActionType {
  /**
   * @generated from enum value: SHARE_ACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_IMAGE = 1;
   */
  GENERATED_IMAGE = 1,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_EDITED_IMAGE = 2;
   */
  EDITED_IMAGE = 2,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_MUSIC = 3;
   */
  GENERATED_MUSIC = 3,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_SOUND = 4;
   */
  GENERATED_SOUND = 4,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_QUOTE = 5;
   */
  GENERATED_QUOTE = 5,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_SPEECH = 6;
   */
  GENERATED_SPEECH = 6,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_COLLAGE = 7;
   */
  GENERATED_COLLAGE = 7,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_VIDEO = 8;
   */
  GENERATED_VIDEO = 8,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_AI_PHOTO_STYLE = 9;
   */
  GENERATED_AI_PHOTO_STYLE = 9,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_MESH = 10;
   */
  GENERATED_MESH = 10,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_AI_MOCKUP = 11;
   */
  GENERATED_AI_MOCKUP = 11,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_LOGO = 12;
   */
  GENERATED_LOGO = 12,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_SPLAT = 13;
   */
  GENERATED_SPLAT = 13,

  /**
   * @generated from enum value: SHARE_ACTION_TYPE_GENERATED_YOUTUBE_THUMBNAIL = 14;
   */
  GENERATED_YOUTUBE_THUMBNAIL = 14,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ShareActionType
 */
export type ShareActionTypeJson = "SHARE_ACTION_TYPE_UNSPECIFIED" | "SHARE_ACTION_TYPE_GENERATED_IMAGE" | "SHARE_ACTION_TYPE_EDITED_IMAGE" | "SHARE_ACTION_TYPE_GENERATED_MUSIC" | "SHARE_ACTION_TYPE_GENERATED_SOUND" | "SHARE_ACTION_TYPE_GENERATED_QUOTE" | "SHARE_ACTION_TYPE_GENERATED_SPEECH" | "SHARE_ACTION_TYPE_GENERATED_COLLAGE" | "SHARE_ACTION_TYPE_GENERATED_VIDEO" | "SHARE_ACTION_TYPE_GENERATED_AI_PHOTO_STYLE" | "SHARE_ACTION_TYPE_GENERATED_MESH" | "SHARE_ACTION_TYPE_GENERATED_AI_MOCKUP" | "SHARE_ACTION_TYPE_GENERATED_LOGO" | "SHARE_ACTION_TYPE_GENERATED_SPLAT" | "SHARE_ACTION_TYPE_GENERATED_YOUTUBE_THUMBNAIL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ShareActionType.
 */
export const ShareActionTypeSchema: GenEnum<ShareActionType, ShareActionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 8);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorVoiceType
 */
export enum MusicGeneratorVoiceType {
  /**
   * @generated from enum value: MUSIC_GENERATOR_VOICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MUSIC_GENERATOR_VOICE_TYPE_FEMALE = 1;
   */
  FEMALE = 1,

  /**
   * @generated from enum value: MUSIC_GENERATOR_VOICE_TYPE_MALE = 2;
   */
  MALE = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorVoiceType
 */
export type MusicGeneratorVoiceTypeJson = "MUSIC_GENERATOR_VOICE_TYPE_UNSPECIFIED" | "MUSIC_GENERATOR_VOICE_TYPE_FEMALE" | "MUSIC_GENERATOR_VOICE_TYPE_MALE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MusicGeneratorVoiceType.
 */
export const MusicGeneratorVoiceTypeSchema: GenEnum<MusicGeneratorVoiceType, MusicGeneratorVoiceTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 9);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorSectionType
 */
export enum MusicGeneratorSectionType {
  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_INTRO = 1;
   */
  INTRO = 1,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_VERSE = 2;
   */
  VERSE = 2,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_CHORUS = 3;
   */
  CHORUS = 3,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_BRIDGE = 4;
   */
  BRIDGE = 4,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_OUTRO = 5;
   */
  OUTRO = 5,

  /**
   * @generated from enum value: MUSIC_GENERATOR_SECTION_TYPE_INSTRUMENTAL = 6;
   */
  INSTRUMENTAL = 6,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorSectionType
 */
export type MusicGeneratorSectionTypeJson = "MUSIC_GENERATOR_SECTION_TYPE_UNSPECIFIED" | "MUSIC_GENERATOR_SECTION_TYPE_INTRO" | "MUSIC_GENERATOR_SECTION_TYPE_VERSE" | "MUSIC_GENERATOR_SECTION_TYPE_CHORUS" | "MUSIC_GENERATOR_SECTION_TYPE_BRIDGE" | "MUSIC_GENERATOR_SECTION_TYPE_OUTRO" | "MUSIC_GENERATOR_SECTION_TYPE_INSTRUMENTAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MusicGeneratorSectionType.
 */
export const MusicGeneratorSectionTypeSchema: GenEnum<MusicGeneratorSectionType, MusicGeneratorSectionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 10);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel
 */
export enum PromptSpeechGeneratorModel {
  /**
   * @generated from enum value: PROMPT_SPEECH_GENERATOR_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_SPEECH_GENERATOR_MODEL_ELEVENLABS_V2 = 1;
   */
  ELEVENLABS_V2 = 1,

  /**
   * @generated from enum value: PROMPT_SPEECH_GENERATOR_MODEL_ELEVENLABS_V3 = 2;
   */
  ELEVENLABS_V3 = 2,

  /**
   * Kokoro TTS on the Aurora network, offered on the Unlimited surface only.
   *
   * @generated from enum value: PROMPT_SPEECH_GENERATOR_MODEL_AURORA_KOKORO_TTS = 3;
   */
  AURORA_KOKORO_TTS = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel
 */
export type PromptSpeechGeneratorModelJson = "PROMPT_SPEECH_GENERATOR_MODEL_UNSPECIFIED" | "PROMPT_SPEECH_GENERATOR_MODEL_ELEVENLABS_V2" | "PROMPT_SPEECH_GENERATOR_MODEL_ELEVENLABS_V3" | "PROMPT_SPEECH_GENERATOR_MODEL_AURORA_KOKORO_TTS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorModel.
 */
export const PromptSpeechGeneratorModelSchema: GenEnum<PromptSpeechGeneratorModel, PromptSpeechGeneratorModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 11);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode
 */
export enum PromptMusicGeneratorContentMode {
  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MODE_AUTO = 1;
   */
  AUTO = 1,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MODE_INSTRUMENTAL = 2;
   */
  INSTRUMENTAL = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode
 */
export type PromptMusicGeneratorContentModeJson = "PROMPT_MUSIC_GENERATOR_CONTENT_MODE_UNSPECIFIED" | "PROMPT_MUSIC_GENERATOR_CONTENT_MODE_AUTO" | "PROMPT_MUSIC_GENERATOR_CONTENT_MODE_INSTRUMENTAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMode.
 */
export const PromptMusicGeneratorContentModeSchema: GenEnum<PromptMusicGeneratorContentMode, PromptMusicGeneratorContentModeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 12);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration
 */
export enum PromptMusicGeneratorContentMusicDuration {
  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_UNSPECIFIED = 0;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_30_SECONDS = 1;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_30_SECONDS = 1,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_60_SECONDS = 2;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_60_SECONDS = 2,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_120_SECONDS = 3;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_120_SECONDS = 3,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_180_SECONDS = 4;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_180_SECONDS = 4,

  /**
   * @generated from enum value: PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_10_SECONDS = 5;
   */
  PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_10_SECONDS = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration
 */
export type PromptMusicGeneratorContentMusicDurationJson = "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_UNSPECIFIED" | "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_30_SECONDS" | "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_60_SECONDS" | "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_120_SECONDS" | "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_180_SECONDS" | "PROMPT_MUSIC_GENERATOR_CONTENT_MUSIC_DURATION_10_SECONDS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContentMusicDuration.
 */
export const PromptMusicGeneratorContentMusicDurationSchema: GenEnum<PromptMusicGeneratorContentMusicDuration, PromptMusicGeneratorContentMusicDurationJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 13);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration
 */
export enum PromptSoundGeneratorContentSoundDuration {
  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_UNSPECIFIED = 0;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_1_SECONDS = 1;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_1_SECONDS = 1,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_5_SECONDS = 2;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_5_SECONDS = 2,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_10_SECONDS = 3;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_10_SECONDS = 3,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_15_SECONDS = 4;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_15_SECONDS = 4,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_30_SECONDS = 5;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_30_SECONDS = 5,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_2_SECONDS = 6;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_2_SECONDS = 6,

  /**
   * @generated from enum value: PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_3_SECONDS = 7;
   */
  PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_3_SECONDS = 7,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration
 */
export type PromptSoundGeneratorContentSoundDurationJson = "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_UNSPECIFIED" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_1_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_5_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_10_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_15_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_30_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_2_SECONDS" | "PROMPT_SOUND_GENERATOR_CONTENT_SOUND_DURATION_3_SECONDS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContentSoundDuration.
 */
export const PromptSoundGeneratorContentSoundDurationSchema: GenEnum<PromptSoundGeneratorContentSoundDuration, PromptSoundGeneratorContentSoundDurationJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 14);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle
 */
export enum CollageMakerContentStyle {
  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_AUTO = 1;
   */
  AUTO = 1,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_CUTE_SCRAPBOOK = 2;
   */
  CUTE_SCRAPBOOK = 2,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_MODERN = 3;
   */
  MODERN = 3,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_POLAROID = 4;
   */
  POLAROID = 4,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_CRAFT_SCRAPBOOK = 5;
   */
  CRAFT_SCRAPBOOK = 5,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_MAGAZINE = 6;
   */
  MAGAZINE = 6,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_GEOMETRIC_MOSAIC = 7;
   */
  GEOMETRIC_MOSAIC = 7,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_GALLERY_WALL = 8;
   */
  GALLERY_WALL = 8,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_PINTEREST_MOODBOARD = 9;
   */
  PINTEREST_MOODBOARD = 9,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_DYNAMIC_OVERLAP = 10;
   */
  DYNAMIC_OVERLAP = 10,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_BLUE_TECH = 11;
   */
  BLUE_TECH = 11,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_COLORFUL_KIDS_COLLAGE = 12;
   */
  COLORFUL_KIDS_COLLAGE = 12,

  /**
   * @generated from enum value: COLLAGE_MAKER_CONTENT_STYLE_CINEMATIC_FILM = 13;
   */
  CINEMATIC_FILM = 13,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle
 */
export type CollageMakerContentStyleJson = "COLLAGE_MAKER_CONTENT_STYLE_UNSPECIFIED" | "COLLAGE_MAKER_CONTENT_STYLE_AUTO" | "COLLAGE_MAKER_CONTENT_STYLE_CUTE_SCRAPBOOK" | "COLLAGE_MAKER_CONTENT_STYLE_MODERN" | "COLLAGE_MAKER_CONTENT_STYLE_POLAROID" | "COLLAGE_MAKER_CONTENT_STYLE_CRAFT_SCRAPBOOK" | "COLLAGE_MAKER_CONTENT_STYLE_MAGAZINE" | "COLLAGE_MAKER_CONTENT_STYLE_GEOMETRIC_MOSAIC" | "COLLAGE_MAKER_CONTENT_STYLE_GALLERY_WALL" | "COLLAGE_MAKER_CONTENT_STYLE_PINTEREST_MOODBOARD" | "COLLAGE_MAKER_CONTENT_STYLE_DYNAMIC_OVERLAP" | "COLLAGE_MAKER_CONTENT_STYLE_BLUE_TECH" | "COLLAGE_MAKER_CONTENT_STYLE_COLORFUL_KIDS_COLLAGE" | "COLLAGE_MAKER_CONTENT_STYLE_CINEMATIC_FILM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.CollageMakerContentStyle.
 */
export const CollageMakerContentStyleSchema: GenEnum<CollageMakerContentStyle, CollageMakerContentStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 15);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DoodlePetVibe
 */
export enum DoodlePetVibe {
  /**
   * @generated from enum value: DOODLE_PET_VIBE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_SO_DUMB = 1;
   */
  SO_DUMB = 1,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_NO_THOUGHTS = 2;
   */
  NO_THOUGHTS = 2,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_DRAMA_QUEEN = 3;
   */
  DRAMA_QUEEN = 3,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_FEED_ME = 4;
   */
  FEED_ME = 4,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_JUDGEY = 5;
   */
  JUDGEY = 5,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_EMPTY_HEAD = 6;
   */
  EMPTY_HEAD = 6,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_CHAOS_MODE = 7;
   */
  CHAOS_MODE = 7,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_HELP = 8;
   */
  HELP = 8,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_IM_BABY = 9;
   */
  IM_BABY = 9,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_CRIMINAL = 10;
   */
  CRIMINAL = 10,

  /**
   * @generated from enum value: DOODLE_PET_VIBE_NONE = 11;
   */
  NONE = 11,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DoodlePetVibe
 */
export type DoodlePetVibeJson = "DOODLE_PET_VIBE_UNSPECIFIED" | "DOODLE_PET_VIBE_SO_DUMB" | "DOODLE_PET_VIBE_NO_THOUGHTS" | "DOODLE_PET_VIBE_DRAMA_QUEEN" | "DOODLE_PET_VIBE_FEED_ME" | "DOODLE_PET_VIBE_JUDGEY" | "DOODLE_PET_VIBE_EMPTY_HEAD" | "DOODLE_PET_VIBE_CHAOS_MODE" | "DOODLE_PET_VIBE_HELP" | "DOODLE_PET_VIBE_IM_BABY" | "DOODLE_PET_VIBE_CRIMINAL" | "DOODLE_PET_VIBE_NONE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DoodlePetVibe.
 */
export const DoodlePetVibeSchema: GenEnum<DoodlePetVibe, DoodlePetVibeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 16);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ColoringPageType
 */
export enum ColoringPageType {
  /**
   * @generated from enum value: COLORING_PAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLORING_PAGE_TYPE_KIDS = 1;
   */
  KIDS = 1,

  /**
   * @generated from enum value: COLORING_PAGE_TYPE_ADULTS = 2;
   */
  ADULTS = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ColoringPageType
 */
export type ColoringPageTypeJson = "COLORING_PAGE_TYPE_UNSPECIFIED" | "COLORING_PAGE_TYPE_KIDS" | "COLORING_PAGE_TYPE_ADULTS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ColoringPageType.
 */
export const ColoringPageTypeSchema: GenEnum<ColoringPageType, ColoringPageTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 17);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.WeddingInviteTheme
 */
export enum WeddingInviteTheme {
  /**
   * @generated from enum value: WEDDING_INVITE_THEME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_FLORAL_ROMANCE = 1;
   */
  FLORAL_ROMANCE = 1,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_MINIMALIST_CHIC = 2;
   */
  MINIMALIST_CHIC = 2,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_VINTAGE_ELEGANCE = 3;
   */
  VINTAGE_ELEGANCE = 3,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_MODERN_LUXURY = 4;
   */
  MODERN_LUXURY = 4,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_RUSTIC_CHARM = 5;
   */
  RUSTIC_CHARM = 5,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_ART_DECO = 6;
   */
  ART_DECO = 6,

  /**
   * @generated from enum value: WEDDING_INVITE_THEME_CUSTOM = 7;
   */
  CUSTOM = 7,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.WeddingInviteTheme
 */
export type WeddingInviteThemeJson = "WEDDING_INVITE_THEME_UNSPECIFIED" | "WEDDING_INVITE_THEME_FLORAL_ROMANCE" | "WEDDING_INVITE_THEME_MINIMALIST_CHIC" | "WEDDING_INVITE_THEME_VINTAGE_ELEGANCE" | "WEDDING_INVITE_THEME_MODERN_LUXURY" | "WEDDING_INVITE_THEME_RUSTIC_CHARM" | "WEDDING_INVITE_THEME_ART_DECO" | "WEDDING_INVITE_THEME_CUSTOM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.WeddingInviteTheme.
 */
export const WeddingInviteThemeSchema: GenEnum<WeddingInviteTheme, WeddingInviteThemeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 18);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType
 */
export enum ModelThreeDGeneratorOpenSCADModelType {
  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_UNSPECIFIED = 0;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_KEYCHAIN = 1;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_KEYCHAIN = 1,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_VASE = 2;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_VASE = 2,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_CAKE_TOPPER = 3;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_CAKE_TOPPER = 3,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FIGURINE = 4;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FIGURINE = 4,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COOKIE_CUTTER = 5;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COOKIE_CUTTER = 5,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COASTER = 6;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COASTER = 6,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_ORNAMENT = 7;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_ORNAMENT = 7,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_PHONE_STAND = 8;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_PHONE_STAND = 8,

  /**
   * @generated from enum value: MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FREEFORM = 9;
   */
  MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FREEFORM = 9,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType
 */
export type ModelThreeDGeneratorOpenSCADModelTypeJson = "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_UNSPECIFIED" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_KEYCHAIN" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_VASE" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_CAKE_TOPPER" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FIGURINE" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COOKIE_CUTTER" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_COASTER" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_ORNAMENT" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_PHONE_STAND" | "MODEL_THREE_D_GENERATOR_OPEN_SCAD_MODEL_TYPE_FREEFORM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ModelThreeDGeneratorOpenSCADModelType.
 */
export const ModelThreeDGeneratorOpenSCADModelTypeSchema: GenEnum<ModelThreeDGeneratorOpenSCADModelType, ModelThreeDGeneratorOpenSCADModelTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 19);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorTimeOfDayLighting
 */
export enum DirectorTimeOfDayLighting {
  /**
   * @generated from enum value: DIRECTOR_TIME_OF_DAY_LIGHTING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_TIME_OF_DAY_LIGHTING_GOLDEN_HOUR = 1;
   */
  GOLDEN_HOUR = 1,

  /**
   * @generated from enum value: DIRECTOR_TIME_OF_DAY_LIGHTING_MIDDAY = 2;
   */
  MIDDAY = 2,

  /**
   * @generated from enum value: DIRECTOR_TIME_OF_DAY_LIGHTING_TWILIGHT = 3;
   */
  TWILIGHT = 3,

  /**
   * @generated from enum value: DIRECTOR_TIME_OF_DAY_LIGHTING_NEON = 4;
   */
  NEON = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorTimeOfDayLighting
 */
export type DirectorTimeOfDayLightingJson = "DIRECTOR_TIME_OF_DAY_LIGHTING_UNSPECIFIED" | "DIRECTOR_TIME_OF_DAY_LIGHTING_GOLDEN_HOUR" | "DIRECTOR_TIME_OF_DAY_LIGHTING_MIDDAY" | "DIRECTOR_TIME_OF_DAY_LIGHTING_TWILIGHT" | "DIRECTOR_TIME_OF_DAY_LIGHTING_NEON";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorTimeOfDayLighting.
 */
export const DirectorTimeOfDayLightingSchema: GenEnum<DirectorTimeOfDayLighting, DirectorTimeOfDayLightingJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 20);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorLightingDirection
 */
export enum DirectorLightingDirection {
  /**
   * @generated from enum value: DIRECTOR_LIGHTING_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_LIGHTING_DIRECTION_FRONT_LIT = 1;
   */
  FRONT_LIT = 1,

  /**
   * @generated from enum value: DIRECTOR_LIGHTING_DIRECTION_SIDE_LIT = 2;
   */
  SIDE_LIT = 2,

  /**
   * @generated from enum value: DIRECTOR_LIGHTING_DIRECTION_BACK_LIT = 3;
   */
  BACK_LIT = 3,

  /**
   * @generated from enum value: DIRECTOR_LIGHTING_DIRECTION_TOP = 4;
   */
  TOP = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorLightingDirection
 */
export type DirectorLightingDirectionJson = "DIRECTOR_LIGHTING_DIRECTION_UNSPECIFIED" | "DIRECTOR_LIGHTING_DIRECTION_FRONT_LIT" | "DIRECTOR_LIGHTING_DIRECTION_SIDE_LIT" | "DIRECTOR_LIGHTING_DIRECTION_BACK_LIT" | "DIRECTOR_LIGHTING_DIRECTION_TOP";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorLightingDirection.
 */
export const DirectorLightingDirectionSchema: GenEnum<DirectorLightingDirection, DirectorLightingDirectionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 21);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockColor
 */
export enum DirectorFilmStockColor {
  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_COLOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_COLOR_FULL_COLOR = 1;
   */
  FULL_COLOR = 1,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_COLOR_BLACK_AND_WHITE = 2;
   */
  BLACK_AND_WHITE = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockColor
 */
export type DirectorFilmStockColorJson = "DIRECTOR_FILM_STOCK_COLOR_UNSPECIFIED" | "DIRECTOR_FILM_STOCK_COLOR_FULL_COLOR" | "DIRECTOR_FILM_STOCK_COLOR_BLACK_AND_WHITE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockColor.
 */
export const DirectorFilmStockColorSchema: GenEnum<DirectorFilmStockColor, DirectorFilmStockColorJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 22);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockFormat
 */
export enum DirectorFilmStockFormat {
  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_FORMAT_UNSPECIFIED = 0;
   */
  DIRECTOR_FILM_STOCK_FORMAT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_FORMAT_VHS = 1;
   */
  DIRECTOR_FILM_STOCK_FORMAT_VHS = 1,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_FORMAT_16MM = 2;
   */
  DIRECTOR_FILM_STOCK_FORMAT_16MM = 2,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_FORMAT_35MM = 3;
   */
  DIRECTOR_FILM_STOCK_FORMAT_35MM = 3,

  /**
   * @generated from enum value: DIRECTOR_FILM_STOCK_FORMAT_DIGITAL = 4;
   */
  DIRECTOR_FILM_STOCK_FORMAT_DIGITAL = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockFormat
 */
export type DirectorFilmStockFormatJson = "DIRECTOR_FILM_STOCK_FORMAT_UNSPECIFIED" | "DIRECTOR_FILM_STOCK_FORMAT_VHS" | "DIRECTOR_FILM_STOCK_FORMAT_16MM" | "DIRECTOR_FILM_STOCK_FORMAT_35MM" | "DIRECTOR_FILM_STOCK_FORMAT_DIGITAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorFilmStockFormat.
 */
export const DirectorFilmStockFormatSchema: GenEnum<DirectorFilmStockFormat, DirectorFilmStockFormatJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 23);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFocusType
 */
export enum DirectorFocusType {
  /**
   * @generated from enum value: DIRECTOR_FOCUS_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_FOCUS_TYPE_DEEP_FOCUS = 1;
   */
  DEEP_FOCUS = 1,

  /**
   * @generated from enum value: DIRECTOR_FOCUS_TYPE_CINEMATIC_BOKEH = 2;
   */
  CINEMATIC_BOKEH = 2,

  /**
   * @generated from enum value: DIRECTOR_FOCUS_TYPE_SELECTIVE_FOCUS = 3;
   */
  SELECTIVE_FOCUS = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorFocusType
 */
export type DirectorFocusTypeJson = "DIRECTOR_FOCUS_TYPE_UNSPECIFIED" | "DIRECTOR_FOCUS_TYPE_DEEP_FOCUS" | "DIRECTOR_FOCUS_TYPE_CINEMATIC_BOKEH" | "DIRECTOR_FOCUS_TYPE_SELECTIVE_FOCUS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorFocusType.
 */
export const DirectorFocusTypeSchema: GenEnum<DirectorFocusType, DirectorFocusTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 24);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorCompositionType
 */
export enum DirectorCompositionType {
  /**
   * @generated from enum value: DIRECTOR_COMPOSITION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_COMPOSITION_TYPE_RULE_OF_THIRDS = 1;
   */
  RULE_OF_THIRDS = 1,

  /**
   * @generated from enum value: DIRECTOR_COMPOSITION_TYPE_CENTER_WEIGHTED = 2;
   */
  CENTER_WEIGHTED = 2,

  /**
   * @generated from enum value: DIRECTOR_COMPOSITION_TYPE_NEGATIVE_SPACE = 3;
   */
  NEGATIVE_SPACE = 3,

  /**
   * @generated from enum value: DIRECTOR_COMPOSITION_TYPE_HEADROOM = 4;
   */
  HEADROOM = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorCompositionType
 */
export type DirectorCompositionTypeJson = "DIRECTOR_COMPOSITION_TYPE_UNSPECIFIED" | "DIRECTOR_COMPOSITION_TYPE_RULE_OF_THIRDS" | "DIRECTOR_COMPOSITION_TYPE_CENTER_WEIGHTED" | "DIRECTOR_COMPOSITION_TYPE_NEGATIVE_SPACE" | "DIRECTOR_COMPOSITION_TYPE_HEADROOM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorCompositionType.
 */
export const DirectorCompositionTypeSchema: GenEnum<DirectorCompositionType, DirectorCompositionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 25);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorShotSizeType
 */
export enum DirectorShotSizeType {
  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_EXTREME_CLOSE_UP = 1;
   */
  EXTREME_CLOSE_UP = 1,

  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_CLOSE_UP = 2;
   */
  CLOSE_UP = 2,

  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_MEDIUM = 3;
   */
  MEDIUM = 3,

  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_WIDE = 4;
   */
  WIDE = 4,

  /**
   * @generated from enum value: DIRECTOR_SHOT_SIZE_TYPE_EXTREME_WIDE = 5;
   */
  EXTREME_WIDE = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorShotSizeType
 */
export type DirectorShotSizeTypeJson = "DIRECTOR_SHOT_SIZE_TYPE_UNSPECIFIED" | "DIRECTOR_SHOT_SIZE_TYPE_EXTREME_CLOSE_UP" | "DIRECTOR_SHOT_SIZE_TYPE_CLOSE_UP" | "DIRECTOR_SHOT_SIZE_TYPE_MEDIUM" | "DIRECTOR_SHOT_SIZE_TYPE_WIDE" | "DIRECTOR_SHOT_SIZE_TYPE_EXTREME_WIDE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorShotSizeType.
 */
export const DirectorShotSizeTypeSchema: GenEnum<DirectorShotSizeType, DirectorShotSizeTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 26);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorLensType
 */
export enum DirectorLensType {
  /**
   * @generated from enum value: DIRECTOR_LENS_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_LENS_TYPE_WIDE_ANGLE = 1;
   */
  WIDE_ANGLE = 1,

  /**
   * @generated from enum value: DIRECTOR_LENS_TYPE_STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: DIRECTOR_LENS_TYPE_TELEPHOTO = 3;
   */
  TELEPHOTO = 3,

  /**
   * @generated from enum value: DIRECTOR_LENS_TYPE_MACRO = 4;
   */
  MACRO = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorLensType
 */
export type DirectorLensTypeJson = "DIRECTOR_LENS_TYPE_UNSPECIFIED" | "DIRECTOR_LENS_TYPE_WIDE_ANGLE" | "DIRECTOR_LENS_TYPE_STANDARD" | "DIRECTOR_LENS_TYPE_TELEPHOTO" | "DIRECTOR_LENS_TYPE_MACRO";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorLensType.
 */
export const DirectorLensTypeSchema: GenEnum<DirectorLensType, DirectorLensTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 27);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementType
 */
export enum DirectorMovementType {
  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_STATIC = 1;
   */
  STATIC = 1,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_PAN = 2;
   */
  PAN = 2,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_DOLLY = 3;
   */
  DOLLY = 3,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_TRACKING = 4;
   */
  TRACKING = 4,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_TYPE_ORBIT = 5;
   */
  ORBIT = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementType
 */
export type DirectorMovementTypeJson = "DIRECTOR_MOVEMENT_TYPE_UNSPECIFIED" | "DIRECTOR_MOVEMENT_TYPE_STATIC" | "DIRECTOR_MOVEMENT_TYPE_PAN" | "DIRECTOR_MOVEMENT_TYPE_DOLLY" | "DIRECTOR_MOVEMENT_TYPE_TRACKING" | "DIRECTOR_MOVEMENT_TYPE_ORBIT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorMovementType.
 */
export const DirectorMovementTypeSchema: GenEnum<DirectorMovementType, DirectorMovementTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 28);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementIntensity
 */
export enum DirectorMovementIntensity {
  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_INTENSITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_INTENSITY_SUBTLE = 1;
   */
  SUBTLE = 1,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_INTENSITY_STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_INTENSITY_INTENSE = 3;
   */
  INTENSE = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementIntensity
 */
export type DirectorMovementIntensityJson = "DIRECTOR_MOVEMENT_INTENSITY_UNSPECIFIED" | "DIRECTOR_MOVEMENT_INTENSITY_SUBTLE" | "DIRECTOR_MOVEMENT_INTENSITY_STANDARD" | "DIRECTOR_MOVEMENT_INTENSITY_INTENSE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorMovementIntensity.
 */
export const DirectorMovementIntensitySchema: GenEnum<DirectorMovementIntensity, DirectorMovementIntensityJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 29);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementEasing
 */
export enum DirectorMovementEasing {
  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_EASING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_EASING_LINEAR = 1;
   */
  LINEAR = 1,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_EASING_STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: DIRECTOR_MOVEMENT_EASING_NATURAL = 3;
   */
  NATURAL = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.DirectorMovementEasing
 */
export type DirectorMovementEasingJson = "DIRECTOR_MOVEMENT_EASING_UNSPECIFIED" | "DIRECTOR_MOVEMENT_EASING_LINEAR" | "DIRECTOR_MOVEMENT_EASING_STANDARD" | "DIRECTOR_MOVEMENT_EASING_NATURAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.DirectorMovementEasing.
 */
export const DirectorMovementEasingSchema: GenEnum<DirectorMovementEasing, DirectorMovementEasingJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 30);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration
 */
export enum PromptToVideoGeneratorContentDuration {
  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_UNSPECIFIED = 0;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_4_SECONDS = 1;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_4_SECONDS = 1,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_6_SECONDS = 2;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_6_SECONDS = 2,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_8_SECONDS = 3;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_8_SECONDS = 3,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_5_SECONDS = 4;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_5_SECONDS = 4,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_7_SECONDS = 5;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_7_SECONDS = 5,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_9_SECONDS = 6;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_9_SECONDS = 6,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_10_SECONDS = 7;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_10_SECONDS = 7,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_11_SECONDS = 8;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_11_SECONDS = 8,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_12_SECONDS = 9;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_12_SECONDS = 9,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_13_SECONDS = 10;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_13_SECONDS = 10,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_14_SECONDS = 11;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_14_SECONDS = 11,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_15_SECONDS = 12;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_15_SECONDS = 12,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration
 */
export type PromptToVideoGeneratorContentDurationJson = "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_UNSPECIFIED" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_4_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_6_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_8_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_5_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_7_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_9_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_10_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_11_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_12_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_13_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_14_SECONDS" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_DURATION_15_SECONDS";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentDuration.
 */
export const PromptToVideoGeneratorContentDurationSchema: GenEnum<PromptToVideoGeneratorContentDuration, PromptToVideoGeneratorContentDurationJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 31);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution
 */
export enum PromptToVideoGeneratorContentResolution {
  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_UNSPECIFIED = 0;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_720P = 1;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_720P = 1,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_1080P = 2;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_1080P = 2,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_4K = 3;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_4K = 3,

  /**
   * minimax hailuo h3
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_2K = 4;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_2K = 4,

  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_480P = 5;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_480P = 5,

  /**
   * minimax hailuo h3
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_768P = 6;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_768P = 6,

  /**
   * gemini omni flash 1.1
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_360P = 7;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_360P = 7,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution
 */
export type PromptToVideoGeneratorContentResolutionJson = "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_UNSPECIFIED" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_720P" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_1080P" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_4K" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_2K" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_480P" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_768P" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_RESOLUTION_360P";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentResolution.
 */
export const PromptToVideoGeneratorContentResolutionSchema: GenEnum<PromptToVideoGeneratorContentResolution, PromptToVideoGeneratorContentResolutionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 32);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio
 */
export enum PromptToVideoGeneratorContentAspectRatio {
  /**
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_UNSPECIFIED = 0;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_UNSPECIFIED = 0,

  /**
   * all
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_1_1 = 1;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_1_1 = 1,

  /**
   * all
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_16_9 = 2;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_16_9 = 2,

  /**
   * all
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_9_16 = 3;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_9_16 = 3,

  /**
   * all
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_3 = 4;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_3 = 4,

  /**
   * all
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_4 = 5;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_4 = 5,

  /**
   * grok, veo
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_2 = 6;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_2 = 6,

  /**
   * grok, veo
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_2_3 = 7;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_2_3 = 7,

  /**
   * seedance 1.5 pro
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_21_9 = 8;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_21_9 = 8,

  /**
   * fal pika 2.1
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_5 = 9;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_5 = 9,

  /**
   * fal pika 2.1
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_5_4 = 10;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_5_4 = 10,

  /**
   * "auto" follows the input media (minimax hailuo h3: vendor "adaptive").
   *
   * @generated from enum value: PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_AUTO = 11;
   */
  PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_AUTO = 11,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio
 */
export type PromptToVideoGeneratorContentAspectRatioJson = "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_UNSPECIFIED" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_1_1" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_16_9" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_9_16" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_3" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_4" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_3_2" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_2_3" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_21_9" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_4_5" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_5_4" | "PROMPT_TO_VIDEO_GENERATOR_CONTENT_ASPECT_RATIO_AUTO";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContentAspectRatio.
 */
export const PromptToVideoGeneratorContentAspectRatioSchema: GenEnum<PromptToVideoGeneratorContentAspectRatio, PromptToVideoGeneratorContentAspectRatioJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 33);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SplatStyle
 */
export enum SplatStyle {
  /**
   * @generated from enum value: SPLAT_STYLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPLAT_STYLE_CINEMATIC_REALISM = 1;
   */
  CINEMATIC_REALISM = 1,

  /**
   * @generated from enum value: SPLAT_STYLE_STYLIZED_ANIMATION = 2;
   */
  STYLIZED_ANIMATION = 2,

  /**
   * @generated from enum value: SPLAT_STYLE_CYBERPUNK_SYNTHWAVE = 3;
   */
  CYBERPUNK_SYNTHWAVE = 3,

  /**
   * @generated from enum value: SPLAT_STYLE_LOW_POLY_RETRO = 4;
   */
  LOW_POLY_RETRO = 4,

  /**
   * @generated from enum value: SPLAT_STYLE_STUDIO_GHIBLI = 5;
   */
  STUDIO_GHIBLI = 5,

  /**
   * @generated from enum value: SPLAT_STYLE_VOXEL_ART = 6;
   */
  VOXEL_ART = 6,

  /**
   * @generated from enum value: SPLAT_STYLE_CLAYMATION_MINIATURE = 7;
   */
  CLAYMATION_MINIATURE = 7,

  /**
   * @generated from enum value: SPLAT_STYLE_DARK_FANTASY = 8;
   */
  DARK_FANTASY = 8,

  /**
   * @generated from enum value: SPLAT_STYLE_SCI_FI_TECH = 9;
   */
  SCI_FI_TECH = 9,

  /**
   * @generated from enum value: SPLAT_STYLE_CEL_SHADED = 10;
   */
  CEL_SHADED = 10,

  /**
   * @generated from enum value: SPLAT_STYLE_SURREAL_LIMINAL = 11;
   */
  SURREAL_LIMINAL = 11,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_JAPANDI = 12;
   */
  INTERIOR_JAPANDI = 12,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_INDUSTRIAL = 13;
   */
  INTERIOR_INDUSTRIAL = 13,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_MID_CENTURY = 14;
   */
  INTERIOR_MID_CENTURY = 14,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_BOHEMIAN = 15;
   */
  INTERIOR_BOHEMIAN = 15,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_CYBERPUNK = 16;
   */
  INTERIOR_CYBERPUNK = 16,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_ART_DECO = 17;
   */
  INTERIOR_ART_DECO = 17,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_MINIMALIST = 18;
   */
  INTERIOR_MINIMALIST = 18,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_RUSTIC = 19;
   */
  INTERIOR_RUSTIC = 19,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_DARK_ACADEMIA = 20;
   */
  INTERIOR_DARK_ACADEMIA = 20,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_BIOPHILIC = 21;
   */
  INTERIOR_BIOPHILIC = 21,

  /**
   * @generated from enum value: SPLAT_STYLE_INTERIOR_MEDIEVAL = 22;
   */
  INTERIOR_MEDIEVAL = 22,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.SplatStyle
 */
export type SplatStyleJson = "SPLAT_STYLE_UNSPECIFIED" | "SPLAT_STYLE_CINEMATIC_REALISM" | "SPLAT_STYLE_STYLIZED_ANIMATION" | "SPLAT_STYLE_CYBERPUNK_SYNTHWAVE" | "SPLAT_STYLE_LOW_POLY_RETRO" | "SPLAT_STYLE_STUDIO_GHIBLI" | "SPLAT_STYLE_VOXEL_ART" | "SPLAT_STYLE_CLAYMATION_MINIATURE" | "SPLAT_STYLE_DARK_FANTASY" | "SPLAT_STYLE_SCI_FI_TECH" | "SPLAT_STYLE_CEL_SHADED" | "SPLAT_STYLE_SURREAL_LIMINAL" | "SPLAT_STYLE_INTERIOR_JAPANDI" | "SPLAT_STYLE_INTERIOR_INDUSTRIAL" | "SPLAT_STYLE_INTERIOR_MID_CENTURY" | "SPLAT_STYLE_INTERIOR_BOHEMIAN" | "SPLAT_STYLE_INTERIOR_CYBERPUNK" | "SPLAT_STYLE_INTERIOR_ART_DECO" | "SPLAT_STYLE_INTERIOR_MINIMALIST" | "SPLAT_STYLE_INTERIOR_RUSTIC" | "SPLAT_STYLE_INTERIOR_DARK_ACADEMIA" | "SPLAT_STYLE_INTERIOR_BIOPHILIC" | "SPLAT_STYLE_INTERIOR_MEDIEVAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.SplatStyle.
 */
export const SplatStyleSchema: GenEnum<SplatStyle, SplatStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 34);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaType
 */
export enum MediaType {
  /**
   * @generated from enum value: MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_TYPE_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * @generated from enum value: MEDIA_TYPE_AUDIO = 2;
   */
  AUDIO = 2,

  /**
   * @generated from enum value: MEDIA_TYPE_CAD = 3;
   */
  CAD = 3,

  /**
   * @generated from enum value: MEDIA_TYPE_VIDEO = 4;
   */
  VIDEO = 4,

  /**
   * @generated from enum value: MEDIA_TYPE_JSON = 5;
   */
  JSON = 5,

  /**
   * @generated from enum value: MEDIA_TYPE_MESH = 6;
   */
  MESH = 6,

  /**
   * @generated from enum value: MEDIA_TYPE_SPLAT = 7;
   */
  SPLAT = 7,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaType
 */
export type MediaTypeJson = "MEDIA_TYPE_UNSPECIFIED" | "MEDIA_TYPE_IMAGE" | "MEDIA_TYPE_AUDIO" | "MEDIA_TYPE_CAD" | "MEDIA_TYPE_VIDEO" | "MEDIA_TYPE_JSON" | "MEDIA_TYPE_MESH" | "MEDIA_TYPE_SPLAT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MediaType.
 */
export const MediaTypeSchema: GenEnum<MediaType, MediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 35);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaStatus
 */
export enum MediaStatus {
  /**
   * @generated from enum value: MEDIA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_STATUS_UPLOAD_PENDING = 1;
   */
  UPLOAD_PENDING = 1,

  /**
   * @generated from enum value: MEDIA_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: MEDIA_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: MEDIA_STATUS_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaStatus
 */
export type MediaStatusJson = "MEDIA_STATUS_UNSPECIFIED" | "MEDIA_STATUS_UPLOAD_PENDING" | "MEDIA_STATUS_PROCESSING" | "MEDIA_STATUS_COMPLETED" | "MEDIA_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MediaStatus.
 */
export const MediaStatusSchema: GenEnum<MediaStatus, MediaStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 36);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrainAnalysisStatus
 */
export enum BrainAnalysisStatus {
  /**
   * @generated from enum value: BRAIN_ANALYSIS_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BRAIN_ANALYSIS_STATUS_PROCESSING = 1;
   */
  PROCESSING = 1,

  /**
   * @generated from enum value: BRAIN_ANALYSIS_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: BRAIN_ANALYSIS_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrainAnalysisStatus
 */
export type BrainAnalysisStatusJson = "BRAIN_ANALYSIS_STATUS_UNSPECIFIED" | "BRAIN_ANALYSIS_STATUS_PROCESSING" | "BRAIN_ANALYSIS_STATUS_COMPLETED" | "BRAIN_ANALYSIS_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.BrainAnalysisStatus.
 */
export const BrainAnalysisStatusSchema: GenEnum<BrainAnalysisStatus, BrainAnalysisStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 37);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.LyricWordType
 */
export enum LyricWordType {
  /**
   * @generated from enum value: LYRIC_WORD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LYRIC_WORD_TYPE_WORD = 1;
   */
  WORD = 1,

  /**
   * @generated from enum value: LYRIC_WORD_TYPE_SPACING = 2;
   */
  SPACING = 2,

  /**
   * @generated from enum value: LYRIC_WORD_TYPE_AUDIO_EVENT = 3;
   */
  AUDIO_EVENT = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.LyricWordType
 */
export type LyricWordTypeJson = "LYRIC_WORD_TYPE_UNSPECIFIED" | "LYRIC_WORD_TYPE_WORD" | "LYRIC_WORD_TYPE_SPACING" | "LYRIC_WORD_TYPE_AUDIO_EVENT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.LyricWordType.
 */
export const LyricWordTypeSchema: GenEnum<LyricWordType, LyricWordTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 38);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaSplatContentResolution
 */
export enum MediaSplatContentResolution {
  /**
   * @generated from enum value: MEDIA_SPLAT_CONTENT_RESOLUTION_UNSPECIFIED = 0;
   */
  MEDIA_SPLAT_CONTENT_RESOLUTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_SPLAT_CONTENT_RESOLUTION_FULL_RES = 1;
   */
  MEDIA_SPLAT_CONTENT_RESOLUTION_FULL_RES = 1,

  /**
   * @generated from enum value: MEDIA_SPLAT_CONTENT_RESOLUTION_100K = 2;
   */
  MEDIA_SPLAT_CONTENT_RESOLUTION_100K = 2,

  /**
   * @generated from enum value: MEDIA_SPLAT_CONTENT_RESOLUTION_150K = 3;
   */
  MEDIA_SPLAT_CONTENT_RESOLUTION_150K = 3,

  /**
   * @generated from enum value: MEDIA_SPLAT_CONTENT_RESOLUTION_500K = 4;
   */
  MEDIA_SPLAT_CONTENT_RESOLUTION_500K = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MediaSplatContentResolution
 */
export type MediaSplatContentResolutionJson = "MEDIA_SPLAT_CONTENT_RESOLUTION_UNSPECIFIED" | "MEDIA_SPLAT_CONTENT_RESOLUTION_FULL_RES" | "MEDIA_SPLAT_CONTENT_RESOLUTION_100K" | "MEDIA_SPLAT_CONTENT_RESOLUTION_150K" | "MEDIA_SPLAT_CONTENT_RESOLUTION_500K";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MediaSplatContentResolution.
 */
export const MediaSplatContentResolutionSchema: GenEnum<MediaSplatContentResolution, MediaSplatContentResolutionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 39);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ImageGeneratorModel
 */
export enum ImageGeneratorModel {
  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GEMINI_25_FLASH = 1;
   */
  GEMINI_25_FLASH = 1,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GEMINI_3_PRO_PREVIEW = 2;
   */
  GEMINI_3_PRO_PREVIEW = 2,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GEMINI_3_1_FLASH_IMAGE_PREVIEW = 3;
   */
  GEMINI_3_1_FLASH_IMAGE_PREVIEW = 3,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_SEEDREAM_5_LITE = 4;
   */
  SEEDREAM_5_LITE = 4,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_RECRAFT_V4 = 5;
   */
  RECRAFT_V4 = 5,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GPT_IMAGE_2 = 6;
   */
  GPT_IMAGE_2 = 6,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_SEEDREAM_5_PRO = 7;
   */
  SEEDREAM_5_PRO = 7,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_FAL_SMART_RESIZE = 8;
   */
  FAL_SMART_RESIZE = 8,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_IDEOGRAM_V4_5 = 9;
   */
  IDEOGRAM_V4_5 = 9,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_SEEDREAM_5_FLASH = 10;
   */
  SEEDREAM_5_FLASH = 10,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GPT_IMAGE_2_5_FLARE = 11;
   */
  GPT_IMAGE_2_5_FLARE = 11,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_GPT_IMAGE_2_5_SUNBURST = 12;
   */
  GPT_IMAGE_2_5_SUNBURST = 12,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_NANO_BANANA_2_1 = 13;
   */
  NANO_BANANA_2_1 = 13,

  /**
   * @generated from enum value: IMAGE_GENERATOR_MODEL_KREA_3 = 14;
   */
  KREA_3 = 14,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ImageGeneratorModel
 */
export type ImageGeneratorModelJson = "IMAGE_GENERATOR_MODEL_UNSPECIFIED" | "IMAGE_GENERATOR_MODEL_GEMINI_25_FLASH" | "IMAGE_GENERATOR_MODEL_GEMINI_3_PRO_PREVIEW" | "IMAGE_GENERATOR_MODEL_GEMINI_3_1_FLASH_IMAGE_PREVIEW" | "IMAGE_GENERATOR_MODEL_SEEDREAM_5_LITE" | "IMAGE_GENERATOR_MODEL_RECRAFT_V4" | "IMAGE_GENERATOR_MODEL_GPT_IMAGE_2" | "IMAGE_GENERATOR_MODEL_SEEDREAM_5_PRO" | "IMAGE_GENERATOR_MODEL_FAL_SMART_RESIZE" | "IMAGE_GENERATOR_MODEL_IDEOGRAM_V4_5" | "IMAGE_GENERATOR_MODEL_SEEDREAM_5_FLASH" | "IMAGE_GENERATOR_MODEL_GPT_IMAGE_2_5_FLARE" | "IMAGE_GENERATOR_MODEL_GPT_IMAGE_2_5_SUNBURST" | "IMAGE_GENERATOR_MODEL_NANO_BANANA_2_1" | "IMAGE_GENERATOR_MODEL_KREA_3";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ImageGeneratorModel.
 */
export const ImageGeneratorModelSchema: GenEnum<ImageGeneratorModel, ImageGeneratorModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 40);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoGeneratorModel
 */
export enum VideoGeneratorModel {
  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_VEO_31_FAST_GENERATE_PREVIEW = 1;
   */
  VEO_31_FAST_GENERATE_PREVIEW = 1,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_GROK_IMAGINE_VIDEO = 2;
   */
  GROK_IMAGINE_VIDEO = 2,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDDREAM_2 = 3;
   */
  BYTEDANCE_SEEDDREAM_2 = 3,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_1_5_PRO = 4;
   */
  BYTEDANCE_SEEDANCE_1_5_PRO = 4,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_AI_V3 = 5;
   */
  KLING_AI_V3 = 5,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_RUNWAY_GEN_4_5 = 6;
   */
  RUNWAY_GEN_4_5 = 6,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_LUMA_RAY_2 = 7;
   */
  LUMA_RAY_2 = 7,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_FAL_PIKA_2_1 = 8;
   */
  FAL_PIKA_2_1 = 8,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_AI_V3_MOTION_CONTROL = 9;
   */
  KLING_AI_V3_MOTION_CONTROL = 9,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_ALIBABA_HAPPY_HORSE_V1 = 10;
   */
  ALIBABA_HAPPY_HORSE_V1 = 10,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_ALIBABA_WAN_2_7 = 11;
   */
  ALIBABA_WAN_2_7 = 11,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MULEROUTER_WAN_2_7_SPICY = 12;
   */
  MULEROUTER_WAN_2_7_SPICY = 12,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_FAL_LTX_2_3 = 13;
   */
  FAL_LTX_2_3 = 13,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_AI_V3_TURBO = 14;
   */
  KLING_AI_V3_TURBO = 14,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_LUMA_RAY_3_2 = 15;
   */
  LUMA_RAY_3_2 = 15,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_FAL_PIXVERSE_V6 = 16;
   */
  FAL_PIXVERSE_V6 = 16,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_FAL_PIXVERSE_C1 = 17;
   */
  FAL_PIXVERSE_C1 = 17,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_HEYGEN_AVATAR_5 = 18;
   */
  HEYGEN_AVATAR_5 = 18,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_ALIBABA_HAPPY_HORSE_V1_1 = 19;
   */
  ALIBABA_HAPPY_HORSE_V1_1 = 19,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH = 20;
   */
  GEMINI_OMNI_FLASH = 20,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_FAST = 21;
   */
  BYTEDANCE_SEEDANCE_2_FAST = 21,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_MINI = 22;
   */
  BYTEDANCE_SEEDANCE_2_MINI = 22,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_V3_OMNI = 23;
   */
  KLING_V3_OMNI = 23,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3 = 24;
   */
  MINIMAX_HAILUO_V3 = 24,

  /**
   * black forest labs flux 3
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_FLUX_3 = 25;
   */
  FLUX_3 = 25,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_5 = 26;
   */
  BYTEDANCE_SEEDANCE_2_5 = 26,

  /**
   * direct Pika API (replaces fal-hosted Pika 2.1)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_PIKA_2_5 = 27;
   */
  PIKA_2_5 = 27,

  /**
   * all-in-one reference video (wan3.0-video)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_ALIBABA_WAN_3_0 = 28;
   */
  ALIBABA_WAN_3_0 = 28,

  /**
   * faster hardware variant (wan3.0-video-prime)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_ALIBABA_WAN_3_0_PRIME = 29;
   */
  ALIBABA_WAN_3_0_PRIME = 29,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0 = 30;
   */
  MULEROUTER_BERRY_1_0 = 30,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_PRO = 31;
   */
  MULEROUTER_BERRY_1_0_PRO = 31,

  /**
   * xAI Grok Imagine 1.5 (native 1080p)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_GROK_IMAGINE_VIDEO_1_5 = 32;
   */
  GROK_IMAGINE_VIDEO_1_5 = 32,

  /**
   * @generated from enum value: VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH_1_1 = 33;
   */
  GEMINI_OMNI_FLASH_1_1 = 33,

  /**
   * duration means extension length, not total output length
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED = 34;
   */
  GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED = 34,

  /**
   * MiniMax H3 Max: the fast H3 variant. Text-to-video and first/last-frame
   * image-to-video only (no reference image/video/audio, no studio assets),
   * 480P/768P output (no 2K), 5-15s.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_MAX = 35;
   */
  MINIMAX_HAILUO_V3_MAX = 35,

  /**
   * MiniMax H3 Fast: the quickest H3 variant. 480P only, 5-15s. Unlike H3
   * Max it keeps the full reference channel (reference image/audio/video and
   * studio assets) alongside first/last-frame image-to-video. Does not offer
   * an "auto" aspect ratio: the vendor rejects adaptive for this model.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_FAST = 36;
   */
  MINIMAX_HAILUO_V3_FAST = 36,

  /**
   * MiniMax H3 Max Turbo: the cheaper H3 Max tier with the same capability
   * set. Text-to-video and first/last-frame image-to-video only (no reference
   * image/video/audio, no studio assets), 480P/768P output, 5-15s.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_MAX_TURBO = 37;
   */
  MINIMAX_HAILUO_V3_MAX_TURBO = 37,

  /**
   * WAN 3.0 Prime Spicy (berry-1.0-turbo)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_TURBO = 38;
   */
  MULEROUTER_BERRY_1_0_TURBO = 38,

  /**
   * WAN 3.0 Pro Prime Spicy (berry-1.0-pro-turbo)
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_PRO_TURBO = 39;
   */
  MULEROUTER_BERRY_1_0_PRO_TURBO = 39,

  /**
   * Seedance 2.5 video extension: takes one source video and extends it.
   * Like the Omni Flash extend model, duration means extension length, not
   * total output length; the output aspect ratio is inherited from the source
   * (the vendor requires ratio=adaptive).
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED = 40;
   */
  BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED = 40,

  /**
   * Wan 2.2 on the Aurora network, offered on the Unlimited surface only.
   * Text-to-video, 720p, 5 seconds, 16:9 or 9:16, no audio.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_AURORA_WAN_2_2 = 41;
   */
  AURORA_WAN_2_2 = 41,

  /**
   * Kling Video 4.0 Flash. Text-to-video (21:9, 16:9, 9:16 or 1:1) and
   * first-frame image-to-video, 720p, 3-20 seconds.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_V4_FLASH = 42;
   */
  KLING_V4_FLASH = 42,

  /**
   * Kling Video 4.0. Text-to-video (21:9, 16:9, 9:16 or 1:1) and
   * image-to-video from a first and optional last frame, 720p or 1080p,
   * 3-30 seconds.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_KLING_V4 = 43;
   */
  KLING_V4 = 43,

  /**
   * HeyGen Video 1.0 (a post-train of MiniMax H3). Text-to-video,
   * first-frame image-to-video or reference-to-video (images, videos, audio),
   * 480p-2k, 5-15 seconds, native audio.
   *
   * @generated from enum value: VIDEO_GENERATOR_MODEL_HEYGEN_VIDEO_1 = 44;
   */
  HEYGEN_VIDEO_1 = 44,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoGeneratorModel
 */
export type VideoGeneratorModelJson = "VIDEO_GENERATOR_MODEL_UNSPECIFIED" | "VIDEO_GENERATOR_MODEL_VEO_31_FAST_GENERATE_PREVIEW" | "VIDEO_GENERATOR_MODEL_GROK_IMAGINE_VIDEO" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDDREAM_2" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_1_5_PRO" | "VIDEO_GENERATOR_MODEL_KLING_AI_V3" | "VIDEO_GENERATOR_MODEL_RUNWAY_GEN_4_5" | "VIDEO_GENERATOR_MODEL_LUMA_RAY_2" | "VIDEO_GENERATOR_MODEL_FAL_PIKA_2_1" | "VIDEO_GENERATOR_MODEL_KLING_AI_V3_MOTION_CONTROL" | "VIDEO_GENERATOR_MODEL_ALIBABA_HAPPY_HORSE_V1" | "VIDEO_GENERATOR_MODEL_ALIBABA_WAN_2_7" | "VIDEO_GENERATOR_MODEL_MULEROUTER_WAN_2_7_SPICY" | "VIDEO_GENERATOR_MODEL_FAL_LTX_2_3" | "VIDEO_GENERATOR_MODEL_KLING_AI_V3_TURBO" | "VIDEO_GENERATOR_MODEL_LUMA_RAY_3_2" | "VIDEO_GENERATOR_MODEL_FAL_PIXVERSE_V6" | "VIDEO_GENERATOR_MODEL_FAL_PIXVERSE_C1" | "VIDEO_GENERATOR_MODEL_HEYGEN_AVATAR_5" | "VIDEO_GENERATOR_MODEL_ALIBABA_HAPPY_HORSE_V1_1" | "VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_FAST" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_MINI" | "VIDEO_GENERATOR_MODEL_KLING_V3_OMNI" | "VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3" | "VIDEO_GENERATOR_MODEL_FLUX_3" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_5" | "VIDEO_GENERATOR_MODEL_PIKA_2_5" | "VIDEO_GENERATOR_MODEL_ALIBABA_WAN_3_0" | "VIDEO_GENERATOR_MODEL_ALIBABA_WAN_3_0_PRIME" | "VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0" | "VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_PRO" | "VIDEO_GENERATOR_MODEL_GROK_IMAGINE_VIDEO_1_5" | "VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH_1_1" | "VIDEO_GENERATOR_MODEL_GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED" | "VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_MAX" | "VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_FAST" | "VIDEO_GENERATOR_MODEL_MINIMAX_HAILUO_V3_MAX_TURBO" | "VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_TURBO" | "VIDEO_GENERATOR_MODEL_MULEROUTER_BERRY_1_0_PRO_TURBO" | "VIDEO_GENERATOR_MODEL_BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED" | "VIDEO_GENERATOR_MODEL_AURORA_WAN_2_2" | "VIDEO_GENERATOR_MODEL_KLING_V4_FLASH" | "VIDEO_GENERATOR_MODEL_KLING_V4" | "VIDEO_GENERATOR_MODEL_HEYGEN_VIDEO_1";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoGeneratorModel.
 */
export const VideoGeneratorModelSchema: GenEnum<VideoGeneratorModel, VideoGeneratorModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 41);

/**
 * VideoEditorModel identifies a Video Editor model in the ListModels catalog.
 * Video editor requests carry no model field — the FE selects the model by
 * which model_config oneof member it sends: VIDEO_EDITOR_MODEL_HAPPYHORSE_V1
 * -> happyhorse_v1_config, VIDEO_EDITOR_MODEL_GEMINI_OMNI_FLASH ->
 * gemini_omni_flash_config, VIDEO_EDITOR_MODEL_GROK_IMAGINE_VIDEO_1_5 ->
 * grok_imagine_video_1_5_config. WAN 3.0 and WAN 3.0 Prime share a config
 * type and are told apart by member name: wan_3_0_config vs
 * wan_3_0_prime_config. FLUX 3 Video Editing Fast and High likewise share
 * Flux3VideoEditingVideoEditConfig and are told apart by member name:
 * flux_3_video_editing_fast_config vs flux_3_video_editing_high_config.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoEditorModel
 */
export enum VideoEditorModel {
  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_HAPPYHORSE_V1 = 1;
   */
  HAPPYHORSE_V1 = 1,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_GEMINI_OMNI_FLASH = 2;
   */
  GEMINI_OMNI_FLASH = 2,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_GROK_IMAGINE_VIDEO_1_5 = 3;
   */
  GROK_IMAGINE_VIDEO_1_5 = 3,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_MINIMAX_HAILUO_V3 = 4;
   */
  MINIMAX_HAILUO_V3 = 4,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_WAN_3_0 = 5;
   */
  WAN_3_0 = 5,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_WAN_3_0_PRIME = 6;
   */
  WAN_3_0_PRIME = 6,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_FLUX_3_VIDEO_EDITING_FAST = 7;
   */
  FLUX_3_VIDEO_EDITING_FAST = 7,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_FLUX_3_VIDEO_EDITING_HIGH = 8;
   */
  FLUX_3_VIDEO_EDITING_HIGH = 8,

  /**
   * @generated from enum value: VIDEO_EDITOR_MODEL_BYTEDANCE_SEEDANCE_2_5 = 9;
   */
  BYTEDANCE_SEEDANCE_2_5 = 9,
}

/**
 * VideoEditorModel identifies a Video Editor model in the ListModels catalog.
 * Video editor requests carry no model field — the FE selects the model by
 * which model_config oneof member it sends: VIDEO_EDITOR_MODEL_HAPPYHORSE_V1
 * -> happyhorse_v1_config, VIDEO_EDITOR_MODEL_GEMINI_OMNI_FLASH ->
 * gemini_omni_flash_config, VIDEO_EDITOR_MODEL_GROK_IMAGINE_VIDEO_1_5 ->
 * grok_imagine_video_1_5_config. WAN 3.0 and WAN 3.0 Prime share a config
 * type and are told apart by member name: wan_3_0_config vs
 * wan_3_0_prime_config. FLUX 3 Video Editing Fast and High likewise share
 * Flux3VideoEditingVideoEditConfig and are told apart by member name:
 * flux_3_video_editing_fast_config vs flux_3_video_editing_high_config.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoEditorModel
 */
export type VideoEditorModelJson = "VIDEO_EDITOR_MODEL_UNSPECIFIED" | "VIDEO_EDITOR_MODEL_HAPPYHORSE_V1" | "VIDEO_EDITOR_MODEL_GEMINI_OMNI_FLASH" | "VIDEO_EDITOR_MODEL_GROK_IMAGINE_VIDEO_1_5" | "VIDEO_EDITOR_MODEL_MINIMAX_HAILUO_V3" | "VIDEO_EDITOR_MODEL_WAN_3_0" | "VIDEO_EDITOR_MODEL_WAN_3_0_PRIME" | "VIDEO_EDITOR_MODEL_FLUX_3_VIDEO_EDITING_FAST" | "VIDEO_EDITOR_MODEL_FLUX_3_VIDEO_EDITING_HIGH" | "VIDEO_EDITOR_MODEL_BYTEDANCE_SEEDANCE_2_5";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoEditorModel.
 */
export const VideoEditorModelSchema: GenEnum<VideoEditorModel, VideoEditorModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 42);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameType
 */
export enum VideoFrameType {
  /**
   * @generated from enum value: VIDEO_FRAME_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_FRAME_TYPE_FIRST = 1;
   */
  FIRST = 1,

  /**
   * @generated from enum value: VIDEO_FRAME_TYPE_LAST = 2;
   */
  LAST = 2,

  /**
   * @generated from enum value: VIDEO_FRAME_TYPE_REFERENCE = 3;
   */
  REFERENCE = 3,

  /**
   * @generated from enum value: VIDEO_FRAME_TYPE_ATTACHMENT = 4;
   */
  ATTACHMENT = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameType
 */
export type VideoFrameTypeJson = "VIDEO_FRAME_TYPE_UNSPECIFIED" | "VIDEO_FRAME_TYPE_FIRST" | "VIDEO_FRAME_TYPE_LAST" | "VIDEO_FRAME_TYPE_REFERENCE" | "VIDEO_FRAME_TYPE_ATTACHMENT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoFrameType.
 */
export const VideoFrameTypeSchema: GenEnum<VideoFrameType, VideoFrameTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 43);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameInputMediaType
 */
export enum VideoFrameInputMediaType {
  /**
   * @generated from enum value: VIDEO_FRAME_INPUT_MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_FRAME_INPUT_MEDIA_TYPE_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * @generated from enum value: VIDEO_FRAME_INPUT_MEDIA_TYPE_AUDIO = 2;
   */
  AUDIO = 2,

  /**
   * @generated from enum value: VIDEO_FRAME_INPUT_MEDIA_TYPE_VIDEO = 3;
   */
  VIDEO = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameInputMediaType
 */
export type VideoFrameInputMediaTypeJson = "VIDEO_FRAME_INPUT_MEDIA_TYPE_UNSPECIFIED" | "VIDEO_FRAME_INPUT_MEDIA_TYPE_IMAGE" | "VIDEO_FRAME_INPUT_MEDIA_TYPE_AUDIO" | "VIDEO_FRAME_INPUT_MEDIA_TYPE_VIDEO";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoFrameInputMediaType.
 */
export const VideoFrameInputMediaTypeSchema: GenEnum<VideoFrameInputMediaType, VideoFrameInputMediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 44);

/**
 * VideoFrameReferenceType tags how a REFERENCE image is used by models that
 * support typed references. PixVerse C1 reference-to-video uses it to route a
 * reference image as the video's subject or its background. Unspecified lets
 * the provider apply its default (background for PixVerse C1).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType
 */
export enum VideoFrameReferenceType {
  /**
   * @generated from enum value: VIDEO_FRAME_REFERENCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_FRAME_REFERENCE_TYPE_SUBJECT = 1;
   */
  SUBJECT = 1,

  /**
   * @generated from enum value: VIDEO_FRAME_REFERENCE_TYPE_BACKGROUND = 2;
   */
  BACKGROUND = 2,
}

/**
 * VideoFrameReferenceType tags how a REFERENCE image is used by models that
 * support typed references. PixVerse C1 reference-to-video uses it to route a
 * reference image as the video's subject or its background. Unspecified lets
 * the provider apply its default (background for PixVerse C1).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType
 */
export type VideoFrameReferenceTypeJson = "VIDEO_FRAME_REFERENCE_TYPE_UNSPECIFIED" | "VIDEO_FRAME_REFERENCE_TYPE_SUBJECT" | "VIDEO_FRAME_REFERENCE_TYPE_BACKGROUND";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoFrameReferenceType.
 */
export const VideoFrameReferenceTypeSchema: GenEnum<VideoFrameReferenceType, VideoFrameReferenceTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 45);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorModel
 */
export enum MusicGeneratorModel {
  /**
   * @generated from enum value: MUSIC_GENERATOR_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MUSIC_GENERATOR_MODEL_ELEVEN_LABS = 1;
   */
  ELEVEN_LABS = 1,

  /**
   * full length song
   *
   * @generated from enum value: MUSIC_GENERATOR_MODEL_LYRIA_3 = 2;
   */
  LYRIA_3 = 2,

  /**
   * @generated from enum value: MUSIC_GENERATOR_MODEL_LYRIA_2 = 3;
   */
  LYRIA_2 = 3,

  /**
   * 30 seconds clip
   *
   * @generated from enum value: MUSIC_GENERATOR_MODEL_LYRIA_3_PREVIEW_CLIP = 4;
   */
  LYRIA_3_PREVIEW_CLIP = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MusicGeneratorModel
 */
export type MusicGeneratorModelJson = "MUSIC_GENERATOR_MODEL_UNSPECIFIED" | "MUSIC_GENERATOR_MODEL_ELEVEN_LABS" | "MUSIC_GENERATOR_MODEL_LYRIA_3" | "MUSIC_GENERATOR_MODEL_LYRIA_2" | "MUSIC_GENERATOR_MODEL_LYRIA_3_PREVIEW_CLIP";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MusicGeneratorModel.
 */
export const MusicGeneratorModelSchema: GenEnum<MusicGeneratorModel, MusicGeneratorModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 46);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ToolType
 */
export enum ToolType {
  /**
   * @generated from enum value: TOOL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOOL_TYPE_UPSCALER = 1;
   */
  UPSCALER = 1,

  /**
   * @generated from enum value: TOOL_TYPE_QUOTE_GENERATOR = 2;
   */
  QUOTE_GENERATOR = 2,

  /**
   * @generated from enum value: TOOL_TYPE_DESIGN_REVIEWER = 3;
   */
  DESIGN_REVIEWER = 3,

  /**
   * @generated from enum value: TOOL_TYPE_IMAGE_EDITOR = 4;
   */
  IMAGE_EDITOR = 4,

  /**
   * @generated from enum value: TOOL_TYPE_AI_MUSIC_GENERATOR = 5;
   */
  AI_MUSIC_GENERATOR = 5,

  /**
   * @generated from enum value: TOOL_TYPE_AI_WATERMARK_REMOVER = 6;
   */
  AI_WATERMARK_REMOVER = 6,

  /**
   * @generated from enum value: TOOL_TYPE_SOUND_GENERATOR = 7;
   */
  SOUND_GENERATOR = 7,

  /**
   * @generated from enum value: TOOL_TYPE_SPEECH_GENERATOR = 8;
   */
  SPEECH_GENERATOR = 8,

  /**
   * @generated from enum value: TOOL_TYPE_COLLAGE_MAKER = 9;
   */
  COLLAGE_MAKER = 9,

  /**
   * @generated from enum value: TOOL_TYPE_MOCKUP_GENERATOR = 10;
   */
  MOCKUP_GENERATOR = 10,

  /**
   * @generated from enum value: TOOL_TYPE_FILE_CONVERTER = 11;
   */
  FILE_CONVERTER = 11,

  /**
   * @generated from enum value: TOOL_TYPE_STUDIO_DESIGNER = 12;
   */
  STUDIO_DESIGNER = 12,

  /**
   * @generated from enum value: TOOL_TYPE_VECTORIZER = 13;
   */
  VECTORIZER = 13,

  /**
   * @generated from enum value: TOOL_TYPE_BG_REMOVER = 14;
   */
  BG_REMOVER = 14,

  /**
   * @generated from enum value: TOOL_TYPE_FLOW = 15;
   */
  FLOW = 15,

  /**
   * @generated from enum value: TOOL_TYPE_LOGO_GENERATOR = 16;
   */
  LOGO_GENERATOR = 16,

  /**
   * @generated from enum value: TOOL_TYPE_FONT_GENERATOR = 17;
   */
  FONT_GENERATOR = 17,

  /**
   * @generated from enum value: TOOL_TYPE_IMAGE_COMPRESSOR = 18;
   */
  IMAGE_COMPRESSOR = 18,

  /**
   * @generated from enum value: TOOL_TYPE_TRANSFERS = 19;
   */
  TRANSFERS = 19,

  /**
   * @generated from enum value: TOOL_TYPE_THREED_MODEL_VIEWER = 20;
   */
  THREED_MODEL_VIEWER = 20,

  /**
   * @generated from enum value: TOOL_TYPE_DOODLE_PET = 21;
   */
  DOODLE_PET = 21,

  /**
   * @generated from enum value: TOOL_TYPE_THREE_D_MODEL_GENERATOR = 22;
   */
  THREE_D_MODEL_GENERATOR = 22,

  /**
   * @generated from enum value: TOOL_TYPE_PEOPLE_REMOVER_FROM_BACKGROUND = 23;
   */
  PEOPLE_REMOVER_FROM_BACKGROUND = 23,

  /**
   * @generated from enum value: TOOL_TYPE_COLORING_PAGE_MAKER = 24;
   */
  COLORING_PAGE_MAKER = 24,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_GENERATOR = 25;
   */
  VIDEO_GENERATOR = 25,

  /**
   * @generated from enum value: TOOL_TYPE_WEDDING_INVITE_GENERATOR = 26;
   */
  WEDDING_INVITE_GENERATOR = 26,

  /**
   * @generated from enum value: TOOL_TYPE_ETSY_COACH = 27;
   */
  ETSY_COACH = 27,

  /**
   * @generated from enum value: TOOL_TYPE_COLOR_PALETTE_PICKER = 28;
   */
  COLOR_PALETTE_PICKER = 28,

  /**
   * @generated from enum value: TOOL_TYPE_AI_PHOTO_STYLE = 29;
   */
  AI_PHOTO_STYLE = 29,

  /**
   * @generated from enum value: TOOL_TYPE_TOON_FAMILY_BUILDER = 30;
   */
  TOON_FAMILY_BUILDER = 30,

  /**
   * @generated from enum value: TOOL_TYPE_IMAGE_RESIZER = 31;
   */
  IMAGE_RESIZER = 31,

  /**
   * @generated from enum value: TOOL_TYPE_MESH_GENERATOR = 32;
   */
  MESH_GENERATOR = 32,

  /**
   * @generated from enum value: TOOL_TYPE_THREE_D_SCULPT = 33;
   */
  THREE_D_SCULPT = 33,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_UPSCALER = 34;
   */
  VIDEO_UPSCALER = 34,

  /**
   * @generated from enum value: TOOL_TYPE_AI_MOCKUP_GENERATOR = 35;
   */
  AI_MOCKUP_GENERATOR = 35,

  /**
   * @generated from enum value: TOOL_TYPE_CAMERA_ANGLE = 36;
   */
  CAMERA_ANGLE = 36,

  /**
   * @generated from enum value: TOOL_TYPE_MARKETPLACE_EDITOR = 37;
   */
  MARKETPLACE_EDITOR = 37,

  /**
   * @generated from enum value: TOOL_TYPE_AISVG_GENERATOR = 38;
   */
  AISVG_GENERATOR = 38,

  /**
   * @generated from enum value: TOOL_TYPE_SPLAT_GENERATOR = 39;
   */
  SPLAT_GENERATOR = 39,

  /**
   * @generated from enum value: TOOL_TYPE_LUMO = 40;
   */
  LUMO = 40,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_CUTOUTS = 41;
   */
  VIDEO_CUTOUTS = 41,

  /**
   * @generated from enum value: TOOL_TYPE_AD_CAMPAIGNS = 42;
   */
  AD_CAMPAIGNS = 42,

  /**
   * @generated from enum value: TOOL_TYPE_SUBTITLE_GENERATOR = 43;
   */
  SUBTITLE_GENERATOR = 43,

  /**
   * @generated from enum value: TOOL_TYPE_PRODUCT_MANAGER = 44;
   */
  PRODUCT_MANAGER = 44,

  /**
   * @generated from enum value: TOOL_TYPE_CHARACTER_MANAGEMENT = 45;
   */
  CHARACTER_MANAGEMENT = 45,

  /**
   * @generated from enum value: TOOL_TYPE_IMAGE_ALIVE = 46;
   */
  IMAGE_ALIVE = 46,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_EDITOR = 47;
   */
  VIDEO_EDITOR = 47,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_UNCENSORED = 48;
   */
  VIDEO_UNCENSORED = 48,

  /**
   * @generated from enum value: TOOL_TYPE_YOUTUBE_THUMBNAIL_GENERATOR = 49;
   */
  YOUTUBE_THUMBNAIL_GENERATOR = 49,

  /**
   * @generated from enum value: TOOL_TYPE_INPAINT = 50;
   */
  INPAINT = 50,

  /**
   * @generated from enum value: TOOL_TYPE_IMAGE_LAYERIZER = 51;
   */
  IMAGE_LAYERIZER = 51,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_IMAGE_GENERATOR = 52;
   */
  UNLIMITED_IMAGE_GENERATOR = 52,

  /**
   * @generated from enum value: TOOL_TYPE_AD_BANNER_RESIZER = 53;
   */
  AD_BANNER_RESIZER = 53,

  /**
   * @generated from enum value: TOOL_TYPE_VIDEO_DRAFT = 54;
   */
  VIDEO_DRAFT = 54,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_BG_REMOVER = 55;
   */
  UNLIMITED_BG_REMOVER = 55,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_UPSCALER = 56;
   */
  UNLIMITED_UPSCALER = 56,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_VECTORIZER = 57;
   */
  UNLIMITED_VECTORIZER = 57,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_VIDEO_GENERATOR = 58;
   */
  UNLIMITED_VIDEO_GENERATOR = 58,

  /**
   * @generated from enum value: TOOL_TYPE_UNLIMITED_SPEECH_GENERATOR = 59;
   */
  UNLIMITED_SPEECH_GENERATOR = 59,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ToolType
 */
export type ToolTypeJson = "TOOL_TYPE_UNSPECIFIED" | "TOOL_TYPE_UPSCALER" | "TOOL_TYPE_QUOTE_GENERATOR" | "TOOL_TYPE_DESIGN_REVIEWER" | "TOOL_TYPE_IMAGE_EDITOR" | "TOOL_TYPE_AI_MUSIC_GENERATOR" | "TOOL_TYPE_AI_WATERMARK_REMOVER" | "TOOL_TYPE_SOUND_GENERATOR" | "TOOL_TYPE_SPEECH_GENERATOR" | "TOOL_TYPE_COLLAGE_MAKER" | "TOOL_TYPE_MOCKUP_GENERATOR" | "TOOL_TYPE_FILE_CONVERTER" | "TOOL_TYPE_STUDIO_DESIGNER" | "TOOL_TYPE_VECTORIZER" | "TOOL_TYPE_BG_REMOVER" | "TOOL_TYPE_FLOW" | "TOOL_TYPE_LOGO_GENERATOR" | "TOOL_TYPE_FONT_GENERATOR" | "TOOL_TYPE_IMAGE_COMPRESSOR" | "TOOL_TYPE_TRANSFERS" | "TOOL_TYPE_THREED_MODEL_VIEWER" | "TOOL_TYPE_DOODLE_PET" | "TOOL_TYPE_THREE_D_MODEL_GENERATOR" | "TOOL_TYPE_PEOPLE_REMOVER_FROM_BACKGROUND" | "TOOL_TYPE_COLORING_PAGE_MAKER" | "TOOL_TYPE_VIDEO_GENERATOR" | "TOOL_TYPE_WEDDING_INVITE_GENERATOR" | "TOOL_TYPE_ETSY_COACH" | "TOOL_TYPE_COLOR_PALETTE_PICKER" | "TOOL_TYPE_AI_PHOTO_STYLE" | "TOOL_TYPE_TOON_FAMILY_BUILDER" | "TOOL_TYPE_IMAGE_RESIZER" | "TOOL_TYPE_MESH_GENERATOR" | "TOOL_TYPE_THREE_D_SCULPT" | "TOOL_TYPE_VIDEO_UPSCALER" | "TOOL_TYPE_AI_MOCKUP_GENERATOR" | "TOOL_TYPE_CAMERA_ANGLE" | "TOOL_TYPE_MARKETPLACE_EDITOR" | "TOOL_TYPE_AISVG_GENERATOR" | "TOOL_TYPE_SPLAT_GENERATOR" | "TOOL_TYPE_LUMO" | "TOOL_TYPE_VIDEO_CUTOUTS" | "TOOL_TYPE_AD_CAMPAIGNS" | "TOOL_TYPE_SUBTITLE_GENERATOR" | "TOOL_TYPE_PRODUCT_MANAGER" | "TOOL_TYPE_CHARACTER_MANAGEMENT" | "TOOL_TYPE_IMAGE_ALIVE" | "TOOL_TYPE_VIDEO_EDITOR" | "TOOL_TYPE_VIDEO_UNCENSORED" | "TOOL_TYPE_YOUTUBE_THUMBNAIL_GENERATOR" | "TOOL_TYPE_INPAINT" | "TOOL_TYPE_IMAGE_LAYERIZER" | "TOOL_TYPE_UNLIMITED_IMAGE_GENERATOR" | "TOOL_TYPE_AD_BANNER_RESIZER" | "TOOL_TYPE_VIDEO_DRAFT" | "TOOL_TYPE_UNLIMITED_BG_REMOVER" | "TOOL_TYPE_UNLIMITED_UPSCALER" | "TOOL_TYPE_UNLIMITED_VECTORIZER" | "TOOL_TYPE_UNLIMITED_VIDEO_GENERATOR" | "TOOL_TYPE_UNLIMITED_SPEECH_GENERATOR";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ToolType.
 */
export const ToolTypeSchema: GenEnum<ToolType, ToolTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 47);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AIPhotoStyleModel
 */
export enum AIPhotoStyleModel {
  /**
   * @generated from enum value: AI_PHOTO_STYLE_MODEL_UNSPECIFIED = 0;
   */
  AI_PHOTO_STYLE_MODEL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AI_PHOTO_STYLE_MODEL_NANO_BANANA = 1;
   */
  AI_PHOTO_STYLE_MODEL_NANO_BANANA = 1,

  /**
   * @generated from enum value: AI_PHOTO_STYLE_MODEL_NANO_BANANA_PRO = 2;
   */
  AI_PHOTO_STYLE_MODEL_NANO_BANANA_PRO = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AIPhotoStyleModel
 */
export type AIPhotoStyleModelJson = "AI_PHOTO_STYLE_MODEL_UNSPECIFIED" | "AI_PHOTO_STYLE_MODEL_NANO_BANANA" | "AI_PHOTO_STYLE_MODEL_NANO_BANANA_PRO";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AIPhotoStyleModel.
 */
export const AIPhotoStyleModelSchema: GenEnum<AIPhotoStyleModel, AIPhotoStyleModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 48);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ToonFamilyStyle
 */
export enum ToonFamilyStyle {
  /**
   * @generated from enum value: TOON_FAMILY_STYLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_DONALD_DUCK = 1;
   */
  DONALD_DUCK = 1,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_SUPERMAN = 2;
   */
  SUPERMAN = 2,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_PIXAR = 3;
   */
  PIXAR = 3,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_SCOOBY_DOO = 4;
   */
  SCOOBY_DOO = 4,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_SPONGEBOB = 5;
   */
  SPONGEBOB = 5,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_CYBERPUNK = 6;
   */
  CYBERPUNK = 6,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_SCI_FI = 7;
   */
  SCI_FI = 7,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_WATERCOLOR = 8;
   */
  WATERCOLOR = 8,

  /**
   * @generated from enum value: TOON_FAMILY_STYLE_PAPER_CUTOUT = 9;
   */
  PAPER_CUTOUT = 9,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ToonFamilyStyle
 */
export type ToonFamilyStyleJson = "TOON_FAMILY_STYLE_UNSPECIFIED" | "TOON_FAMILY_STYLE_DONALD_DUCK" | "TOON_FAMILY_STYLE_SUPERMAN" | "TOON_FAMILY_STYLE_PIXAR" | "TOON_FAMILY_STYLE_SCOOBY_DOO" | "TOON_FAMILY_STYLE_SPONGEBOB" | "TOON_FAMILY_STYLE_CYBERPUNK" | "TOON_FAMILY_STYLE_SCI_FI" | "TOON_FAMILY_STYLE_WATERCOLOR" | "TOON_FAMILY_STYLE_PAPER_CUTOUT";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ToonFamilyStyle.
 */
export const ToonFamilyStyleSchema: GenEnum<ToonFamilyStyle, ToonFamilyStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 49);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ActionType
 */
export enum ActionType {
  /**
   * @generated from enum value: ACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTION_TYPE_CONVERT_GLB_TO_STL = 1;
   */
  CONVERT_GLB_TO_STL = 1,

  /**
   * @generated from enum value: ACTION_TYPE_GENERATE_LYRICS = 2;
   */
  GENERATE_LYRICS = 2,

  /**
   * @generated from enum value: ACTION_TYPE_UPSCALE = 3;
   */
  UPSCALE = 3,

  /**
   * @generated from enum value: ACTION_TYPE_REMOVE_BACKGROUND = 4;
   */
  REMOVE_BACKGROUND = 4,

  /**
   * @generated from enum value: ACTION_TYPE_VECTORIZE = 5;
   */
  VECTORIZE = 5,

  /**
   * @generated from enum value: ACTION_TYPE_FORK_SESSION = 6;
   */
  FORK_SESSION = 6,

  /**
   * @generated from enum value: ACTION_TYPE_SET_ITERATION_AS_LAST = 7;
   */
  SET_ITERATION_AS_LAST = 7,

  /**
   * @generated from enum value: ACTION_TYPE_REMOVE_VIDEO_BACKGROUND = 8;
   */
  REMOVE_VIDEO_BACKGROUND = 8,

  /**
   * @generated from enum value: ACTION_TYPE_RUN_BRAIN_ANALYSIS_VIDEO = 9;
   */
  RUN_BRAIN_ANALYSIS_VIDEO = 9,

  /**
   * Make a client-supplied image the session's latest image, so the user can
   * keep iterating on it. Carries ImportImagePayload.
   *
   * @generated from enum value: ACTION_TYPE_IMPORT_IMAGE = 10;
   */
  IMPORT_IMAGE = 10,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.ActionType
 */
export type ActionTypeJson = "ACTION_TYPE_UNSPECIFIED" | "ACTION_TYPE_CONVERT_GLB_TO_STL" | "ACTION_TYPE_GENERATE_LYRICS" | "ACTION_TYPE_UPSCALE" | "ACTION_TYPE_REMOVE_BACKGROUND" | "ACTION_TYPE_VECTORIZE" | "ACTION_TYPE_FORK_SESSION" | "ACTION_TYPE_SET_ITERATION_AS_LAST" | "ACTION_TYPE_REMOVE_VIDEO_BACKGROUND" | "ACTION_TYPE_RUN_BRAIN_ANALYSIS_VIDEO" | "ACTION_TYPE_IMPORT_IMAGE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.ActionType.
 */
export const ActionTypeSchema: GenEnum<ActionType, ActionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 50);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MeshModel
 */
export enum MeshModel {
  /**
   * @generated from enum value: MESH_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESH_MODEL_TRELLIS = 1;
   */
  TRELLIS = 1,

  /**
   * @generated from enum value: MESH_MODEL_MESHY = 2;
   */
  MESHY = 2,

  /**
   * @generated from enum value: MESH_MODEL_REPLICATE = 3;
   */
  REPLICATE = 3,

  /**
   * @generated from enum value: MESH_MODEL_HYPER_3D = 4;
   */
  HYPER_3D = 4,

  /**
   * @generated from enum value: MESH_MODEL_HITEM_3D = 5;
   */
  HITEM_3D = 5,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.MeshModel
 */
export type MeshModelJson = "MESH_MODEL_UNSPECIFIED" | "MESH_MODEL_TRELLIS" | "MESH_MODEL_MESHY" | "MESH_MODEL_REPLICATE" | "MESH_MODEL_HYPER_3D" | "MESH_MODEL_HITEM_3D";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.MeshModel.
 */
export const MeshModelSchema: GenEnum<MeshModel, MeshModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 51);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle
 */
export enum LogoGeneratorStyle {
  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_TECH = 1;
   */
  TECH = 1,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_FLASHY = 2;
   */
  FLASHY = 2,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_MODERN = 3;
   */
  MODERN = 3,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_PLAYFUL = 4;
   */
  PLAYFUL = 4,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_ABSTRACT = 5;
   */
  ABSTRACT = 5,

  /**
   * @generated from enum value: LOGO_GENERATOR_STYLE_MINIMAL = 6;
   */
  MINIMAL = 6,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle
 */
export type LogoGeneratorStyleJson = "LOGO_GENERATOR_STYLE_UNSPECIFIED" | "LOGO_GENERATOR_STYLE_TECH" | "LOGO_GENERATOR_STYLE_FLASHY" | "LOGO_GENERATOR_STYLE_MODERN" | "LOGO_GENERATOR_STYLE_PLAYFUL" | "LOGO_GENERATOR_STYLE_ABSTRACT" | "LOGO_GENERATOR_STYLE_MINIMAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.LogoGeneratorStyle.
 */
export const LogoGeneratorStyleSchema: GenEnum<LogoGeneratorStyle, LogoGeneratorStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 52);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerModel
 */
export enum VideoUpscalerModel {
  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_PROTEUS = 1;
   */
  PROTEUS = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_ARTEMIS = 2;
   */
  ARTEMIS = 2,

  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_GAIA = 3;
   */
  GAIA = 3,

  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_RHEA = 4;
   */
  RHEA = 4,

  /**
   * BytePlus MediaKit video enhancement, executed via services-genai
   * DirectGenerate (genai models byteplus_video_enhance_v1 /
   * byteplus_video_enhance_pro_v1). Professional runs ~10x the standard rate
   * with much longer processing; configure via VideoUpscalerByteplusEnhanceConfig.
   *
   * @generated from enum value: VIDEO_UPSCALER_MODEL_BYTEPLUS_VIDEO_ENHANCE = 5;
   */
  BYTEPLUS_VIDEO_ENHANCE = 5,

  /**
   * @generated from enum value: VIDEO_UPSCALER_MODEL_BYTEPLUS_VIDEO_ENHANCE_PRO = 6;
   */
  BYTEPLUS_VIDEO_ENHANCE_PRO = 6,

  /**
   * Black Forest Labs FLUX Video Upscale, executed via services-genai
   * DirectGenerate (genai model flux_3_video_upscale). Sources of at most
   * 20 seconds and 2560x1440; configure via VideoUpscalerFluxVideoUpscaleConfig.
   *
   * @generated from enum value: VIDEO_UPSCALER_MODEL_FLUX_VIDEO_UPSCALE = 7;
   */
  FLUX_VIDEO_UPSCALE = 7,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerModel
 */
export type VideoUpscalerModelJson = "VIDEO_UPSCALER_MODEL_UNSPECIFIED" | "VIDEO_UPSCALER_MODEL_PROTEUS" | "VIDEO_UPSCALER_MODEL_ARTEMIS" | "VIDEO_UPSCALER_MODEL_GAIA" | "VIDEO_UPSCALER_MODEL_RHEA" | "VIDEO_UPSCALER_MODEL_BYTEPLUS_VIDEO_ENHANCE" | "VIDEO_UPSCALER_MODEL_BYTEPLUS_VIDEO_ENHANCE_PRO" | "VIDEO_UPSCALER_MODEL_FLUX_VIDEO_UPSCALE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerModel.
 */
export const VideoUpscalerModelSchema: GenEnum<VideoUpscalerModel, VideoUpscalerModelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 53);

/**
 * VideoUpscalerFluxVideoUpscaleCreativity selects how FLUX Video Upscale treats
 * the source: precise stays faithful to it, creative invents finer detail (and
 * can drift faces or product shapes). Creative is billed at a higher rate.
 * Unspecified resolves to the genai default (creative).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleCreativity
 */
export enum VideoUpscalerFluxVideoUpscaleCreativity {
  /**
   * @generated from enum value: VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_PRECISE = 1;
   */
  PRECISE = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_CREATIVE = 2;
   */
  CREATIVE = 2,
}

/**
 * VideoUpscalerFluxVideoUpscaleCreativity selects how FLUX Video Upscale treats
 * the source: precise stays faithful to it, creative invents finer detail (and
 * can drift faces or product shapes). Creative is billed at a higher rate.
 * Unspecified resolves to the genai default (creative).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleCreativity
 */
export type VideoUpscalerFluxVideoUpscaleCreativityJson = "VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_UNSPECIFIED" | "VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_PRECISE" | "VIDEO_UPSCALER_FLUX_VIDEO_UPSCALE_CREATIVITY_CREATIVE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleCreativity.
 */
export const VideoUpscalerFluxVideoUpscaleCreativitySchema: GenEnum<VideoUpscalerFluxVideoUpscaleCreativity, VideoUpscalerFluxVideoUpscaleCreativityJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 54);

/**
 * VideoUpscalerByteplusEnhanceScene selects a preset enhancement template. Standard
 * model only (the professional tier ignores it). Unspecified resolves to the
 * genai default (aigc — our sources are AI-generated).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceScene
 */
export enum VideoUpscalerByteplusEnhanceScene {
  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_COMMON = 1;
   */
  COMMON = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_UGC = 2;
   */
  UGC = 2,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_SHORT_SERIES = 3;
   */
  SHORT_SERIES = 3,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_AIGC = 4;
   */
  AIGC = 4,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_OLD_FILM = 5;
   */
  OLD_FILM = 5,
}

/**
 * VideoUpscalerByteplusEnhanceScene selects a preset enhancement template. Standard
 * model only (the professional tier ignores it). Unspecified resolves to the
 * genai default (aigc — our sources are AI-generated).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceScene
 */
export type VideoUpscalerByteplusEnhanceSceneJson = "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_UNSPECIFIED" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_COMMON" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_UGC" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_SHORT_SERIES" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_AIGC" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_SCENE_OLD_FILM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceScene.
 */
export const VideoUpscalerByteplusEnhanceSceneSchema: GenEnum<VideoUpscalerByteplusEnhanceScene, VideoUpscalerByteplusEnhanceSceneJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 55);

/**
 * VideoUpscalerByteplusEnhanceStyle controls sharpening strength. Unspecified means
 * the vendor default (hd).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceStyle
 */
export enum VideoUpscalerByteplusEnhanceStyle {
  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_HD = 1;
   */
  HD = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_NATURAL = 2;
   */
  NATURAL = 2,
}

/**
 * VideoUpscalerByteplusEnhanceStyle controls sharpening strength. Unspecified means
 * the vendor default (hd).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceStyle
 */
export type VideoUpscalerByteplusEnhanceStyleJson = "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_UNSPECIFIED" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_HD" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_STYLE_NATURAL";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceStyle.
 */
export const VideoUpscalerByteplusEnhanceStyleSchema: GenEnum<VideoUpscalerByteplusEnhanceStyle, VideoUpscalerByteplusEnhanceStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 56);

/**
 * VideoUpscalerByteplusEnhanceResolution is the target output resolution level,
 * bucketed by short side. The enum carries the vendor's full ladder; the
 * service validates the per-model offered subset (720p-4k standard, 720p-2k
 * professional today), so widening the offer later is a validation-only
 * change. Unspecified resolves to the genai default (1080p).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceResolution
 */
export enum VideoUpscalerByteplusEnhanceResolution {
  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_UNSPECIFIED = 0;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_240P = 1;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_240P = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_360P = 2;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_360P = 2,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_480P = 3;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_480P = 3,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_540P = 4;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_540P = 4,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_720P = 5;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_720P = 5,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_1080P = 6;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_1080P = 6,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_2K = 7;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_2K = 7,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_4K = 8;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_4K = 8,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_8K = 9;
   */
  VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_8K = 9,
}

/**
 * VideoUpscalerByteplusEnhanceResolution is the target output resolution level,
 * bucketed by short side. The enum carries the vendor's full ladder; the
 * service validates the per-model offered subset (720p-4k standard, 720p-2k
 * professional today), so widening the offer later is a validation-only
 * change. Unspecified resolves to the genai default (1080p).
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceResolution
 */
export type VideoUpscalerByteplusEnhanceResolutionJson = "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_UNSPECIFIED" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_240P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_360P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_480P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_540P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_720P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_1080P" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_2K" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_4K" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_RESOLUTION_8K";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceResolution.
 */
export const VideoUpscalerByteplusEnhanceResolutionSchema: GenEnum<VideoUpscalerByteplusEnhanceResolution, VideoUpscalerByteplusEnhanceResolutionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 57);

/**
 * VideoUpscalerByteplusEnhanceBitrateLevel is the target average bitrate band.
 * Unspecified means the vendor default (medium). Mutually exclusive with an
 * explicit bitrate — the service rejects both set.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceBitrateLevel
 */
export enum VideoUpscalerByteplusEnhanceBitrateLevel {
  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_HIGH = 3;
   */
  HIGH = 3,
}

/**
 * VideoUpscalerByteplusEnhanceBitrateLevel is the target average bitrate band.
 * Unspecified means the vendor default (medium). Mutually exclusive with an
 * explicit bitrate — the service rejects both set.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceBitrateLevel
 */
export type VideoUpscalerByteplusEnhanceBitrateLevelJson = "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_UNSPECIFIED" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_LOW" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_MEDIUM" | "VIDEO_UPSCALER_BYTEPLUS_ENHANCE_BITRATE_LEVEL_HIGH";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceBitrateLevel.
 */
export const VideoUpscalerByteplusEnhanceBitrateLevelSchema: GenEnum<VideoUpscalerByteplusEnhanceBitrateLevel, VideoUpscalerByteplusEnhanceBitrateLevelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 58);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditResolution
 */
export enum HappyhorseVideoEditResolution {
  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_RESOLUTION_UNSPECIFIED = 0;
   */
  HAPPYHORSE_VIDEO_EDIT_RESOLUTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_RESOLUTION_720P = 1;
   */
  HAPPYHORSE_VIDEO_EDIT_RESOLUTION_720P = 1,

  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_RESOLUTION_1080P = 2;
   */
  HAPPYHORSE_VIDEO_EDIT_RESOLUTION_1080P = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditResolution
 */
export type HappyhorseVideoEditResolutionJson = "HAPPYHORSE_VIDEO_EDIT_RESOLUTION_UNSPECIFIED" | "HAPPYHORSE_VIDEO_EDIT_RESOLUTION_720P" | "HAPPYHORSE_VIDEO_EDIT_RESOLUTION_1080P";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditResolution.
 */
export const HappyhorseVideoEditResolutionSchema: GenEnum<HappyhorseVideoEditResolution, HappyhorseVideoEditResolutionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 59);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditAudioSetting
 */
export enum HappyhorseVideoEditAudioSetting {
  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_AUTO = 1;
   */
  AUTO = 1,

  /**
   * @generated from enum value: HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_ORIGIN = 2;
   */
  ORIGIN = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditAudioSetting
 */
export type HappyhorseVideoEditAudioSettingJson = "HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_UNSPECIFIED" | "HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_AUTO" | "HAPPYHORSE_VIDEO_EDIT_AUDIO_SETTING_ORIGIN";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.HappyhorseVideoEditAudioSetting.
 */
export const HappyhorseVideoEditAudioSettingSchema: GenEnum<HappyhorseVideoEditAudioSetting, HappyhorseVideoEditAudioSettingJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 60);

/**
 * VideoEditorResolution is the shared output-resolution vocabulary for the
 * Video Editor app. New editor models reuse this rather than declaring their
 * own model-specific resolution enum, so clients render one control for every
 * model. Deliberately separate from PromptToVideoGeneratorContentResolution:
 * the two apps offer different tier sets and evolve independently.
 *
 * The values are the UNION across editor models. Which subset a given model
 * accepts is published per-model in the ListModels catalog
 * (catalog.capabilities.input_options.resolution.allowed_values) — drive the
 * picker from that, not from this enum.
 *
 * HappyhorseVideoEditConfig keeps HappyhorseVideoEditResolution for wire
 * compatibility; migrating it onto this enum is a separate additive change.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoEditorResolution
 */
export enum VideoEditorResolution {
  /**
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_UNSPECIFIED = 0;
   */
  VIDEO_EDITOR_RESOLUTION_UNSPECIFIED = 0,

  /**
   * happyhorse
   *
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_720P = 1;
   */
  VIDEO_EDITOR_RESOLUTION_720P = 1,

  /**
   * happyhorse
   *
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_1080P = 2;
   */
  VIDEO_EDITOR_RESOLUTION_1080P = 2,

  /**
   * minimax h3
   *
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_768P = 3;
   */
  VIDEO_EDITOR_RESOLUTION_768P = 3,

  /**
   * minimax h3
   *
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_2K = 4;
   */
  VIDEO_EDITOR_RESOLUTION_2K = 4,

  /**
   * wan 3.0
   *
   * @generated from enum value: VIDEO_EDITOR_RESOLUTION_480P = 5;
   */
  VIDEO_EDITOR_RESOLUTION_480P = 5,
}

/**
 * VideoEditorResolution is the shared output-resolution vocabulary for the
 * Video Editor app. New editor models reuse this rather than declaring their
 * own model-specific resolution enum, so clients render one control for every
 * model. Deliberately separate from PromptToVideoGeneratorContentResolution:
 * the two apps offer different tier sets and evolve independently.
 *
 * The values are the UNION across editor models. Which subset a given model
 * accepts is published per-model in the ListModels catalog
 * (catalog.capabilities.input_options.resolution.allowed_values) — drive the
 * picker from that, not from this enum.
 *
 * HappyhorseVideoEditConfig keeps HappyhorseVideoEditResolution for wire
 * compatibility; migrating it onto this enum is a separate additive change.
 *
 * @generated from enum creativefabrica.studiomediamatrix.v1.VideoEditorResolution
 */
export type VideoEditorResolutionJson = "VIDEO_EDITOR_RESOLUTION_UNSPECIFIED" | "VIDEO_EDITOR_RESOLUTION_720P" | "VIDEO_EDITOR_RESOLUTION_1080P" | "VIDEO_EDITOR_RESOLUTION_768P" | "VIDEO_EDITOR_RESOLUTION_2K" | "VIDEO_EDITOR_RESOLUTION_480P";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.VideoEditorResolution.
 */
export const VideoEditorResolutionSchema: GenEnum<VideoEditorResolution, VideoEditorResolutionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 61);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.CameraAnglePreset
 */
export enum CameraAnglePreset {
  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_FRONT = 1;
   */
  FRONT = 1,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_SIDE = 2;
   */
  SIDE = 2,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_TOP = 3;
   */
  TOP = 3,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_BACK = 4;
   */
  BACK = 4,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_BOTTOM = 5;
   */
  BOTTOM = 5,

  /**
   * @generated from enum value: CAMERA_ANGLE_PRESET_THREE_QUARTER = 6;
   */
  THREE_QUARTER = 6,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.CameraAnglePreset
 */
export type CameraAnglePresetJson = "CAMERA_ANGLE_PRESET_UNSPECIFIED" | "CAMERA_ANGLE_PRESET_FRONT" | "CAMERA_ANGLE_PRESET_SIDE" | "CAMERA_ANGLE_PRESET_TOP" | "CAMERA_ANGLE_PRESET_BACK" | "CAMERA_ANGLE_PRESET_BOTTOM" | "CAMERA_ANGLE_PRESET_THREE_QUARTER";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.CameraAnglePreset.
 */
export const CameraAnglePresetSchema: GenEnum<CameraAnglePreset, CameraAnglePresetJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 62);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.NoticeStatus
 */
export enum NoticeStatus {
  /**
   * @generated from enum value: NOTICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTICE_STATUS_FAILED = 1;
   */
  FAILED = 1,

  /**
   * @generated from enum value: NOTICE_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: NOTICE_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.NoticeStatus
 */
export type NoticeStatusJson = "NOTICE_STATUS_UNSPECIFIED" | "NOTICE_STATUS_FAILED" | "NOTICE_STATUS_IN_PROGRESS" | "NOTICE_STATUS_COMPLETED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.NoticeStatus.
 */
export const NoticeStatusSchema: GenEnum<NoticeStatus, NoticeStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 63);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.NoticeActionType
 */
export enum NoticeActionType {
  /**
   * @generated from enum value: NOTICE_ACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTICE_ACTION_TYPE_VIEWED = 1;
   */
  VIEWED = 1,

  /**
   * @generated from enum value: NOTICE_ACTION_TYPE_CLOSED = 2;
   */
  CLOSED = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.NoticeActionType
 */
export type NoticeActionTypeJson = "NOTICE_ACTION_TYPE_UNSPECIFIED" | "NOTICE_ACTION_TYPE_VIEWED" | "NOTICE_ACTION_TYPE_CLOSED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.NoticeActionType.
 */
export const NoticeActionTypeSchema: GenEnum<NoticeActionType, NoticeActionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 64);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle
 */
export enum AISVGGeneratorStyle {
  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_UNSPECIFIED = 0;
   */
  AISVG_GENERATOR_STYLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_CARTOON = 1;
   */
  AISVG_GENERATOR_STYLE_CARTOON = 1,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_MINIMAL = 2;
   */
  AISVG_GENERATOR_STYLE_MINIMAL = 2,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_GEOMETRIC = 3;
   */
  AISVG_GENERATOR_STYLE_GEOMETRIC = 3,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_LINE_ART = 4;
   */
  AISVG_GENERATOR_STYLE_LINE_ART = 4,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_OUTLINE = 5;
   */
  AISVG_GENERATOR_STYLE_OUTLINE = 5,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_FILLED = 6;
   */
  AISVG_GENERATOR_STYLE_FILLED = 6,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_LOGO = 7;
   */
  AISVG_GENERATOR_STYLE_LOGO = 7,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_ABSTRACT = 8;
   */
  AISVG_GENERATOR_STYLE_ABSTRACT = 8,

  /**
   * @generated from enum value: AISVG_GENERATOR_STYLE_ISOMETRIC = 9;
   */
  AISVG_GENERATOR_STYLE_ISOMETRIC = 9,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle
 */
export type AISVGGeneratorStyleJson = "AISVG_GENERATOR_STYLE_UNSPECIFIED" | "AISVG_GENERATOR_STYLE_CARTOON" | "AISVG_GENERATOR_STYLE_MINIMAL" | "AISVG_GENERATOR_STYLE_GEOMETRIC" | "AISVG_GENERATOR_STYLE_LINE_ART" | "AISVG_GENERATOR_STYLE_OUTLINE" | "AISVG_GENERATOR_STYLE_FILLED" | "AISVG_GENERATOR_STYLE_LOGO" | "AISVG_GENERATOR_STYLE_ABSTRACT" | "AISVG_GENERATOR_STYLE_ISOMETRIC";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStyle.
 */
export const AISVGGeneratorStyleSchema: GenEnum<AISVGGeneratorStyle, AISVGGeneratorStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 65);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity
 */
export enum AISVGGeneratorComplexity {
  /**
   * @generated from enum value: AISVG_GENERATOR_COMPLEXITY_UNSPECIFIED = 0;
   */
  AISVG_GENERATOR_COMPLEXITY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AISVG_GENERATOR_COMPLEXITY_DETAILED = 1;
   */
  AISVG_GENERATOR_COMPLEXITY_DETAILED = 1,

  /**
   * @generated from enum value: AISVG_GENERATOR_COMPLEXITY_VERY_SIMPLE = 2;
   */
  AISVG_GENERATOR_COMPLEXITY_VERY_SIMPLE = 2,

  /**
   * @generated from enum value: AISVG_GENERATOR_COMPLEXITY_SIMPLE = 3;
   */
  AISVG_GENERATOR_COMPLEXITY_SIMPLE = 3,

  /**
   * @generated from enum value: AISVG_GENERATOR_COMPLEXITY_MEDIUM = 4;
   */
  AISVG_GENERATOR_COMPLEXITY_MEDIUM = 4,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity
 */
export type AISVGGeneratorComplexityJson = "AISVG_GENERATOR_COMPLEXITY_UNSPECIFIED" | "AISVG_GENERATOR_COMPLEXITY_DETAILED" | "AISVG_GENERATOR_COMPLEXITY_VERY_SIMPLE" | "AISVG_GENERATOR_COMPLEXITY_SIMPLE" | "AISVG_GENERATOR_COMPLEXITY_MEDIUM";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorComplexity.
 */
export const AISVGGeneratorComplexitySchema: GenEnum<AISVGGeneratorComplexity, AISVGGeneratorComplexityJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 66);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth
 */
export enum AISVGGeneratorStrokeWidth {
  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_WIDTH_UNSPECIFIED = 0;
   */
  AISVG_GENERATOR_STROKE_WIDTH_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_WIDTH_THIN = 1;
   */
  AISVG_GENERATOR_STROKE_WIDTH_THIN = 1,

  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_WIDTH_MEDIUM = 2;
   */
  AISVG_GENERATOR_STROKE_WIDTH_MEDIUM = 2,

  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_WIDTH_THICK = 3;
   */
  AISVG_GENERATOR_STROKE_WIDTH_THICK = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth
 */
export type AISVGGeneratorStrokeWidthJson = "AISVG_GENERATOR_STROKE_WIDTH_UNSPECIFIED" | "AISVG_GENERATOR_STROKE_WIDTH_THIN" | "AISVG_GENERATOR_STROKE_WIDTH_MEDIUM" | "AISVG_GENERATOR_STROKE_WIDTH_THICK";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeWidth.
 */
export const AISVGGeneratorStrokeWidthSchema: GenEnum<AISVGGeneratorStrokeWidth, AISVGGeneratorStrokeWidthJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 67);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle
 */
export enum AISVGGeneratorStrokeStyle {
  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_STYLE_UNSPECIFIED = 0;
   */
  AISVG_GENERATOR_STROKE_STYLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_STYLE_SHARP = 1;
   */
  AISVG_GENERATOR_STROKE_STYLE_SHARP = 1,

  /**
   * @generated from enum value: AISVG_GENERATOR_STROKE_STYLE_ROUNDED = 2;
   */
  AISVG_GENERATOR_STROKE_STYLE_ROUNDED = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle
 */
export type AISVGGeneratorStrokeStyleJson = "AISVG_GENERATOR_STROKE_STYLE_UNSPECIFIED" | "AISVG_GENERATOR_STROKE_STYLE_SHARP" | "AISVG_GENERATOR_STROKE_STYLE_ROUNDED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorStrokeStyle.
 */
export const AISVGGeneratorStrokeStyleSchema: GenEnum<AISVGGeneratorStrokeStyle, AISVGGeneratorStrokeStyleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 68);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor
 */
export enum AISVGGeneratorColor {
  /**
   * @generated from enum value: AISVG_GENERATOR_COLOR_UNSPECIFIED = 0;
   */
  AISVG_GENERATOR_COLOR_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AISVG_GENERATOR_COLOR_FULL_COLOR = 1;
   */
  AISVG_GENERATOR_COLOR_FULL_COLOR = 1,

  /**
   * @generated from enum value: AISVG_GENERATOR_COLOR_GRAYSCALE = 2;
   */
  AISVG_GENERATOR_COLOR_GRAYSCALE = 2,

  /**
   * @generated from enum value: AISVG_GENERATOR_COLOR_BLACK_AND_WHITE = 3;
   */
  AISVG_GENERATOR_COLOR_BLACK_AND_WHITE = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor
 */
export type AISVGGeneratorColorJson = "AISVG_GENERATOR_COLOR_UNSPECIFIED" | "AISVG_GENERATOR_COLOR_FULL_COLOR" | "AISVG_GENERATOR_COLOR_GRAYSCALE" | "AISVG_GENERATOR_COLOR_BLACK_AND_WHITE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.AISVGGeneratorColor.
 */
export const AISVGGeneratorColorSchema: GenEnum<AISVGGeneratorColor, AISVGGeneratorColorJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 69);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.InputMediaType
 */
export enum InputMediaType {
  /**
   * @generated from enum value: INPUT_MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INPUT_MEDIA_TYPE_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * @generated from enum value: INPUT_MEDIA_TYPE_AUDIO = 2;
   */
  AUDIO = 2,

  /**
   * @generated from enum value: INPUT_MEDIA_TYPE_VIDEO = 3;
   */
  VIDEO = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.InputMediaType
 */
export type InputMediaTypeJson = "INPUT_MEDIA_TYPE_UNSPECIFIED" | "INPUT_MEDIA_TYPE_IMAGE" | "INPUT_MEDIA_TYPE_AUDIO" | "INPUT_MEDIA_TYPE_VIDEO";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.InputMediaType.
 */
export const InputMediaTypeSchema: GenEnum<InputMediaType, InputMediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 70);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.InputMediaStatus
 */
export enum InputMediaStatus {
  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_PENDING_UPLOAD = 1;
   */
  PENDING_UPLOAD = 1,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_UPLOADED = 2;
   */
  UPLOADED = 2,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.InputMediaStatus
 */
export type InputMediaStatusJson = "INPUT_MEDIA_STATUS_UNSPECIFIED" | "INPUT_MEDIA_STATUS_PENDING_UPLOAD" | "INPUT_MEDIA_STATUS_UPLOADED" | "INPUT_MEDIA_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.InputMediaStatus.
 */
export const InputMediaStatusSchema: GenEnum<InputMediaStatus, InputMediaStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 71);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaStatus
 */
export enum BrandedMediaStatus {
  /**
   * @generated from enum value: BRANDED_MEDIA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BRANDED_MEDIA_STATUS_PROCESSING = 1;
   */
  PROCESSING = 1,

  /**
   * @generated from enum value: BRANDED_MEDIA_STATUS_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: BRANDED_MEDIA_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaStatus
 */
export type BrandedMediaStatusJson = "BRANDED_MEDIA_STATUS_UNSPECIFIED" | "BRANDED_MEDIA_STATUS_PROCESSING" | "BRANDED_MEDIA_STATUS_SUCCESS" | "BRANDED_MEDIA_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.BrandedMediaStatus.
 */
export const BrandedMediaStatusSchema: GenEnum<BrandedMediaStatus, BrandedMediaStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 72);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaType
 */
export enum BrandedMediaType {
  /**
   * @generated from enum value: BRANDED_MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BRANDED_MEDIA_TYPE_VIDEO = 1;
   */
  VIDEO = 1,

  /**
   * @generated from enum value: BRANDED_MEDIA_TYPE_AUDIO = 2;
   */
  AUDIO = 2,

  /**
   * @generated from enum value: BRANDED_MEDIA_TYPE_IMAGE = 3;
   */
  IMAGE = 3,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaType
 */
export type BrandedMediaTypeJson = "BRANDED_MEDIA_TYPE_UNSPECIFIED" | "BRANDED_MEDIA_TYPE_VIDEO" | "BRANDED_MEDIA_TYPE_AUDIO" | "BRANDED_MEDIA_TYPE_IMAGE";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.BrandedMediaType.
 */
export const BrandedMediaTypeSchema: GenEnum<BrandedMediaType, BrandedMediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 73);

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform
 */
export enum BrandedMediaPlatform {
  /**
   * @generated from enum value: BRANDED_MEDIA_PLATFORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BRANDED_MEDIA_PLATFORM_STUDIO = 1;
   */
  STUDIO = 1,

  /**
   * @generated from enum value: BRANDED_MEDIA_PLATFORM_FREEMODE_AI = 2;
   */
  FREEMODE_AI = 2,
}

/**
 * @generated from enum creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform
 */
export type BrandedMediaPlatformJson = "BRANDED_MEDIA_PLATFORM_UNSPECIFIED" | "BRANDED_MEDIA_PLATFORM_STUDIO" | "BRANDED_MEDIA_PLATFORM_FREEMODE_AI";

/**
 * Describes the enum creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform.
 */
export const BrandedMediaPlatformSchema: GenEnum<BrandedMediaPlatform, BrandedMediaPlatformJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studiomediamatrix_v1_types, 74);

